/*
 * FOR SALE — « Proposer une annonce » (décisions 005, 007, 015), parcours en étapes (spec 03, direction visuelle 04).
 * Module chargé seulement si le réglage service_url est valide. Fonctions pures et tables exportées pour les tests Node.
 *
 * Parcours : choix du jeu → accueil du jeu → étapes du jeu (STEP_PLAN, groupées en 3 phases) → « Le titre qui donne
 * envie » → « Vérifier » → « Conditions de vente » (VEND-11 : case et envoi) → succès. Un seul <form novalidate> :
 * chaque étape est un fieldset[data-fs-step], un seul visible ; readInput → validateSubmission → envoi restent ceux du
 * modèle (sections et ordre inchangés : les étapes ne sont qu'une présentation). Continuer valide l'étape (erreurs
 * filtrées sur ses clés) ; Précédent ne valide rien. Chaque changement d'étape écrit le brouillon, pousse #sell
 * dans l'historique (le bouton retour ramène à l'étape précédente), fait défiler une seule fois et met le focus sur
 * le titre d'étape (preventScroll).
 *
 * Connexion avant de commencer (Charles, 9 octobre 2026) : le choix du jeu et l'accueil se voient sans session, mais
 * « Commencer » et « Reprendre » demandent d'abord la connexion Discord, dans une fenêtre séparée (FSAccount.loginPopup),
 * puis ouvrent l'étape voulue. Un non-membre l'apprend donc avant de remplir quoi que ce soit (ajouté au serveur avec
 * DISCORD_JOIN=1). Fenêtre bloquée → redirection ; au retour, l'accueil propose de commencer. Une session expirée en
 * cours de route se renouvelle à « Envoyer l'annonce », saisie gardée.
 *
 * Captures (décision 015, contrat 05) : un emplacement par écran du jeu (captures.slots du modèle ; WarUniverse n'en a
 * plus depuis VEND-05 : le hangar se déclare en cochant ses vaisseaux). Image décodée et
 * ré-encodée dans le navigateur (fs-propose-media.js, chargé à la demande : métadonnées retirées, nom neutre
 * <jeu>-<slot>, 2000 px au plus, zones masquées aplaties), envoyée dès qu'une session existe (POST /submissions/media),
 * puis jointe à l'envoi (media: [{ slot, id }]). Jamais d'image stockée : le brouillon ne garde que l'identifiant d'une
 * capture envoyée (relu par POST /submissions/media/status). Les emplacements « équipe seulement » ne passent jamais par
 * le site : ils sont présentés « à envoyer dans votre ticket Selling sur Discord ». Service des captures éteint : les
 * emplacements obligatoires passent « à envoyer dans le ticket », sans bloquer.
 * Après l'envoi : avec le ticket vendeur (SELLER_TICKETS=1, /me → features.sellerTickets, MOD-02), le bot ouvre un ticket
 * privé au nom du vendeur ; le succès donne son lien, ou, pas encore ouvert, renvoie à « Mes annonces ». Sans lui, le
 * succès renvoie au suivi sur le site (« Mes annonces », /#my-listings) et dit la suite : la vente se propose sur le
 * site (P-21), jamais d'invitation à ouvrir un ticket MEE6 ni à passer par le salon #selling.
 * Lecture d'une capture (analyse, décision 007) : bouton « Remplir à partir de cette capture » seulement si l'analyse est
 * active ; une valeur déjà saisie n'est jamais écrasée (« Lu : … [Utiliser] ») et la relecture est confirmée.
 *
 * Jeu : aucun d'office. Repris de ?game=, de l'univers actif, d'un appel à l'action (data-fs-propose-open) ou du
 * brouillon. Le choix ne touche que ce bloc (data-fs-universe pour l'accent, pack du jeu lu sans être injecté), jamais
 * l'univers de la page. Défilement toujours explicite (behavior 'instant' ou 'smooth'), focus par preventScroll.
 * Connexion : nonce et intention dans l'onglet (fs-account.js), code à usage unique échangé par POST /auth/exchange.
 * Aucun jeton n'est jamais accepté depuis l'adresse.
 * Changer de jeu efface la saisie en cours, après confirmation s'il y en a une : un seul brouillon, celui du jeu courant.
 * Aucun aperçu pendant la saisie : la carte d'annonce n'apparaît qu'au récapitulatif de « Vérifier ».
 * Données (sessionStorage seulement) : « fs-propose-draft » (brouillon v4 du jeu courant : saisie exacte, étape, étapes vues et
 * passées, choix d'arrondi, identifiants des captures envoyées), effacé à l'envoi réussi, par « Recommencer à zéro » et
 * à la déconnexion ; « fs-session », « fs-auth-nonce », « fs-auth-return » (sans fs-account.js, ancienne page).
 * Lien #fs_import (retiré, sans producteur légitime) : effacé de l'adresse par le snippet SANS être lu.
 * Aucun achat. Prix souhaité (VEND-09, choix C9 du contrat prix-et-achat-direct) : seulement si le service l'annonce
 * (/me → features.prices, session connue), une étape « Votre prix » après « Le titre qui donne envie » demande le net
 * que le vendeur veut toucher, entier de 1 à 10 000 €, envoyé hors de values (expectedNet) ; ni commission, ni prix
 * estimé, ni calcul. Connu seulement après la connexion (en fin de parcours) : l'étape s'insère alors avant « Vérifier »
 * sans rien perdre. Sans l'annonce du service, parcours et textes d'aujourd'hui : aucun prix, il se fixe dans le
 * ticket Selling du vendeur sur Discord.
 * Champs : catalogue commun (fs-ui-field.css pour le rendu, fs-ui.js pour le câblage d'erreur et le compteur) ; restent
 * ici les messages, la grille et les contrôles propres au formulaire.
 */
import { el as h, setFieldError, syncCount } from './fs-ui.js';
import { viewer } from './fs-ui-dialog.js';
import { has, locale, number, path, pick, t } from './fs-i18n.js';
import { normalizeKey, STAT_ALIASES, STAT_NAMES, SECTION_NAMES, statKey, statName } from './fs-listing-names.js';
export { normalizeKey, STAT_ALIASES, STAT_NAMES, SECTION_NAMES, statKey, statName };

export const SESSION_KEY = 'fs-session';
export const TICKET_INTENT_KEY = 'fs-ticket-intent';
export const TICKET_INTENT_MS = 10 * 60 * 1000;
export const DRAFT_KEY = 'fs-propose-draft';
/** Brouillons des jeux fermés à la vente (VEND-01), à part du brouillon du jeu choisi : voir holdClosedDrafts. */
export const CLOSED_DRAFT_KEY = 'fs-propose-draft-closed';
export const NONCE_KEY = 'fs-auth-nonce';
export const RETURN_KEY = 'fs-auth-return';
export const IMPORT_KEY = 'fs-propose-import';
export const IMPORT_RETURN_KEY = 'fs-import-return';
/** Message neutre d'un lien #fs_import (jamais lu) ; même texte que fs-propose-import.js. */
export const UNSUPPORTED_LINK = t('propose.link.unsupported');
/** Note d'un jeu fermé à la vente (VEND-01 : modèle `selling: false`), demandé par ?game=, le brouillon ou un lien. */
export const closedGameNote = (name) => t('propose.closed.note', { name });
/** Plafond d'une session lue ici : 7 jours, comme fs-account.js (renouvellement fait par fs-account.js). */
export const SESSION_MAX_MS = 7 * 24 * 60 * 60 * 1000;
const TOKEN = /^[A-Za-z0-9._~+/=-]{8,4096}$/;
const MAX_BODY = 16 * 1024;

const CODE = /^[A-Za-z0-9._~-]{8,512}$/;
/**
 * Lit le retour de connexion dans le fragment : #fs_code=… (code à usage unique) ou #fs_error=…, n'importe où
 * dans le fragment. Un éventuel « fs_session » est seulement signalé (present) pour être effacé : jamais utilisé.
 */
export function parseFragment(hash) {
  const text = String(hash || '');
  const read = (name) => {
    const match = text.match(new RegExp(`(?:^|[#&])${name}=([^&#]*)`));
    if (!match) return null;
    try { return decodeURIComponent(match[1]); } catch { return null; }
  };
  const code = read('fs_code');
  return { present: /(?:^|[#&])fs_(?:code|error|session)=/.test(text), code: code && CODE.test(code) ? code : null, error: read('fs_error') };
}

/** Expiration d'une réponse /auth/exchange (secondes ou millisecondes), jamais au-delà de 7 jours (SESSION_MAX_MS). */
export function sessionExpiry(exp, token, now = Date.now()) {
  if (Number.isFinite(exp) && exp > 0) return Math.min(exp < 1e12 ? exp * 1000 : exp, now + SESSION_MAX_MS);
  return tokenExpiry(token, now);
}

function decodeSegment(part) {
  const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64 + '='.repeat((4 - (base64.length % 4)) % 4));
  return new TextDecoder().decode(Uint8Array.from(binary, (char) => char.charCodeAt(0)));
}

/** Expiration (ms) lue dans le jeton si un segment base64url JSON porte « exp », sinon 7 jours ; jamais au-delà de 7 jours. */
export function tokenExpiry(token, now = Date.now()) {
  const limit = now + SESSION_MAX_MS;
  for (const part of String(token || '').split('.')) {
    if (!part || part.length > 4096 || !/^[A-Za-z0-9_-]+={0,2}$/.test(part)) continue;
    try {
      const payload = JSON.parse(decodeSegment(part));
      if (payload && typeof payload === 'object' && Number.isFinite(payload.exp)) {
        return Math.min(payload.exp < 1e12 ? payload.exp * 1000 : payload.exp, limit);
      }
    } catch { /* segment non JSON (signature) */ }
  }
  return limit;
}

/** Intention de ticket encore fraîche (posée par fs-ticket.js avant la connexion) : le retour vise une fiche. */
export function freshTicketIntent(raw, now = Date.now()) {
  try {
    const intent = JSON.parse(raw || 'null');
    return Boolean(intent && typeof intent === 'object' && Number.isFinite(intent.at) && intent.at <= now + 60_000 && now - intent.at < TICKET_INTENT_MS);
  } catch { return false; }
}

export function authErrorMessage(code) {
  const text = String(code || '').toLowerCase();
  if (/restricted|timeout|pending/.test(text)) return t('propose.auth.restricted');
  if (/server_limit/.test(text)) return t('propose.auth.server_limit');
  if (/member|guild|membre|serveur/.test(text)) return t('propose.auth.not_member');
  if (/denied|refus|cancel|consent/.test(text)) return t('propose.auth.denied');
  if (/expir|state/.test(text)) return t('propose.auth.expired');
  return t('propose.common.discord_failed');
}

/** URL de base du service : https (ou http local de développement), sans identifiants, requête ni / final. */
export function serviceBase(raw) {
  try {
    const url = new URL(String(raw || '').trim());
    const local = url.protocol === 'http:' && ['127.0.0.1', 'localhost'].includes(url.hostname);
    if ((url.protocol !== 'https:' && !local) || url.username || url.password || url.search || url.hash) return '';
    return `${url.origin}${url.pathname.replace(/\/+$/, '')}`;
  } catch { return ''; }
}

/** Langues dont l'adresse a un préfixe (/fr, /es…) : liste fermée, comme le service (RETURN_LANGS). */
export const RETURN_LANGS = Object.freeze(['en', 'fr', 'es', 'tr', 'ru']);
/**
 * Préfixe de langue de la page, lu dans data-fs-root (« /fr/ » → « fr ») ; '' quand la racine est « / » (langue
 * principale, quelle qu'elle soit) ou hors de la liste fermée.
 */
export function rootLang(root) {
  const segment = String(root ?? '').replace(/^\/+|\/+$/g, '');
  return RETURN_LANGS.includes(segment) ? segment : '';
}
/** Départ de la connexion (repli sans fs-account.js) ; `lang` : préfixe de la page (rootLang), pour revenir dans sa langue. */
export const loginUrl = (base, game, nonce, lang = '') => `${base}/auth/discord/start?game=${encodeURIComponent(game)}${nonce ? `&nonce=${encodeURIComponent(nonce)}` : ''}${RETURN_LANGS.includes(lang) ? `&lang=${lang}` : ''}`;
const newNonce = () => (typeof crypto.randomUUID === 'function' ? crypto.randomUUID()
  : [...crypto.getRandomValues(new Uint8Array(16))].map((byte) => byte.toString(16).padStart(2, '0')).join(''));

/** Séparateurs de milliers tolérés en plus de ceux du validateur (espaces, points) : virgules et apostrophes. */
export const normalizeInteger = (raw) => {
  const text = String(raw).trim();
  return /^\d{1,3}(?:[,'’]\d{3})+$/.test(text) ? text.replace(/[,'’]/g, '') : text;
};

/**
 * Jeux qui ont, sur le serveur FOR SALE, un forum d'annonces (et un bouton dans le panneau vendeur du serveur) : SEULE liste
 * du thème (écran de succès : forum du jeu cité par showcaseText). Les autres (jeux futurs) : « sur le site » seulement.
 * Nova Horizon : forum nh-galaxy (8 octobre 2026) ; DarkOrbit : forum darkorbit (16 octobre 2026).
 */
export const DISCORD_ROOM_GAMES = Object.freeze(['waruniverse', 'redgalaxy', 'novahorizon', 'darkorbit']);
export const hasDiscordRooms = (game) => DISCORD_ROOM_GAMES.includes(game);
/** Dernière étape de l'écran de succès : forum du jeu seulement s'il existe ; captures seulement si le jeu en prend. */
export const showcaseText = (game, { captures = true } = {}) => t(`propose.showcase.${captures ? 'captures' : 'plain'}${hasDiscordRooms(game) ? '_forum' : ''}`);
/**
 * Captures à envoyer dans le ticket Selling (étape « Prix ») : obligatoires d'abord, puis « si vous les avez ». `required`
 * et `optional` sont des listes de libellés déjà en minuscule initiale.
 */
export function ticketShotsText(required, optional) {
  if (!required.length && !optional.length) return t('propose.tickets.shots_asked');
  if (!required.length) return t('propose.tickets.shots_optional', { optional: optional.join(', ') });
  if (!optional.length) return t('propose.tickets.shots_required', { required: required.join(', ') });
  return t('propose.tickets.shots_both', { required: required.join(', '), optional: optional.join(', ') });
}

/** Salon du ticket vendeur ouvert par le bot (ticket.url de POST /submissions : https://discord.com/channels/<serveur>/<salon>), sinon ''. */
export function sellingUrl(raw) {
  const text = String(raw ?? '').trim();
  return /^https:\/\/discord\.com\/channels\/\d{17,20}\/\d{17,20}\/?$/.test(text) ? text : '';
}
/** Invitation au serveur (discord.gg/<code> ou discord.com/invite/<code>), sinon '' (même règle que fs-ticket.js). */
export function inviteUrl(raw) {
  const text = String(raw ?? '').trim();
  return /^https:\/\/(?:discord\.gg|discord\.com\/invite)\/[A-Za-z0-9-]{2,64}\/?$/.test(text) ? text : '';
}

/** GET /features → join, gardé 5 min dans l'onglet : même clé et même forme que fs-ticket.js ({ at, join }). */
export const JOIN_KEY = 'fs-ticket-join';
export const JOIN_TTL_MS = 5 * 60 * 1000;
/** Cache d'onglet { at, join } : `join` (booléen) s'il a moins de 5 min, sinon null (même règle que fs-ticket.js). */
export function readJoinCache(raw, now = Date.now()) {
  try {
    const cache = JSON.parse(raw || 'null');
    if (!cache || typeof cache.join !== 'boolean' || !Number.isFinite(cache.at) || cache.at > now + 1000 || now - cache.at >= JOIN_TTL_MS) return null;
    return cache.join;
  } catch { return null; }
}

/**
 * Ligne « Discord » de l'accueil du jeu, dite avant tout effort (retour du 9 octobre 2026 : un visiteur venu de Google
 * découvrait à l'envoi qu'il fallait être membre du serveur ; la connexion se fait désormais avant de commencer). `join` : le service ajoute au serveur le compte qui n'en
 * est pas membre (GET /features → join) ; sinon l'invitation (réglage discord_invite_url), si elle existe, est proposée
 * tout de suite. `connected` : session déjà ouverte, donc membre. → { text, invite } (invite : '' ou l'adresse).
 */
export function discordWelcome({ join = false, invite = '', connected = false } = {}) {
  if (connected) return { text: t('propose.welcome.connected'), invite: '' };
  if (join) return { text: t('propose.welcome.join'), invite: '' };
  return { text: t('propose.welcome.member'), invite: inviteUrl(invite) };
}

/** Traduit la réponse de POST /submissions en état d'interface. */
export function submissionOutcome(status, body) {
  const data = body && typeof body === 'object' ? body : {};
  if (status >= 200 && status < 300) {
    const states = [data.moderation, data.status, data.submission?.moderation];
    if (data.published === true || states.some((state) => state === 'approved' || state === 'published')) {
      return { kind: 'published', title: t('propose.outcome.published_title'), message: t('propose.outcome.published') };
    }
    return { kind: 'received', title: t('propose.outcome.received_title'), message: t('propose.outcome.received') };
  }
  /* Messages choisis par le statut et le code d'erreur (body.error), jamais par le texte renvoyé par le service. */
  if (status === 422) {
    const errors = data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors) ? data.errors : { _: typeof data.error === 'string' ? data.error : t('propose.outcome.invalid_fallback') };
    return { kind: 'invalid', errors, message: t('propose.outcome.invalid') };
  }
  if (status === 429 && data.error === 'busy') return { kind: 'error', message: t('propose.outcome.busy') };
  if (status === 429) return { kind: 'limit', message: t('propose.outcome.limit') };
  if (status === 401) return { kind: 'auth', message: t('propose.outcome.auth') };
  if (status === 403 && data.error === 'member_restricted') return { kind: 'error', message: t('propose.auth.restricted') };
  if (status === 403) return { kind: 'error', message: t('propose.outcome.forbidden') };
  if (status === 413) return { kind: 'error', message: t('propose.outcome.too_large') };
  return { kind: 'error', message: t('propose.outcome.error') };
}

/* ------------------------------------------------------------------ brouillons, erreurs, contexte */

const DRAFT_TEXT = 200;
const DRAFT_VALUES = 120;
const SLOT_KEY = /^[a-z][a-z0-9_-]{1,31}$/;
/** Version du brouillon écrit : 4 depuis la fusion des deux premières étapes (VEND-08) ; v3, v2 et v1 restent lisibles. */
export const DRAFT_VERSION = 4;
/** Première étape de chaque jeu : « Votre pilote » (VEND-08). */
export const FIRST_STEP = 'pilote';
/**
 * Étapes d'un brouillon v3 qui n'existent plus (VEND-08, TECH-02 CA4) : « L’essentiel » mène à « Votre pilote », qui
 * reprend ses champs ; l'ancienne « Votre fiche pilote » garde son identifiant. Une étape inconnue reste écartée.
 */
export const RENAMED_STEPS = Object.freeze({ essentiel: FIRST_STEP });
const migrateStep = (id) => (typeof id === 'string' && Object.hasOwn(RENAMED_STEPS, id) ? RENAMED_STEPS[id] : id);
/**
 * Saisie relue du stockage : titre, étiquettes et valeurs simples (jamais d'objet ni de secret), puis l'état du parcours
 * (brouillon v4, v3 migré) : étape et étapes vues ou passées (liste fermée du jeu), titre retouché, choix « exact » de
 * l'arrondi, réponses partielles et « Autre formulation » des widgets, captures envoyées (identifiant opaque seulement)
 * ou perdues, prix souhaité tel que saisi (hors de values). Jamais d'image ni de data URL.
 */
function cleanDraft(input, game) {
  if (!input || typeof input !== 'object') return null;
  const values = {};
  for (const [key, value] of Object.entries(input.values && typeof input.values === 'object' ? input.values : {}).slice(0, DRAFT_VALUES)) {
    if (!/^[a-z0-9_]{1,40}$/i.test(key)) continue;
    if (typeof value === 'boolean') values[key] = value;
    else if (typeof value === 'string' || typeof value === 'number') values[key] = String(value).slice(0, DRAFT_TEXT);
    else if (Array.isArray(value)) values[key] = value.filter((item) => typeof item === 'string').map((item) => item.slice(0, 80)).slice(0, 120);
  }
  const draft = {
    title: typeof input.title === 'string' ? input.title.slice(0, DRAFT_TEXT) : '',
    tags: Array.isArray(input.tags) ? input.tags.filter((tag) => typeof tag === 'string').map((tag) => tag.slice(0, 60)).slice(0, 10) : [],
    values,
  };
  const ids = game ? stepIds(game, { prices: true }) : [];
  const step = migrateStep(input.step);
  if (ids.includes(step)) draft.step = step;
  for (const name of ['visited', 'skipped']) {
    const list = Array.isArray(input[name]) ? [...new Set(input[name].map(migrateStep).filter((id) => ids.includes(id)))] : [];
    if (list.length) draft[name] = list;
  }
  if (input.titleEdited === true) draft.titleEdited = true;
  if (input.tagsSeen === true) draft.tagsSeen = true;
  /* Import d'un outil de compte (AccInsight) : clés remplies par l'outil, masquées au vendeur, et étapes rouvertes par
     « Modifier » sur Vérifier (retours du 3 novembre 2026). */
  const imported = Array.isArray(input.imported) ? [...new Set(input.imported.filter((key) => typeof key === 'string' && /^[a-z0-9_]{1,40}$/.test(key)))].slice(0, DRAFT_VALUES) : [];
  if (imported.length) draft.imported = imported;
  const revealed = Array.isArray(input.revealed) ? [...new Set(input.revealed.map(migrateStep).filter((id) => ids.includes(id)))] : [];
  if (revealed.length) draft.revealed = revealed;
  /* Identifiant d'un brouillon prérempli (« Modifier », « Corriger et renvoyer ») : le mode gardé ne vaut que pour lui. */
  if (typeof input.id === 'string' && DRAFT_ID.test(input.id)) draft.id = input.id;
  /* Prix souhaité (VEND-09) : saisie exacte, texte court, jamais dans values. */
  if (typeof input.price === 'string' && input.price.trim()) draft.price = input.price.slice(0, 16);
  const rounding = Object.fromEntries(Object.entries(input.rounding && typeof input.rounding === 'object' ? input.rounding : {})
    .filter(([key, choice]) => /^[a-z0-9_]{1,40}$/.test(key) && choice === 'exact').slice(0, DRAFT_VALUES));
  if (Object.keys(rounding).length) draft.rounding = rounding;
  /* Réponses partielles d'un widget (Star Missions, enrichissements, VEND-04) : parties déjà répondues, textes courts. */
  const partial = {};
  for (const [key, answers] of Object.entries(input.partial && typeof input.partial === 'object' ? input.partial : {}).slice(0, 8)) {
    if (!/^[a-z0-9_]{1,40}$/.test(key) || !answers || typeof answers !== 'object' || Array.isArray(answers)) continue;
    const kept = Object.entries(answers).filter(([part, text]) => /^[a-z0-9_]{1,40}$/i.test(part) && (typeof text === 'string' || typeof text === 'number') && String(text).trim())
      .slice(0, 12).map(([part, text]) => [part, String(text).trim().slice(0, 24)]);
    if (kept.length) partial[key] = Object.fromEntries(kept);
  }
  if (Object.keys(partial).length) draft.partial = partial;
  /* « Autre formulation » d'un widget : texte repris gardé tel quel, même quand la réponse du widget est complète. */
  const other = Object.fromEntries(Object.entries(input.other && typeof input.other === 'object' ? input.other : {}).slice(0, 8)
    .filter(([key, text]) => /^[a-z0-9_]{1,40}$/.test(key) && typeof text === 'string' && text.trim()).map(([key, text]) => [key, text.trim().slice(0, DRAFT_TEXT)]));
  if (Object.keys(other).length) draft.other = other;
  const captures = {};
  for (const [slot, entry] of Object.entries(input.captures && typeof input.captures === 'object' ? input.captures : {}).slice(0, 12)) {
    if (!SLOT_KEY.test(slot) || !entry || typeof entry !== 'object') continue;
    if (entry.state === 'uploaded' && typeof entry.ref === 'string' && MEDIA_REF.test(entry.ref)) captures[slot] = { state: 'uploaded', ref: entry.ref };
    else if (entry.state === 'lost') captures[slot] = { state: 'lost' };
  }
  if (Object.keys(captures).length) draft.captures = captures;
  return draft;
}

/**
 * Reprise d'un brouillon ou d'un préremplissage sur les choix fermés du modèle (spec 21 § 1.3, analyse 24) : chaque
 * valeur passe par matchOption (option, puis alias ; jamais approchée). Ancien texte d'un champ devenu multichoix :
 * découpé sur , ; / et retours à la ligne, morceaux reconnus cochés, les autres dans la note « Autres » du champ
 * (<clé>_note) s'il en a une. Un morceau de la liste `ignored` du champ est retiré sans erreur. Sinon, le champ est
 * vidé et rendu dans `review` avec la valeur d'origine, pour le marquer « à revoir ».
 */
export function restoreClosedValues(template, values = {}, match = () => null) {
  const out = { ...values };
  const review = {};
  const ignored = [];
  const fields = (template?.sections || []).flatMap((section) => section.fields);
  const keys = new Set(fields.map((field) => field.key));
  for (const field of fields) {
    const raw = out[field.key];
    if (raw === undefined || raw === '' || (field.type !== 'choice' && field.type !== 'multichoice')) continue;
    if (field.type === 'choice') {
      const option = typeof raw === 'string' ? match(field, raw) : null;
      if (option) out[field.key] = option;
      else { delete out[field.key]; review[field.key] = String(raw); }
      continue;
    }
    const pieces = (Array.isArray(raw) ? raw : String(raw).split(/[,;/\n]+/)).map((piece) => String(piece).trim()).filter(Boolean);
    /* « Aucun » d'une liste (noneOption, VEND-04) : repris tel quel s'il est seul. */
    if (typeof field.noneOption === 'string' && pieces.length === 1 && [normalizeKey(field.noneOption), 'aucun', 'aucune'].includes(normalizeKey(pieces[0]))) { out[field.key] = [field.noneOption]; continue; }
    const skip = new Set((Array.isArray(field.ignored) ? field.ignored : []).map((item) => String(item).toLowerCase()));
    const chosen = new Set();
    const rest = [];
    for (const piece of pieces) {
      const option = match(field, piece);
      if (option) chosen.add(option);
      else if (skip.has(piece.toLowerCase())) ignored.push(piece);
      else rest.push(piece);
    }
    const list = (field.options || []).filter((option) => chosen.has(option)).slice(0, field.maxItems || Infinity);
    if (list.length) out[field.key] = list; else delete out[field.key];
    if (!rest.length) continue;
    const note = `${field.key}_note`;
    if (keys.has(note)) out[note] = [out[note], rest.join(', ')].filter(Boolean).join(', ').slice(0, 120);
    else review[field.key] = rest.join(', ');
  }
  return { values: out, review, ignored };
}

/** Vrai si le brouillon garde un parcours à reprendre : une étape au-delà de la première ou des captures. */
export const hasProgress = (draft) => Boolean(draft && ((draft.step && draft.step !== FIRST_STEP) || (draft.captures && Object.keys(draft.captures).length)));

/** Libellé affiché d'une étiquette : même règle que tagLabel de fs-filters.js et le snippet fs-tag-label (« FULL DCS »
    → « Full DCS », « a-designs » → « A-designs ») ; la valeur envoyée reste l'étiquette du modèle. */
const TAG_ACRONYMS = new Set(['dcs', 'dch', 'acc']);
export const tagLabel = (tag) => {
  const label = String(tag ?? '').trim().split(/\s+/).filter(Boolean).map((word) => {
    const upper = word.toUpperCase();
    const lower = word.toLowerCase();
    if (/[0-9]/.test(word) || TAG_ACRONYMS.has(lower)) return upper;
    if (word === upper && word !== lower && word.length > 3) return upper.slice(0, 1) + lower.slice(1);
    return word;
  }).join(' ');
  return label.slice(0, 1).toUpperCase() + label.slice(1);
};

/** Vrai si la saisie ne contient rien à garder. */
export const isEmptyDraft = (input) => !input || (!String(input.title || '').trim() && !(input.tags || []).length
  && !Object.values(input.values || {}).some((value) => (Array.isArray(value) ? value.length : value !== '' && value !== undefined && value !== null))
  && !Object.keys(input.partial || {}).length && !Object.keys(input.other || {}).length);

/**
 * Brouillon gardé dans l'onglet : { game: <jeu courant>, drafts: { <jeu>: saisie } }, un seul brouillon, celui du jeu
 * courant (changer de jeu efface la saisie). Accepte l'ancien format { game, input } (aller-retour Discord) ; les
 * brouillons d'autres jeux d'une version précédente sont ignorés, comme les jeux inconnus et les contenus illisibles.
 */
export function readDraftStore(text, games) {
  let data;
  try { data = JSON.parse(String(text || 'null')); } catch { data = null; }
  const store = { game: '', drafts: {} };
  if (!data || typeof data !== 'object') return store;
  const known = (game) => typeof game === 'string' && games.includes(game);
  if (known(data.game)) store.game = data.game;
  const source = data.drafts && typeof data.drafts === 'object' ? data.drafts : known(data.game) && data.input ? { [data.game]: data.input } : {};
  for (const [game, input] of Object.entries(source)) {
    const draft = game === store.game ? cleanDraft(input, game) : null;
    if (draft && (!isEmptyDraft(draft) || hasProgress(draft))) store.drafts[game] = draft;
  }
  return store;
}

/** Texte à garder : le brouillon du jeu courant seulement, s'il est non vide ou en cours (version 4 ; les versions 3,
 * 2 et 1 restent lisibles, une v3 migrée par cleanDraft). */
export function serializeDraftStore(game, drafts) {
  const kept = Object.fromEntries(Object.entries(drafts || {}).filter(([key]) => key === game).map(([key, input]) => [key, cleanDraft(input, key)]).filter(([, input]) => input && (!isEmptyDraft(input) || hasProgress(input))));
  return JSON.stringify({ v: DRAFT_VERSION, game: game || '', drafts: kept });
}

/**
 * Brouillons des jeux fermés à la vente (VEND-01, modèle `selling: false`), gardés à part dans l'onglet : le brouillon
 * du jeu choisi ne les écrase jamais. `text` : contenu de DRAFT_KEY ; `held` : contenu de CLOSED_DRAFT_KEY ; `games` :
 * jeux proposés. Retourne { held, restore, games } : texte à garder (null = rien), brouillon à remettre dans DRAFT_KEY
 * (réouverture du jeu, si l'onglet n'a pas d'autre brouillon ; sinon null) et jeux gardés.
 */
export function holdClosedDrafts(text, held, games) {
  const parse = (value) => { try { const data = JSON.parse(String(value || 'null')); return data && typeof data === 'object' ? data : null; } catch { return null; } };
  const kept = {};
  const keep = (game, input) => {
    const draft = /^[a-z][a-z0-9-]{1,39}$/.test(game) ? cleanDraft(input, game) : null;
    if (draft && (!isEmptyDraft(draft) || hasProgress(draft))) kept[game] = draft;
  };
  for (const [game, input] of Object.entries(parse(held)?.drafts || {}).slice(0, 8)) keep(game, input);
  const main = parse(text);
  // Format v3 ou v4 { game, drafts } ou ancien format { game, input } (aller-retour Discord), comme readDraftStore.
  if (typeof main?.game === 'string' && !games.includes(main.game)) keep(main.game, main.drafts && typeof main.drafts === 'object' ? main.drafts[main.game] : main.input);
  let restore = null;
  const back = Object.keys(kept).find((game) => games.includes(game));
  if (back && !Object.keys(readDraftStore(text, games).drafts).length) { restore = serializeDraftStore(back, { [back]: kept[back] }); delete kept[back]; }
  return { held: Object.keys(kept).length ? JSON.stringify({ v: DRAFT_VERSION, drafts: kept }) : null, restore, games: Object.keys(kept) };
}

/** Aide des étiquettes selon le modèle (minimum exigé par le jeu, 6 au plus). */
export function tagsHint(template) {
  const min = Number(template?.minTags) || 0;
  if (min <= 0) return t('propose.tags_hint.max');
  return min === 1 ? t('propose.tags_hint.one') : t('propose.tags_hint.range', { min });
}

/** Messages d'erreur écrits par le site, déjà dans la langue de la page (siteError) : displayError les rend tels quels. */
const SITE_ERRORS = new Set();
export const siteError = (text) => { SITE_ERRORS.add(String(text ?? '').trim().replace(/\.$/, '')); return text; };

/**
 * Message d'erreur tel qu'affiché : les messages du validateur (packages/listing-templates, partagés avec le service et
 * renvoyés tels quels en 422) restent inchangés ; seule leur présentation est reformulée ici.
 */
export function displayError(message, context = null) {
  const text = String(message ?? '').trim().replace(/\.$/, '');
  if (SITE_ERRORS.has(text)) return text;
  /* Sous le champ (spec 21 § 2.5) : message contextualisé avec le nom du champ, au lieu de « À renseigner ». Champ vide
     depuis que tout est obligatoire (VEND-04) : une quantité demande « 0 » plutôt qu'un vide. */
  if (/^obligatoire$/i.test(text) && context?.name) {
    const label = String(pick(context.name) ?? '');
    const name = label.charAt(0).toLocaleLowerCase(locale) + label.slice(1);
    if (context.kind === 'choice') return t('propose.errors.choose_named', { name });
    if (context.kind === 'tags') return t('propose.errors.choose_tag');
    if (context.kind === 'number' && (context.min ?? 0) === 0) return t('propose.errors.zero_if_none');
    if (context.kind === 'number') return context.max !== undefined ? t('propose.errors.number_named_range', { name, min: context.min ?? 0, max: context.max }) : t('propose.errors.number_named', { name });
    if (context.kind === 'ships') return t('propose.errors.check_ship');
    if (context.kind === 'multichoice') return context.none ? t('propose.errors.check_box_or_none') : t('propose.errors.check_box');
    if (context.kind === 'boolean') return t('propose.errors.yes_no');
    if (context.kind === 'premium') return context.active ? t('propose.errors.days_left') : t('propose.errors.yes_no');
  }
  /* Widgets WarUniverse : réponse absente ou incomplète (format du modèle, VEND-04), même consigne. */
  const widget = { star_missions: t('propose.errors.star_missions'), enrichments: t('propose.errors.enrichments') }[context?.kind];
  if (widget && /^(?:obligatoire$|une réponse pour chacune des 5 Star Missions|les 4 enrichissements)/i.test(text)) return widget;
  if (/^obligatoire$/i.test(text)) return t('propose.errors.required');
  if (/^pas de prix dans l’annonce/i.test(text)) return t('propose.errors.no_price');
  if (/^liens, invitations et mentions interdits$/i.test(text)) return t('propose.errors.no_link');
  if (/^8 caractères au moins$/i.test(text)) return t('propose.errors.min_8');
  const tags = /^au moins (\d+) étiquettes?$/i.exec(text);
  if (tags) return Number(tags[1]) === 1 ? t('propose.errors.choose_tag') : t('propose.errors.choose_tags', { count: Number(tags[1]) });
  const range = /^entier entre (-?\d+) et (-?\d+)$/i.exec(text);
  if (range && Number(range[2]) >= 1e11) return t('propose.errors.whole_number');
  if (range) return t('propose.errors.number_range', { min: range[1], max: range[2] });
  return locale === 'fr' ? text : validatorText(text);
}

/**
 * Hors du français : autres messages du validateur (packages/listing-templates, en français, renvoyés tels quels en 422)
 * reconnus par leur forme et traduits ; un message inconnu devient une consigne générique, jamais le texte français.
 */
const VALIDATOR_TEXTS = [
  [/^caractères non autorisés$/i, 'bad_characters'], [/^(\d+) caractères au plus$/i, 'too_long', (match) => ({ max: match[1] })],
  [/^étiquette inconnue$/i, 'unknown_tag'], [/^6 étiquettes différentes au plus$/i, 'tags_max'], [/^champs? inconnus?/i, 'unknown_field'],
  [/^oui ou non$/i, 'yes_no'], [/^choix invalide$/i, 'invalid_choice'], [/^choix en double$/i, 'duplicate_choice'],
  [/^(\d+) choix au plus$/i, 'max_choices', (match) => ({ count: Number(match[1]) })], [/^non coché plus haut : (.+)$/i, 'not_checked_above', (match) => ({ list: match[1] })],
  [/^Aucun ne se combine pas avec/i, 'none_conflict'], [/^une réponse pour chacune des 5 Star Missions/i, 'star_missions'], [/^les 4 enrichissements/i, 'enrichments'],
  [/^Indiquez un prix entier en euros/i, 'expected_net'], [/^Le formulaire a été mis à jour/i, 'terms_reload'], [/^jeu non ouvert à la vente$/i, 'game_closed'],
  [/^capture réservée à l’équipe/i, 'staff_slot'], [/^(\d+) captures? au plus pour/i, 'slot_max', (match) => ({ count: Number(match[1]) })],
];
function validatorText(text) {
  for (const [pattern, key, params] of VALIDATOR_TEXTS) {
    const match = pattern.exec(text);
    if (match) return t(`propose.errors.${key}`, params ? params(match) : undefined);
  }
  return t('propose.errors.invalid');
}

/**
 * Résumé d'erreurs compact (spec 05 § 1.10) : les messages identiques regroupés en une ligne, dans l'ordre du formulaire
 * (« Anka, Atlas, Pusat : indiquez 0 si vous n’en avez pas. »). → [{ message, items: [{ key, label }] }]. Les messages
 * du validateur restent ceux de displayError.
 */
export function errorGroups(errors, order, labelOf, contextOf = () => null) {
  const keys = Object.keys(errors || {}).filter((key) => key !== '_');
  const rank = (key) => { const index = order.indexOf(key); return index < 0 ? order.length : index; };
  const groups = new Map();
  for (const key of keys.sort((a, b) => rank(a) - rank(b))) {
    const message = displayError(errors[key], contextOf(key));
    if (!groups.has(message)) groups.set(message, { message, items: [] });
    groups.get(message).items.push({ key, label: labelOf(key) });
  }
  return [...groups.values()];
}

/**
 * Typographie française des textes fixes du formulaire (spec 05, GR-20) : espace fine insécable avant « ? ! ; »,
 * insécable avant « : » et à l'intérieur des guillemets. Jamais sur les messages du validateur ni sur
 * « n champs à compléter : » (lus tels quels par le service et les recettes).
 */
export const frenchSpacing = (text) => (locale !== 'fr' ? String(text ?? '') : String(text ?? '').replace(/ ([?!;])/g, '\u202f$1').replace(/ :/g, '\u00a0:')
  .replace(/« /g, '«\u00a0').replace(/ »/g, '\u00a0»'));

/** Lignes du résumé d'erreurs : { key, text } dans l'ordre du formulaire, libellé lisible devant le message (celui
    du champ, contextualisé si `contextOf` le permet : « RLX-1 : indiquez 0 si vous n’en avez pas. »). */
export function errorItems(errors, order, labelOf, contextOf = () => null) {
  const keys = Object.keys(errors || {}).filter((key) => key !== '_');
  const rank = (key) => { const index = order.indexOf(key); return index < 0 ? order.length : index; };
  return keys.sort((a, b) => rank(a) - rank(b)).map((key) => {
    return { key, text: t('propose.errors.item', { label: pick(labelOf(key)), message: displayError(errors[key], contextOf(key)) }) };
  });
}

/** Grille des vaisseaux et designs : toujours complète (rien de replié, VEND-05) ; filtre par nom au-delà de 12 cases. */
export const DESIGN_FILTER_MIN = 12;
/** Compteur vivant de la grille (role=status) : « 7 vaisseaux cochés », avec le nombre affiché pendant un filtre. */
export function designCountText(checked, { query = '', visible = 0, other = false } = {}) {
  const picked = checked ? t('propose.designs.checked', { count: checked }) : t('propose.designs.none_checked');
  if (!query) return picked;
  if (!visible) return t(other ? 'propose.designs.no_match_other' : 'propose.designs.no_match', { picked });
  return t('propose.designs.shown', { count: visible, picked });
}

/** Avis du changement de jeu : ce qui reste gardé pour l'ancien jeu, et ce qui n'est pas repris. */
export function gameChangeNote(from, to, { draft, imports = 0, names = {} } = {}) {
  if (!from || !to || from === to) return '';
  const typed = !isEmptyDraft(draft);
  if (!typed && !imports) return '';
  const a = names[from] || from; const b = names[to] || to;
  const kept = t(typed && imports ? 'propose.game_change.kept_both' : typed ? 'propose.game_change.kept_entry' : 'propose.game_change.kept_import', { game: a });
  return t('propose.game_change.note', { kept, from: a, to: b });
}

/**
 * Validation des étapes et de l'envoi aux règles d'envoi du modèle (VEND-02, `mode: 'submit'`) : mêmes champs
 * obligatoires et mêmes messages que POST /submissions. Lève l'erreur du validateur (erreurs par champ).
 */
export const checkSubmission = (lib, template, input) => lib.validateSubmission(template, input, { mode: 'submit' });

/** Annonce partielle pour la carte de « Vérifier » : seuls les champs déjà valides, même logique que le service. */
export function previewListing(lib, template, input) {
  const lenient = { ...template, minTags: 0, sections: template.sections.map((section) => ({ ...section, fields: section.fields.map((field) => ({ ...field, required: false })) })) };
  const values = { ...(input.values || {}) };
  const attempt = () => lib.validateSubmission(lenient, { title: 'Aperçu de l’annonce', tags: [], values });
  let listing;
  try { listing = attempt(); } catch (error) {
    if (!error?.errors) throw error;
    Object.keys(error.errors).forEach((key) => delete values[key]);
    try { listing = attempt(); } catch { listing = { game: template.game, values: {} }; }
  }
  const title = String(input.title || '').replace(/\s+/g, ' ').trim().slice(0, template.title?.maxLength ?? 120);
  const tags = (input.tags || []).filter((tag) => template.tags.includes(tag)).slice(0, 6);
  return { game: template.game, title, tags, values: listing.values };
}

const capitalize = (text) => (text ? text.charAt(0).toLocaleUpperCase(locale) + text.slice(1) : text);
/* Noms affichés des serveurs (la valeur envoyée reste l'option anglaise du modèle). */
const SERVERS = { Europe: t('propose.servers.europe'), 'North America': t('propose.servers.north_america'), Turkey: t('propose.servers.turkey') };

/**
 * Texte d'un modèle (champ, emplacement de capture, modèle) dans la langue de la page, français compris : glossaire
 * officiel (objet `i18n` généré par intl-glossaire, `{ en, fr?, … }`, une langue identique à l'anglais omise), sinon le
 * texte du modèle (règle du 4 octobre : un terme de jeu affiché vient du glossaire de la langue active).
 */
export function templateText(owner, prop) {
  const localized = owner?.i18n?.[prop];
  return (localized && typeof localized === 'object' ? pick(localized) : null) ?? pick(owner?.[prop]);
}

/**
 * Valeur d'une caractéristique telle que la carte publiée l'affiche (fs-listing-detail-stat) :
 * pastilles de couleur Discord retirées, ✅/❌ → Oui/Non, « 6 / 8 » → jauge (count, total, fill en %).
 */
export function statValue(value) {
  const text = String(value ?? '').replace(/[🔵🟡🔴🟢🟣🟠⚪⚫]|️/gu, '').trim();
  const lower = text.toLowerCase();
  if (text.includes('✅') || ['yes', 'oui', 'true', 'available'].includes(lower)) return { kind: 'yes', text: t('propose.common.yes') };
  if (text.includes('❌') || ['no', 'non', 'false'].includes(lower)) return { kind: 'no', text: t('propose.common.no') };
  const ratio = /^(\d{1,3})\s*\/\s*(\d{1,2})$/.exec(text);
  if (ratio && Number(ratio[2]) > 0 && Number(ratio[2]) < 25) {
    const count = Number(ratio[1]), total = Number(ratio[2]);
    return { kind: 'ratio', text: `${count} / ${total}`, count, total, fill: Math.min(100, Math.floor((count * 100) / total)) };
  }
  return { kind: 'text', text: text || '—' };
}

/* ------------------------------------------------------------------ packs de jeu (hackathon 2) */


const SHIP_CHARSET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
/** Visuel d'ambiance attribué à une référence : même algorithme que le snippet du pack (shipIndex). */
export function shipIndex(reference, count) {
  if (!Number.isInteger(count) || count < 1) return 0;
  let hash = 7;
  for (const char of String(reference ?? '').trim().toUpperCase()) hash = (hash * 31 + SHIP_CHARSET.indexOf(char) + 1) % 65521;
  return hash % count;
}

/** Clés d'icône essayées pour un champ ou une étiquette : libellé, clé du modèle, sans « full », suivi de « design ». */
export function iconKeys(label, key) {
  const base = normalizeKey(label);
  const keys = [base, normalizeKey(key), base.replace(/^full/, ''), `${base}design`];
  return [...new Set(keys.filter(Boolean))];
}

/** Icône par section du modèle (onglets du formulaire) ; repli : icône du premier champ. */
export const SECTION_ICONS = {
  waruniverse: { infos: 'rank', drones: 'drone', ammo: 'glx2', electro_energy: 'ee1', bonus: 'starmissions' },
  redgalaxy: { infos: 'rank', drones: 'anka', ammo: 'lap4', ressources: 'antimatter', extras: 'empa', galaxy_gates: 'void' },
  darkorbit: { infos: 'rank', ships: 'ships', designs: 'designs', drones: 'drones', lasers_gens: 'lasers', pet: 'pet', ammo: 'ammo', modules_skills: 'modules', galaxy_gates: 'gates', particle_cannons: 'cannons', endgame: 'endgame' },
  novahorizon: { infos: 'rank', ships: 'ships', designs: 'designs', drones: 'wingman', equipment: 'lasers', ammo: 'ammo', skills: 'skills', gates: 'gates', ores: 'ores', refinery: 'enrichments', stats: 'pvpkills' },
};

const SAFE_URL = /^(?:https:\/\/|\/\/|\/(?!\/))[^\s"'<>()\\]+$/;
const safeUrl = (value) => (typeof value === 'string' && SAFE_URL.test(value) ? value : '');
const dimension = (value, fallback) => (Number.isFinite(value) && value > 0 && value <= 4096 ? Math.round(value) : fallback);

/**
 * Lit le JSON d'un pack (script #fs-game-pack-<jeu>, généré par tools/game-packs/build.mjs) et n'en garde que
 * ce que le formulaire utilise, avec des URL relatives ou https seulement. Pack absent ou illisible → null.
 */
export function readPack(text, game) {
  let data;
  try { data = JSON.parse(String(text || '')); } catch { return null; }
  if (!data || typeof data !== 'object' || (game && data.game !== game)) return null;
  const icons = {};
  for (const [key, icon] of Object.entries(data.icons && typeof data.icons === 'object' ? data.icons : {})) {
    const url = safeUrl(icon?.url);
    if (/^[a-z0-9]+$/.test(key) && url) icons[key] = { url, label: typeof icon.label === 'string' ? icon.label.slice(0, 80) : '', width: dimension(icon.width, 64), height: dimension(icon.height, 64) };
  }
  const ships = (Array.isArray(data.ships) ? data.ships : []).map((ship) => ({ url: safeUrl(ship?.url), label: typeof ship?.label === 'string' ? ship.label.slice(0, 80) : '', width: dimension(ship?.width, 256), height: dimension(ship?.height, 256) })).filter((ship) => ship.url);
  /* Designs (vaisseaux du jeu) dans l'ordre de priorité du pack : le plus rare, puis les designs payants, puis les autres. */
  const designs = (Array.isArray(data.designs) ? data.designs : []).map((design) => ({ key: String(design?.key || ''), label: typeof design?.label === 'string' ? design.label.slice(0, 60) : '',
    tier: DESIGN_TIERS.includes(design?.tier) ? design.tier : 'standard', url: safeUrl(design?.url), width: dimension(design?.width, 256), height: dimension(design?.height, 256) }))
    .filter((design) => /^[a-z0-9]+$/.test(design.key) && design.label && design.url);
  /* Fond « scoped » (en-têtes d'étape, succès) et emblème carré (étape Vérifier), seulement par URL sûre. */
  const scoped = data.backgrounds?.scoped;
  const art = safeUrl(scoped?.url) ? { url: scoped.url, focus: typeof scoped.focus === 'string' && /^\d{1,3}% \d{1,3}%$/.test(scoped.focus) ? scoped.focus : '60% 40%' } : null;
  const emblem = safeUrl(data.logos?.emblem?.url) || safeUrl(data.logos?.logotype?.url) || '';
  return { game: String(data.game || ''), name: typeof data.name === 'string' ? data.name.slice(0, 40) : '', credits: typeof data.credits === 'string' ? data.credits.slice(0, 80) : '', icons, ships, designs, art, emblem };
}

const DESIGN_TIERS = ['rarest', 'paid', 'standard'];
/** Mention du rang d'un design : le plus rare du jeu, ou payant en argent réel ; rien pour les autres. */
export const DESIGN_TIER_NAMES = { rarest: t('propose.designs.tier_rarest'), paid: t('propose.designs.tier_paid') };

/** Designs cochés, du plus attirant au plus courant (ordre du pack) ; le premier illustre l'annonce. */
export function chosenDesigns(pack, labels) {
  const chosen = new Set(Array.isArray(labels) ? labels : []);
  return (pack?.designs || []).filter((design) => chosen.has(design.label));
}

/** Icône du pack pour un libellé (et une clé de modèle facultative), ou null. */
export function packIcon(pack, label, key) {
  if (!pack) return null;
  for (const candidate of iconKeys(label, key)) if (pack.icons[candidate]) return { key: candidate, ...pack.icons[candidate] };
  return null;
}

/** Nombre de champs renseignés par section du modèle : { <section>: { filled, total } }. */
export function sectionProgress(template, values = {}) {
  return Object.fromEntries(template.sections.map((section) => [section.id, {
    filled: section.fields.filter((field) => values[field.key] !== undefined && values[field.key] !== '').length,
    total: section.fields.length,
  }]));
}

/* ------------------------------------------------------------------ parcours en étapes (spec 03 § 2, direction 04) */

export const STEP_PHASES = Object.freeze(['compte', 'preuves', 'annonce']);
export const PHASE_NAMES = Object.freeze({ compte: t('propose.phases.compte'), preuves: t('propose.phases.preuves'), annonce: t('propose.phases.annonce') });
/** Étapes ajoutées par le code à la fin de chaque plan (jamais dans les tables par jeu) ; « prix » seulement si le
    service annonce le prix souhaité (features.prices) ; « conditions » en dernier, identique pour tous les jeux (VEND-11). */
export const RESERVED_STEPS = Object.freeze(['titre', 'prix', 'verifier', 'conditions']);
export const CONDITIONS_STEP = 'conditions';
/** Étapes de fin : le récapitulatif, puis les conditions et l'envoi ; « Retour au récapitulatif » y ramène. */
const FINAL_STEPS = Object.freeze(['verifier', CONDITIONS_STEP]);

const plan = (steps) => Object.freeze(steps.map((entry) => Object.freeze({ phase: 'preuves', captures: [], ...entry })));
/*
 * Une étape = un écran du jeu (spec 03 § 2.4 à 2.7). groups : [{ title?, icon?, fields, hint? }]. Rien de replié, aucune
 * étape facultative (VEND-04, règle P-04) : « Continuer » valide tous les champs de l'étape ; plus de saut d'étape, de
 * raccourci vers le titre ni de champs rares repliés. Les captures publiques ouvrent toujours l'étape. est :
 * durée indicative en secondes (accueil : GAME_TIMES). icon : clé de pack.icons. Chemins d'écran « à confirmer » :
 * DarkOrbit, Nova Horizon, drones et enrichissements RedGalaxy (question ouverte n° 10 de la spec).
 * Première étape « Votre pilote » (VEND-08) : « L’essentiel » et « Votre fiche pilote » fusionnées, dans l'ordre de
 * l'écran Info du jeu ; trois groupes empilés depuis la spec 05 (Identité, Progression, Statut du compte) ; les monnaies
 * Nova Horizon passent au coffre. Toute étape à un seul groupe a quand même un titre de groupe (spec 05 § 2.2).
 */
/**
 * Les champs de la fiche pilote demandés en une fois (VEND-08), même phrase pour tous les jeux, en trois groupes empilés
 * (spec 05 § 2.1, avenant à VEND-08 : plus de colonnes côte à côte) : Identité, Progression, Statut du compte.
 * numbersHint : false, le sous-titre dit déjà comment taper les chiffres.
 */
const PILOT = Object.freeze({ id: 'pilote', phase: 'compte', icon: 'rank', numbersHint: false, title: t('propose.steps.pilot.title'), lead: t('propose.steps.pilot.lead') });
const pilot = (identity, progression, status, extra = {}) => ({ ...PILOT, ...extra, groups: [{ title: t('propose.groups.identity'), fields: identity }, { title: t('propose.groups.progression'), fields: progression },
  ...(status.length ? [{ title: t('propose.groups.status'), fields: status }] : [])] });
export const STEP_PLAN = Object.freeze({
  waruniverse: plan([
    /* Plateforme retirée (VEND-06). Rangées : Niveau · Grade, puis Serveur · Faction (spec 05 § 2.1). */
    pilot(['level', 'rank', 'server', 'company'], ['experience', 'honor', 'rankpoints'], ['premium', 'keys', 'faction_change_available'], { est: 105 }),
    /* Aucune capture WarUniverse (VEND-05) : le hangar se déclare en cochant ses vaisseaux, grille complète. */
    { id: 'hangar', est: 60, icon: 'ships', title: t('propose.steps.waruniverse.hangar.title'), lead: t('propose.steps.waruniverse.hangar.lead'),
      groups: [{ title: t('propose.groups.ships'), fields: ['ships'] }] },
    { id: 'drones', est: 45, icon: 'dcs', title: t('propose.steps.waruniverse.drones.title'), lead: t('propose.steps.waruniverse.drones.lead'),
      groups: [{ title: t('propose.groups.drone_covers'), icon: 'dcs', fields: ['dcs', 'dch', 'dcd'] }, { title: t('propose.groups.lasers'), icon: 'lg4', fields: ['lg4', 'lg3'], hint: t('propose.groups.lasers_hint') }] },
    { id: 'munitions', est: 120, icon: 'glx2', title: t('propose.steps.waruniverse.munitions.title'), lead: t('propose.steps.copy_amounts'),
      /* RLX-1, KEP-410 et NC-30 retirés (ajustements du 10 octobre 2026). */
      groups: [{ title: t('propose.groups.ammo'), icon: 'glx2', fields: ['glx_2', 'blx_3', 'wlx_4', 'glx_2_as', 'mrs_6x', 'tnc_130'] },
        { title: t('propose.groups.electro_energy'), icon: 'ee1', fields: ['ee_1', 'en_702', 'eg_88_3', 'em_ap_4'] }] },
    { id: 'tresor', est: 120, icon: 'platinium', title: t('propose.steps.waruniverse.tresor.title'), lead: t('propose.steps.waruniverse.tresor.lead'),
      groups: [{ title: t('propose.groups.currencies_resources'), icon: 'platinium', fields: ['platinium', 'bitcoin', 'golds', 'dungid', 'xureon'] },
        { title: 'Star Missions', icon: 'starmissions', fields: ['star_missions'] }, { title: t('propose.groups.enrichments'), fields: ['enrichments'] },
        { title: t('propose.groups.other_servers'), fields: ['other_servers'] }] },
  ]),
  redgalaxy: plan([
    /* Capture du profil (réservée à l'équipe) : présentée en fin d'étape, inchangée. Plateforme retirée (10 octobre 2026). */
    pilot(['level', 'rank', 'company'], ['experience', 'honor', 'rankpoints'], ['premium', 'keys', 'faction_change_available'], { est: 105, captures: ['profile'] }),
    /* Plus de capture publique RedGalaxy (retours du 15 octobre 2026) : les étapes suivantes se déclarent sans image. */
    { id: 'hangar', est: 90, icon: 'ships', title: t('propose.steps.redgalaxy.hangar.title'), lead: t('propose.steps.redgalaxy.hangar.lead'),
      groups: [{ title: t('propose.groups.ships'), fields: ['ships'] }, { title: t('propose.groups.counter'), fields: ['hangar_slots'] }] },
    { id: 'recherche', est: 45, icon: 'fullresearch', title: t('propose.steps.redgalaxy.recherche.title'), lead: t('propose.steps.redgalaxy.recherche.lead'),
      groups: [{ title: t('propose.groups.tree'), fields: ['full_research', 'skill_cell'] }, { title: t('propose.groups.research_max'), fields: ['research_notes'] }] },
    { id: 'drones', est: 45, icon: 'anka', title: t('propose.steps.redgalaxy.drones.title'), lead: t('propose.steps.redgalaxy.drones.lead'),
      groups: [{ title: t('propose.groups.drones'), icon: 'anka', fields: ['anka', 'atlas', 'pusat'] }, { title: t('propose.groups.drone_designs'), icon: 'strikerdesign', fields: ['striker_design', 'bastion_design', 'yellow_design', 'halloween_design'], hint: t('propose.groups.drone_designs_hint') }] },
    { id: 'armement', est: 120, icon: 'lap4', title: t('propose.steps.redgalaxy.armement.title'), lead: t('propose.steps.redgalaxy.armement.lead'),
      groups: [{ title: t('propose.groups.lasers'), icon: 'lr4', fields: ['lr4'] }, { title: t('propose.groups.ammo'), icon: 'lap4', fields: ['lap_2', 'lap_3', 'lap_4', 'sap', 'rsap', 'mk_3', 'mk_4'] },
        { title: t('propose.groups.extras'), icon: 'empa', fields: ['emp_a', 'snb_a', 'wsc_a', 'clo_a'] }] },
    { id: 'coffre', est: 90, icon: 'redmatter', title: t('propose.steps.redgalaxy.coffre.title'), lead: t('propose.steps.redgalaxy.coffre.lead'),
      groups: [{ title: t('propose.groups.currencies'), icon: 'redmatter', fields: ['red_matter', 'credits', 'celestium'] },
        { title: t('propose.groups.resources'), icon: 'antimatter', fields: ['antimatter', 'mecha_token'] },
        { title: t('propose.groups.galaxy_gates'), icon: 'void', fields: ['void', 'rift', 'nebula', 'inferno'] }] },
  ]),
  /* DarkOrbit, rouvert à la vente (16 octobre 2026, modèle v2) : même forme que RedGalaxy et Nova Horizon, tout
     obligatoire (VEND-04) sauf les notes libres, aucune capture publique. Infos utilisateur et fiche d'outil réservées
     à l'équipe, présentées en fin de fiche pilote (envoyées dans le ticket Selling). */
  darkorbit: plan([
    /* Pays de paiement de la boutique (modèle v3, décision 035) : statut du compte, comme le Premium. */
    pilot(['level', 'rank', 'server', 'company'], ['experience', 'honor', 'rankpoints', 'uridium', 'credits'], ['premium', 'never_banned', 'payment_country'], { est: 105, captures: ['user', 'tool-sheet'], note: t('propose.groups.payment_hint') }),
    { id: 'hangar', est: 120, icon: 'ships', title: t('propose.steps.hangar_designs.title'), lead: t('propose.steps.darkorbit.hangar.lead'),
      groups: [{ title: t('propose.groups.ships'), fields: ['ships', 'other_ships'] }, { title: t('propose.groups.designs'), fields: ['ship_designs', 'notable_designs', 'notable_designs_note'] }] },
    { id: 'drones', est: 45, icon: 'iris', title: t('propose.groups.drones'), lead: t('propose.steps.darkorbit.drones.lead'),
      groups: [{ title: t('propose.groups.drones'), icon: 'iris', fields: ['iris', 'apis', 'zeus'] },
        { title: t('propose.groups.drone_designs'), icon: 'havoc', fields: ['havoc', 'hercules'], hint: t('propose.groups.drone_designs_hint') }] },
    { id: 'armement', est: 90, icon: 'ucb100', title: t('propose.steps.darkorbit.armement.title'), lead: t('propose.steps.copy_amounts'),
      groups: [{ title: t('propose.groups.lasers'), icon: 'lf4', fields: ['lf3', 'lf4', 'prometheus'] }, { title: t('propose.groups.generators'), icon: 'b02', fields: ['b02', 'g3n7900'] },
        { title: t('propose.groups.ammo'), icon: 'ucb100', fields: ['ucb_100', 'rsb_75', 'sab_50', 'mcb_50'] }] },
    /* P.E.T. au niveau 0 : le compte n'en a pas, son matériel n'est alors ni montré ni demandé (requiredIf). */
    { id: 'pet', est: 45, icon: 'pet', title: t('propose.steps.darkorbit.pet.title'), lead: t('propose.steps.darkorbit.pet.lead'),
      groups: [{ title: 'P.E.T.', icon: 'pet', fields: ['pet_level', 'pet_gear'] }, { title: t('propose.groups.skills'), icon: 'skills', fields: ['full_skill_tree', 'skill_points', 'modules', 'modules_note'] }] },
    { id: 'portes', est: 60, icon: 'gates', title: t('propose.groups.galaxy_gates'), lead: t('propose.steps.darkorbit.portes.lead'),
      groups: [{ title: t('propose.groups.gate_rings'), icon: 'kronos', fields: ['gate_rings'], hint: t('propose.groups.rings_hint') },
        { title: t('propose.groups.galaxy_gates'), icon: 'gates', fields: ['alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'kappa', 'lambda', 'kuiper', 'hades', 'kronos'] }] },
    /* Modèle v3 (décision 035) : ce qu'AccInsight ne lit pas. Canons à particules (un groupe par canon, Nidhogg d'abord,
       le plus recherché ; détails montrés seulement si le canon est possédé, requiredIf), puis munitions de canon
       (préremplies par AccInsight) et équipement de fin de jeu (noyaux préremplis par AccInsight). */
    { id: 'canons', est: 120, icon: 'cannons', title: t('propose.steps.darkorbit.canons.title'), lead: t('propose.steps.darkorbit.canons.lead'),
      groups: [
        { title: 'Nidhogg', icon: 'nidhogg', fields: ['nidhogg', 'nidhogg_rarity', 'nidhogg_level', 'nidhogg_ship', 'nidhogg_stars', 'nidhogg_stats'] },
        { title: 'Helios', icon: 'helios', fields: ['helios', 'helios_rarity', 'helios_level', 'helios_ship', 'helios_stars', 'helios_stats'] },
        { title: 'Indra', icon: 'indra', fields: ['indra', 'indra_rarity', 'indra_level', 'indra_ship', 'indra_stars', 'indra_stats'] },
        { title: t('propose.groups.cannon_ammo'), icon: 'thsa04', fields: ['ths_d01', 'ths_c02', 'ths_b03', 'ths_a04', 'cos_d01', 'cos_c02', 'cos_b03', 'cos_a04', 'els_d01', 'els_c02', 'els_b03', 'els_a04'] },
        { title: t('propose.groups.cannons_note'), fields: ['cannons_note'] }] },
    { id: 'fin-de-jeu', est: 90, icon: 'endgame', title: t('propose.steps.darkorbit.fin_de_jeu.title'), lead: t('propose.steps.darkorbit.fin_de_jeu.lead'),
      groups: [{ title: t('propose.groups.refractors'), icon: 'refractors', fields: ['refractors', 'refractors_note'] },
        { title: t('propose.groups.qfc'), icon: 'qfcattack', fields: ['qfc_attack', 'qfc_defense', 'qfc_note'] },
        { title: t('propose.groups.voyager_modules'), icon: 'singularitydrives', fields: ['singularity_drives', 'singularity_model', 'singularity_level', 'gravity_lenses', 'gravity_model', 'gravity_level'] }] },
  ]),
  novahorizon: plan([
    /* Plateforme, titres (Founder, Pioneer, Recruiter) et boîte mail d'origine retirés (10 octobre 2026) : la note alpha
       passe à la fiche pilote. */
    pilot(['server', 'level', 'rank', 'company'], ['experience', 'honor', 'rankpoints'], ['premium'], { est: 75,
      note: t('propose.steps.novahorizon.alpha_note') }),
    { id: 'hangar', est: 120, icon: 'ships', title: t('propose.steps.hangar_designs.title'), lead: t('propose.steps.novahorizon.hangar.lead'),
      groups: [{ title: t('propose.groups.ships'), fields: ['ships', 'other_ships'] }, { title: t('propose.groups.counters'), fields: ['hangar_slots', 'ship_designs', 'engine_cosmetics'] },
        { title: t('propose.groups.designs'), fields: ['notable_designs', 'notable_designs_note'] }] },
    { id: 'wingman', est: 45, icon: 'wingman', title: t('propose.steps.novahorizon.wingman.title'), lead: t('propose.steps.novahorizon.wingman.lead'),
      groups: [{ title: 'Wingman', icon: 'wingman', fields: ['wingman', 'wingman_level'] }, { title: t('propose.groups.cores'), icon: 'auriccore', fields: ['auric_core', 'crimson_core', 'guardian_core', 'skell_core'] }] },
    { id: 'equipement', est: 90, icon: 'lasers', title: t('propose.steps.novahorizon.equipement.title'), lead: t('propose.steps.copy_amounts'),
      /* LA3 ajouté pour les comptes qui ne sont pas encore full LA4 (retours du 15 octobre 2026). */
      groups: [{ title: t('propose.groups.equipment'), icon: 'la5', fields: ['la3', 'la4', 'la5', 'shc3', 'shc4', 'ebs3', 'rx3'] }, { title: t('propose.groups.ammo'), icon: 'ammo', fields: ['flux_3', 'flux_4', 'salvo', 'breaker', 'viper_4'] }] },
    /* Labo refondu par le jeu (29 octobre 2026) : 15 lignes à niveaux. Comme la recherche de Red Galaxy, « Full Labs »
       oui dispense de la liste ; sinon, le vendeur coche les lignes au niveau maximum (médaillons officiels du pack). */
    { id: 'labo', est: 30, icon: 'skills', title: t('propose.steps.novahorizon.labo.title'), lead: t('propose.steps.novahorizon.labo.lead'),
      groups: [{ title: t('propose.groups.lab'), icon: 'skills', fields: ['full_labs'] }, { title: t('propose.groups.labs_max'), fields: ['labs_max'], sole: true }] },
    /* Monnaies (écran portefeuille) avec les portails, minerais et statistiques : le coffre du compte (VEND-08). Minerais
       ramenés à Pyrion et Radion, statistiques aux joueurs abattus (10 octobre 2026). Enrichissements du raffinage sur le
       widget de WarUniverse ; plus aucune capture publique Nova Horizon (retours du 15 octobre 2026). */
    { id: 'exploits', est: 120, icon: 'gates', title: t('propose.steps.novahorizon.exploits.title'), lead: t('propose.steps.novahorizon.exploits.lead'),
      groups: [{ title: t('propose.groups.money'), icon: 'novacore', fields: ['credits', 'nova_core', 'aetherium', 'booty_keys', 'sigils'] },
        { title: t('propose.groups.portals'), icon: 'gates', fields: ['phobos', 'eris', 'typhon', 'charon'] },
        { title: t('propose.groups.ores'), icon: 'ores', fields: ['pyrion', 'radion'] },
        { title: t('propose.groups.stats'), icon: 'pvpkills', fields: ['pvp_kills'] },
        { title: t('propose.groups.enrichments'), fields: ['enrichments'], sole: true }] },
  ]),
});

/** Icône de l'étape Titre par jeu (direction 04 § 1.2) ; Vérifier prend l'emblème du jeu. */
const TITLE_ICONS = { waruniverse: 'starmissions', redgalaxy: 'rankpoints', darkorbit: 'rankpoints', novahorizon: 'rankpoints' };
/** Icône de l'étape Votre prix : la monnaie du jeu dans son pack. */
const PRICE_ICONS = { waruniverse: 'golds', redgalaxy: 'credits', darkorbit: 'credits', novahorizon: 'credits' };
export const PRICE_STEP = 'prix';
/**
 * Plan complet d'un jeu : ses étapes, puis « titre », « prix » si le service annonce le prix souhaité (prices),
 * « verifier » et « conditions » (réservées ; heading : titre affiché quand il diffère du nom de la frise). Le reçu
 * d'achat n'est plus présenté à Vérifier (VEND-10) : capture « équipe », il part avec les autres dans le ticket Selling.
 * Sans prices : le plan d'aujourd'hui, à l'identique.
 */
export function stepsOf(game, { prices = false } = {}) {
  const steps = STEP_PLAN[game];
  if (!steps) return [];
  return [...steps,
    { id: 'titre', phase: 'annonce', est: 30, icon: TITLE_ICONS[game] || 'rank', title: t('propose.steps.titre.title'), lead: t('propose.steps.titre.lead'), groups: [], captures: [] },
    ...(prices ? [{ id: PRICE_STEP, phase: 'annonce', est: 15, icon: PRICE_ICONS[game] || 'rank', title: t('propose.steps.prix.title'),
      lead: t('propose.steps.prix.lead'), groups: [], captures: [] }] : []),
    { id: 'verifier', phase: 'annonce', est: 30, icon: 'emblem', title: t('propose.steps.verifier.title'), heading: t('propose.steps.verifier.heading'), lead: t('propose.steps.verifier.lead'), groups: [], captures: [] },
    { id: CONDITIONS_STEP, phase: 'annonce', est: 30, icon: 'emblem', title: t('propose.steps.conditions.title'), heading: t('propose.steps.conditions.heading'), lead: t('propose.steps.conditions.lead'), groups: [], captures: [] }];
}
/** Identifiants d'étape d'un jeu : liste fermée (brouillon v4 : relu avec prices, pour garder l'étape « prix »). */
export const stepIds = (game, options) => stepsOf(game, options).map((entry) => entry.id);
/** Clés du modèle d'une étape, dans l'ordre d'affichage. */
export const stepKeys = (entry) => (entry?.groups || []).flatMap((group) => group.fields);
/** Étape qui affiche une clé du modèle (titre et étiquettes : « titre »). */
export function stepOfKey(game, key) {
  if (key === 'title' || key === 'tags') return 'titre';
  if (key === 'expectedNet') return PRICE_STEP;
  return STEP_PLAN[game]?.find((entry) => stepKeys(entry).includes(key))?.id ?? null;
}
/** Étape qui présente un emplacement de capture (« receipts » : Vérifier). */
export const stepOfSlot = (game, slot) => stepsOf(game).find((entry) => entry.captures.includes(slot))?.id ?? null;

/**
 * Durées affichées à l'accueil, « x à y minutes » pour une annonce complète (plus d'« essentiel » séparé, VEND-04) :
 * somme des durées des étapes, titre, vérification et conditions de vente compris (30 s chacune), marge de 40 %.
 * Estimation à recaler sur la recette chronométrée d'un vendeur réel (VEND-04, CA7).
 */
export const GAME_TIMES = Object.freeze(Object.fromEntries(Object.keys(STEP_PLAN).map((game) => {
  const seconds = stepsOf(game).reduce((sum, entry) => sum + entry.est, 0);
  return [game, Object.freeze([Math.round(seconds / 60), Math.ceil((seconds * 1.4) / 60)])];
})));
/** « À préparer » de l'accueil : la capture obligatoire, puis deux recommandées. Aucun jeu n'a plus de capture
    publique (WarUniverse VEND-05, RedGalaxy et Nova Horizon 15 octobre 2026, DarkOrbit 16 octobre 2026) : le jeu
    ouvert à côté seulement. */
export const WELCOME_PREP = Object.freeze({});

/** Aides de champ (spec 21 § 6) : une phrase au plus, factuelle ; le libellé du modèle ne change pas. */
const SHIPS_HINT = t('propose.hints.ships');
/** Aide de la grille des vaisseaux WarUniverse, dont le sous-titre dit déjà de tout cocher (VEND-05). */
const SHIPS_ALL_HINT = t('propose.hints.ships_all');
export const FIELD_HINTS = Object.freeze({
  '*': { rankpoints: t('propose.hints.rankpoints'), ships: SHIPS_HINT },
  waruniverse: {
    ships: SHIPS_ALL_HINT,
    faction_change_available: t('propose.hints.waruniverse.faction_change_available'),
    rank: t('propose.hints.waruniverse.rank'),
    star_missions: t('propose.hints.waruniverse.star_missions'),
    other_servers: t('propose.hints.waruniverse.other_servers'),
    enrichments: t('propose.hints.waruniverse.enrichments'),
  },
  redgalaxy: {
    hangar_slots: t('propose.hints.redgalaxy.hangar_slots'), full_research: t('propose.hints.redgalaxy.full_research'),
    research_notes: t('propose.hints.redgalaxy.research_notes'), rank: t('propose.hints.redgalaxy.rank'),
  },
  darkorbit: {
    rank: t('propose.hints.darkorbit.rank'), other_ships: t('propose.hints.other_ships'), ship_designs: t('propose.hints.darkorbit.ship_designs'),
    notable_designs: t('propose.hints.darkorbit.notable_designs'), pet_level: t('propose.hints.darkorbit.pet_level'),
    modules: t('propose.hints.darkorbit.modules'), never_banned: t('propose.hints.darkorbit.never_banned'),
  },
  novahorizon: {
    server: t('propose.hints.novahorizon.server'), other_ships: t('propose.hints.other_ships'),
    notable_designs: t('propose.hints.novahorizon.notable_designs'), full_labs: t('propose.hints.novahorizon.full_labs'),
    labs_max: t('propose.hints.novahorizon.labs_max'),
  },
});
/** Libellés d'écran propres au formulaire (le nom public de la fiche ne change pas) ; notes « Autres : … » des grandes listes. */
const NOTE_LABELS = { notable_designs_note: t('propose.field_labels.notable_designs_note'), modules_note: t('propose.field_labels.modules_note') };
export const FIELD_LABELS = Object.freeze({
  '*': NOTE_LABELS,
  redgalaxy: { research_notes: t('propose.groups.research_max') },
  darkorbit: { notable_designs: t('propose.field_labels.notable_designs'), modules: t('propose.field_labels.modules'), pet_gear: t('propose.field_labels.pet_gear') },
  novahorizon: { notable_designs: t('propose.field_labels.notable_designs') },
});

/*
 * Schémas d'écran dessinés (direction 04 § 3.5) : jamais une vraie capture, seulement les icônes, vaisseaux et designs
 * du pack (décision 006). layout : grid | tree | profile | bar | sheet ; fill : icônes (clés de pack.icons), ships (n
 * vaisseaux d'ambiance) ou designs (n designs) ; masks : zones à masquer, hachurées et nommées.
 */
const ID_MASKS = [{ x: '3%', y: '12%', w: '44%', h: '14%', label: t('propose.masks.username') }, { x: '70%', y: '12%', w: '26%', h: '14%', label: 'ID' }];
export const SHOT_SCHEMAS = Object.freeze({
  /* WarUniverse n'a plus de capture (VEND-05) : son profil illustre seulement « Le jeu ouvert à côté » de l'accueil. */
  'wu-info': { layout: 'profile', tabs: 3, cols: 3, fill: { icons: ['colonel', 'level', 'experience', 'honor', 'bitcoin', 'premium', 'platinium'] },
    masks: [...ID_MASKS, { x: '3%', y: '74%', w: '40%', h: '18%', label: t('propose.masks.players') }] },
  'rg-profile': { layout: 'profile', tabs: 3, cols: 3, fill: { icons: ['colonel', 'level', 'experience', 'honor', 'rankpoints', 'premium', 'redmatter'] },
    masks: [...ID_MASKS, { x: '3%', y: '74%', w: '34%', h: '16%', label: t('propose.masks.clan') }] },
  /* DarkOrbit : plus que les captures réservées à l'équipe (16 octobre 2026) ; son profil illustre aussi l'accueil. */
  'do-user': { layout: 'profile', tabs: 3, cols: 3, fill: { icons: ['rank', 'level', 'experience', 'honor', 'uridium', 'credits', 'premium'] },
    masks: [...ID_MASKS, { x: '3%', y: '74%', w: '34%', h: '16%', label: t('propose.masks.clan') }] },
  'do-sheet': { layout: 'sheet', tabs: 2, cols: 1, fill: { rows: 6 }, masks: ID_MASKS },
  receipt: { layout: 'sheet', tabs: 2, cols: 1, fill: { rows: 6 },
    masks: [{ x: '10%', y: '30%', w: '46%', h: '13%', label: t('propose.masks.email') }, { x: '10%', y: '48%', w: '36%', h: '13%', label: t('propose.masks.name') }, { x: '52%', y: '66%', w: '38%', h: '13%', label: t('propose.masks.card') }] },
});
/** Par emplacement : schéma dessiné et version courte de « ce qu'elle prouve » (panneau des preuves). */
export const CAPTURE_UI = Object.freeze({
  /* RedGalaxy : plus que la capture du profil (équipe) et le reçu (15 octobre 2026). */
  redgalaxy: { profile: ['rg-profile', t('propose.capture_ui.pilot')], receipts: ['receipt', t('propose.capture_ui.receipt')] },
  /* DarkOrbit : infos utilisateur, fiche d'outil et reçu, réservés à l'équipe (16 octobre 2026). */
  darkorbit: { user: ['do-user', t('propose.capture_ui.pilot')], 'tool-sheet': ['do-sheet', t('propose.capture_ui.account_sheet')], receipts: ['receipt', t('propose.capture_ui.receipt')] },
  /* Nova Horizon : plus que le reçu (15 octobre 2026). */
  novahorizon: { receipts: ['receipt', t('propose.capture_ui.receipt')] },
});
/** Emplacements qu'une analyse peut lire (écrans de CAPTURE_STEPS de fs-propose-import.js) ; les autres n'ont pas le
    bouton. Aucun depuis que plus aucun jeu n'a de capture publique (DarkOrbit, 16 octobre 2026). */
export const READABLE_SLOTS = Object.freeze({});

/* ---- grands nombres (spec 03 § 2.9, arbitrage 4) ---- */
/** Au-delà de ce seuil, le site propose un arrondi publié (sélectionné par défaut, l'exact reste possible). */
export const ROUND_THRESHOLD = 100_000;
/** Séparateur des milliers : U+00A0 (U+202F s'affiche sans largeur dans les champs avec certaines polices de repli). */
export const GROUP_SEPARATOR = ' ';
export const groupDigits = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEPARATOR);
/** Nombre affiché dans un texte : groupé comme avant en français (U+00A0), selon la langue de la page ailleurs (Intl).
    Les valeurs des champs et tout ce qui part au service gardent groupDigits. */
export const digits = (value) => (locale === 'fr' ? groupDigits(value) : number(Number(value)));

/* ---- prix souhaité (VEND-09, choix C9 du contrat prix-et-achat-direct) ---- */
/** Bornes du prix souhaité, en euros entiers : le net que le vendeur veut toucher. */
export const EXPECTED_NET_MIN = 1;
export const EXPECTED_NET_MAX = 10000;
/** Message sous le champ, présenté comme ceux du validateur (minuscule initiale, sans point final). */
export const EXPECTED_NET_ERROR = t('propose.price.error', { min: EXPECTED_NET_MIN, max: digits(EXPECTED_NET_MAX) });
/**
 * Saisie du prix souhaité → { amount: '120' } (chaîne d'entier, sans zéro de tête) ou { error }. Espaces (même
 * insécables) et « € » final tolérés ; décimales, signes, lettres et bornes dépassées refusés. Aucun calcul : le nombre
 * envoyé est celui saisi.
 */
export function parseExpectedNet(text) {
  const raw = String(text ?? '').replace(/\s+/g, '').replace(/€$/, '');
  if (!/^\d{1,6}$/.test(raw)) return { error: EXPECTED_NET_ERROR };
  const amount = Number(raw);
  return amount >= EXPECTED_NET_MIN && amount <= EXPECTED_NET_MAX ? { amount: String(amount) } : { error: EXPECTED_NET_ERROR };
}
/** Ligne du récapitulatif : « Prix souhaité : 1 200 € », le nombre saisi groupé, jamais recalculé. */
export const expectedNetSummary = (amount) => t('propose.price.summary', { amount: locale === 'fr' ? `${groupDigits(amount)}\u00a0€`
  : number(Number(amount), { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }) });
/** Au-delà de 8 options, une liste se résume par son nombre au récapitulatif (VEND-10). */
const LONG_LIST = 8;
const COUNT_NOUNS = Object.freeze({ ships: 'propose.list_summary.ships', notable_designs: 'propose.list_summary.designs' });
/**
 * Valeur d'un multichoix au récapitulatif (VEND-10) : « Aucun » de la liste (noneOption) ; une liste longue (vaisseaux,
 * designs…) par son nombre, jamais par ses noms (« 12 vaisseaux », « 8 designs », sinon « Nom : 5 ») ; une liste courte
 * par ses noms, 3 au plus. text : nom affiché d'une option.
 */
export function listSummary(field, value, { name = pick(field.label), text = (option) => option } = {}) {
  const list = Array.isArray(value) ? value : [];
  if (typeof field.noneOption === 'string' && list.length === 1 && list[0] === field.noneOption) return t('propose.list_summary.none', { name });
  if ((field.options?.length ?? 0) > LONG_LIST) return COUNT_NOUNS[field.key] ? t(COUNT_NOUNS[field.key], { count: list.length }) : t('propose.list_summary.total', { name, total: list.length });
  return t('propose.list_summary.items', { name, items: `${list.slice(0, 3).map(text).join(', ')}${list.length > 3 ? ` +${list.length - 3}` : ''}` });
}
/**
 * Textes qui parlent du prix, selon que le service annonce le prix souhaité (on) ou non (off : textes d'aujourd'hui).
 * card : pied de la carte de « Vérifier » ; done : jalon « Prix » de la frise du succès ({shots} : captures à envoyer).
 * Dans les deux cas, l'équipe fixe le prix final : c'est le point 4 des conditions de vente (VEND-11). Les
 * phrases sur les identifiants (VEND-12) ne parlent pas du prix : hors d'ici.
 */
export const PRICE_COPY = Object.freeze({
  off: Object.freeze({
    card: t('propose.price_copy.off_card'),
    /* {shots} : captures à envoyer dans le ticket (ticketShotsText). */
    done: t('propose.price_copy.off_done'),
    /* Sans ticket vendeur (SELLER_TICKETS=0) : aucun ticket à ouvrir soi-même, l'équipe écrit au vendeur. */
    follow: t('propose.price_copy.off_follow'),
  }),
  on: Object.freeze({
    card: t('propose.price_copy.on_card'),
    done: t('propose.price_copy.on_done'),
    follow: t('propose.price_copy.on_follow'),
  }),
});
/** Suivi d'une annonce sur le site : « Mes annonces » (fs-account.js ouvre le dialogue sur ce fragment), dans la langue
    de la page (/fr/#my-listings). */
export const LISTINGS_HREF = path('#my-listings');
/* ---- conditions de vente (VEND-11, décision 005) ---- */
/**
 * Version du texte des conditions acceptées, envoyée avec l'annonce (terms) ; dans la liste fermée du service. off
 * (vente-v5) : le vendeur ouvre lui-même son ticket Selling ; on (vente-v6) : le bot l'ouvre à l'envoi (/me →
 * features.sellerTickets, SELLER_TICKETS=1, MOD-02). Point 4 : l'équipe fixe le prix final (025-net-fixe-par-equipe).
 * Point 6 depuis vente-v5 (off) et vente-v6 (on), demande de Charles du 27 octobre 2026 : justificatifs de paiement et pièce
 * d'identité demandés par e-mail après la vente, le montant versé à réception. vente-v1 à vente-v4 ne sont plus affichées.
 */
export const TERMS_VERSIONS = Object.freeze({ off: 'vente-v5', on: 'vente-v6' });
/**
 * Succès avec le ticket vendeur annoncé (features.sellerTickets) mais sans son lien (ouverture pas finie en 3 s, Discord en
 * panne : le worker réessaie) : jamais la consigne d'ouvrir un ticket MEE6, qui doublerait le salon à venir.
 */
export const TICKET_PENDING_LEAD = t('propose.terms.ticket_pending');
/**
 * Version envoyée avec l'annonce : celle du texte affiché (data-fs-terms de la liste), jamais l'état du formulaire, que /me
 * peut changer avant que la liste soit réécrite. Hors de la liste fermée : '' (envoi sans terms, le service demande de
 * recharger la page).
 */
export const termsToSend = (shown) => (Object.values(TERMS_VERSIONS).includes(shown) ? shown : '');
/**
 * Écran de succès d'une annonce en relecture, d'après la RÉPONSE de POST /submissions (jamais l'état du formulaire :
 * l'interrupteur a pu changer depuis /me) : 'open' (lien du salon), 'pending' (ticket vendeur en cours d'ouverture,
 * ticketPending), sinon 'none' (suivi dans « Mes annonces », aucun ticket à ouvrir). `url` : lien du salon déjà vérifié.
 */
export const doneTicketView = (url, body) => (url ? 'open' : body?.ticketPending === true ? 'pending' : 'none');
/** Points 2 à 6, identiques dans les deux versions. */
const SALE_TERMS_REST = [
  [t('propose.terms.login_bold'), t('propose.terms.login')],
  [t('propose.terms.password_bold'), t('propose.terms.password')],
  [t('propose.terms.price_bold'), t('propose.terms.price')],
  [t('propose.terms.scam_bold'), t('propose.terms.scam')],
  [t('propose.terms.payout_bold'), t('propose.terms.payout')],
];
/**
 * Les six points de l'étape « Conditions de vente », identiques pour tous les jeux : [en gras, suite], par version (off,
 * on : TERMS_VERSIONS) ; seul le point 1 change. Une partie en gras qui finit une phrase garde l'espace qui la suit (fin de
 * phrase lisible telle quelle dans le code, comme sur la page).
 */
export const SALE_TERMS = Object.freeze(Object.fromEntries(Object.entries({
  off: [t('propose.terms.ticket_bold'), t('propose.terms.ticket_off')],
  on: [t('propose.terms.ticket_bold'), t('propose.terms.ticket_on')],
}).map(([key, first]) => [key, Object.freeze([first, ...SALE_TERMS_REST].map((point) => Object.freeze(point)))])));
/** Case de l'étape : acceptation du vendeur ; l'administrateur qui publie directement atteste ses vérifications (MOD-04). */
export const TERMS_COMMIT = Object.freeze({ seller: t('propose.terms.commit_seller'), admin: t('propose.terms.commit_admin') });
export const TERMS_FINE = t('propose.terms.fine');
/** 422 d'un service pas encore à jour (thème publié avant lui) : il ne connaît pas encore `terms` et le refuse seul. */
export const unknownTerms = (body) => Boolean(body?.errors) && Object.keys(body.errors).join() === '_' && /^champs inconnus : terms$/.test(String(body.errors._));
/**
 * POST /submissions : le corps tel quel ; si le service n'est pas encore à jour (422 « champs inconnus : terms », thème
 * publié quelques minutes avant lui), un seul renvoi, même corps sans terms. Toute autre réponse, et la réponse du renvoi,
 * sont rendues telles quelles. post(texte JSON) → { status, body }.
 */
export async function postSubmission(post, payload) {
  const response = await post(JSON.stringify(payload));
  if (response.status !== 422 || !payload.terms || !unknownTerms(response.body)) return response;
  const { terms, ...older } = payload;
  return post(JSON.stringify(older));
}
/**
 * Corps de POST /submissions : l'annonce validée (game, title, tags, values), puis captures, arrondis gardés et
 * annonce remplacée s'il y en a, ou annonce en vente modifiée (`amends`, VEND-16 ; jamais avec `replaces`) ; le prix souhaité (expectedNet) toujours HORS de values, en euros, seulement s'il est
 * valide ; la version des conditions de vente acceptées (terms, VEND-11) ; l'attestation d'un import AccInsight
 * (accountCheck). Sans eux, corps identique à celui d'avant.
 */
export function submissionPayload(listing, { media = [], rounded = [], replaces = '', amends = '', expectedNet = null, terms = '', accountCheck = '' } = {}) {
  return {
    game: listing.game, title: listing.title, tags: listing.tags, values: listing.values,
    ...(media.length ? { media } : {}), ...(rounded.length ? { rounded } : {}), ...(replaces ? { replaces } : amends ? { amends } : {}),
    ...(expectedNet?.amount ? { expectedNet: { amount: expectedNet.amount, currency: 'EUR' } } : {}),
    ...(terms ? { terms } : {}),
    /* Attestation signée d'un import AccInsight (DarkOrbit), vérifiée par le service, jamais dans values. */
    ...(accountCheck ? { accountCheck } : {}),
  };
}
/** Arrondi vers le bas à 3 chiffres significatifs (25 312 845 → 25 300 000) ; jamais vers le haut, sous le seuil inchangé. */
export function roundPublic(value) {
  if (!Number.isSafeInteger(value) || value <= ROUND_THRESHOLD) return value;
  const step = 10 ** (String(value).length - 3);
  return Math.floor(value / step) * step;
}
/** Champ entier sans borne ni unité ni jauge : arrondi proposé au-delà du seuil. */
export const roundable = (field) => field?.type === 'integer' && field.max === undefined && !field.ratioOf && !field.unit;
const SUFFIXES = { k: 1e3, m: 1e6, md: 1e9, mds: 1e9, b: 1e9 };
/**
 * Nombre saisi → entier, ou null s'il est illisible. Accepte les séparateurs de milliers (espaces, points, virgules,
 * apostrophes : « 1.294.504 », format RG) et les raccourcis k, M, Md (décimale seulement devant un raccourci).
 */
export function parseNumber(raw) {
  const text = String(raw ?? '').replace(/[\s  '’]/g, '').toLowerCase();
  if (!text) return null;
  const short = /^(\d{1,12}(?:[.,]\d{1,3})?)(k|m|md|mds|b)$/.exec(text);
  let value = null;
  if (short) value = Math.round(Number(short[1].replace(',', '.')) * SUFFIXES[short[2]]);
  else if (/^\d{1,3}(?:([.,])\d{3})(?:\1\d{3})*$/.test(text)) value = Number(text.replace(/[.,]/g, ''));
  else if (/^\d{1,15}$/.test(text)) value = Number(text);
  return Number.isSafeInteger(value) ? value : null;
}

/* ---- titre et étiquettes suggérés (spec 03 § 5.6) ---- */
const DO_GATES = Object.freeze(['alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'kappa', 'lambda', 'kuiper', 'hades', 'kronos']);
const alpha = (label) => String(label).replace(/-a$/, '-α');
const shortMillions = (value) => `${Math.floor(value / 1e5) / 10}`.replace('.', ',') + ' M';
/**
 * Étiquettes suggérées par des règles vérifiables, 6 au plus : [{ tag, reason }]. Jamais cochées par le site (spec 21
 * § 3.4) : le vendeur les coche d'un clic. Starter ACC disparaît dès qu'une étiquette Full ou Monster est cochée.
 */
export function suggestTags(template, values = {}, { slots = [], checked = [] } = {}) {
  const v = values || {};
  const noneOf = (key) => (template?.sections || []).flatMap((section) => section.fields).find((field) => field.key === key)?.noneOption;
  const ships = Array.isArray(v.ships) ? v.ships : [];
  const big = (Array.isArray(checked) ? checked : []).some((tag) => /^(full|monster)\b/i.test(tag));
  const rules = {
    waruniverse: [
      ['FULL DCS', v.dcs === 8, t('propose.tag_reasons.full', { amount: '8/8', name: 'DCS' })], ['FULL DCH', v.dch === 8, t('propose.tag_reasons.full', { amount: '8/8', name: 'DCH' })],
      ['FULL LG4', v.lg4 >= 40, t('propose.tag_reasons.full', { amount: v.lg4, name: 'LG4' })],
      ['Hyp-J', ships.includes('Hyperion-J'), t('propose.tag_reasons.ship_checked', { name: 'Hyperion-J' })], ['a-designs', ships.some((ship) => /-a$/.test(ship)), t('propose.tag_reasons.alpha_design')],
      /* « Aucun » (noneOption, VEND-04) n'est pas un autre serveur. */
      ['MULTI SERVER', slots.includes('second-server') || (Array.isArray(v.other_servers) && v.other_servers.some((server) => server !== noneOf('other_servers'))), t('propose.tag_reasons.other_server')],
      ['Starter ACC', Number.isInteger(v.lg4) && v.lg4 <= 10 && !big && !(v.dcs === 8 || v.dch === 8 || v.lg4 >= 40), t('propose.tag_reasons.starter')],
    ],
    redgalaxy: [
      ['Striker', v.striker_design > 0, t('propose.tag_reasons.design', { name: 'Striker' })], ['Bastion', v.bastion_design > 0, t('propose.tag_reasons.design', { name: 'Bastion' })],
      ['Yellow', v.yellow_design > 0, t('propose.tag_reasons.design', { name: 'Yellow' })],
      ['Special Design', ships.some((ship) => / (Inferno|Crimson|Sentinel|Anarchy|Halloween)$/.test(ship)), t('propose.tag_reasons.design_variant')],
      ['Full Research', v.full_research === true, t('propose.tag_reasons.full_research')],
    ],
    darkorbit: [['Full Havoc', v.havoc === 10, t('propose.tag_reasons.full', { amount: '10/10', name: 'Havoc' })],
      ['Full Hercules', v.hercules === 10, t('propose.tag_reasons.full', { amount: '10/10', name: 'Hercules' })],
      /* Les 11 portes galactiques terminées au moins une fois (VEND-04 : 0 pour une porte jamais faite). */
      ['Full Galaxy Gates', DO_GATES.every((key) => v[key] > 0), t('propose.tag_reasons.full_gates')]],
    novahorizon: [
      ['Full Wingman', v.wingman === 10, t('propose.tag_reasons.full', { amount: '10/10', name: 'Wingman' })],
      ['Wingman Lvl 8', v.wingman_level === 8, t('propose.tag_reasons.wingman_level', { level: 8 })],
      ['Full Labs', v.full_labs === true, t('propose.tag_reasons.full_labs')],
    ],
  }[template?.game] || [];
  return rules.filter(([tag, ok]) => ok && template.tags.includes(tag)).slice(0, 6).map(([tag, , reason]) => ({ tag, reason }));
}
/** Marqueurs à ajouter au titre (« Ajouter au titre : … »), d'après les valeurs ; le thème retire ceux déjà présents. */
export function titleMarkers(template, values = {}, pack = null) {
  const v = values || {};
  const ships = Array.isArray(v.ships) ? v.ships : [];
  const out = [];
  if (template?.game === 'waruniverse') {
    const alphas = ships.filter((ship) => /-a$/.test(ship));
    if (alphas.length === 3) out.push('Full a Design'); else out.push(...alphas.map(alpha));
    out.push(...ships.filter((ship) => /^Hyperion-[JGVλ]$/.test(ship)));
    if (v.dcd > 0) out.push(`${v.dcd}/5 DCD 🔴`);
    if (v.lg3 > 0) out.push(`${v.lg3} LG3`);
    if (v.mrs_6x >= 1_000_000) out.push(`${shortMillions(v.mrs_6x)} MRS`);
  } else if (template?.game === 'redgalaxy') {
    if (v.striker_design > 0 && v.bastion_design > 0) out.push('Full Striker & Bastion');
    out.push(...ships.filter((ship) => / (Inferno|Crimson|Sentinel|Anarchy|Halloween)$/.test(ship)));
    if (v.full_research === true) out.push('Full Research');
  } else if (template?.game === 'darkorbit') {
    if (v.havoc === 10) out.push('Full Havoc');
    if (v.hercules === 10) out.push('Full Hercules');
    out.push(...chosenDesigns(pack, ships).filter((design) => design.tier !== 'standard').slice(0, 2).map((design) => design.label));
  } else if (template?.game === 'novahorizon') {
    if (ships.includes('Revenant Magma')) out.push('Revenant Magma');
    if (v.wingman_level > 0) out.push(`Wingman Lvl ${v.wingman_level}`);
  }
  return [...new Set(out)].slice(0, 8);
}

/* ---- WarUniverse : Star Missions et enrichissements, widgets du thème sérialisés en texte (spec 21 § 6, B.1) ---- */
const MISSION_NAMES = ['Protos', 'Zeta', 'East', 'Kratos', 'Futurium'];
/** { Protos: '2', … } → « Protos x2, Zeta x1 », ou « All x2 » si les 5 missions sont au même nombre, ou « None » si
    aucune n'est faite (VEND-04 : la réponse est obligatoire, « None » la publie). Au plus x2 : x3 n'existe pas en jeu
    (VEND-07), un ancien « 3 » est ramené à 2. */
export function serializeStarMissions(runs = {}) {
  const count = Object.fromEntries(MISSION_NAMES.map((name) => [name, Math.min(2, Number(runs[name]) || 0)]));
  const done = MISSION_NAMES.filter((name) => count[name] > 0);
  if (!done.length) return 'None';
  if (done.length === MISSION_NAMES.length && new Set(done.map((name) => count[name])).size === 1) return `All x${count[done[0]]}`;
  return done.map((name) => `${name} x${count[name]}`).join(', ');
}
/** Relecture : { Protos: '2', … } (missions absentes : pas faites), un ancien « x3 » ou « x3+ » ramené à « 2 », « None » :
    aucune ; null si le texte n'est pas de cette forme (il reste alors en « Autre formulation »). */
export function parseStarMissions(text) {
  if (/^\s*none\s*$/i.test(String(text ?? ''))) return {};
  const runs = {};
  const parts = String(text ?? '').split(/\s*[,;·]\s*/).map((part) => part.trim()).filter(Boolean);
  for (const part of parts) {
    const match = /^(all|protos|zeta|east|kratos|futurium)\s*x\s*(\d{1,2})\s*\+?$/i.exec(part);
    if (!match) return null;
    const count = String(Math.min(2, Number(match[2])));
    if (count === '0') continue;
    const names = match[1].toLowerCase() === 'all' ? MISSION_NAMES : [MISSION_NAMES.find((name) => name.toLowerCase() === match[1].toLowerCase())];
    for (const name of names) runs[name] = count;
  }
  return runs;
}
const ENRICHMENT_PARTS = [['laser', 'Laser', 'shots'], ['rockets', 'Rockets', 'shots'], ['shield', 'Shield', 'min'], ['speed', 'Speed', 'min']];
/** { laser: 44274, … } → « Laser 44 274 shots · Rockets 46 202 shots · Shield 300 min · Speed 436 501 min » (parties vides omises). */
export function serializeEnrichments(parts = {}) {
  return ENRICHMENT_PARTS.filter(([key]) => Number.isInteger(parts[key]) && parts[key] >= 0)
    .map(([key, name, unit]) => `${name} ${groupDigits(parts[key])} ${unit}`).join(' · ');
}
/** Relecture : { laser: 44274, … } ; null si une partie n'est pas reconnue. */
export function parseEnrichments(text) {
  const parts = {};
  for (const part of String(text ?? '').split(/\s*[·;,|]\s*(?=[a-z])/i).map((item) => item.trim()).filter(Boolean)) {
    const match = /^(laser|lasers|rockets?|shield|speed)\s*:?\s*([\d\s\u00a0\u202f.]+?)\s*(shots?|min)?$/i.exec(part);
    if (!match) return null;
    const key = { laser: 'laser', lasers: 'laser', rocket: 'rockets', rockets: 'rockets', shield: 'shield', speed: 'speed' }[match[1].toLowerCase()];
    const number = Number(match[2].replace(/\D/g, ''));
    if (!Number.isSafeInteger(number)) return null;
    parts[key] = number;
  }
  return parts;
}

/* ---- captures : textes du parcours (spec 03 § 4.3, contrat 05) ---- */
export const LEVEL_NAMES = Object.freeze({ required: t('propose.levels.required'), recommended: t('propose.levels.recommended'), bonus: t('propose.levels.bonus') });
export const SHOT_TEXT = Object.freeze({
  public: t('propose.shot.public'),
  staff: t('propose.shot.staff'),
  ticket: t('propose.shot.ticket'),
  preparing: t('propose.shot.preparing'),
  readyOffline: t('propose.shot.ready_offline'),
  readyQueued: t('propose.shot.ready_queued'),
  sent: t('propose.shot.sent'),
  lost: t('propose.shot.lost'),
  off: t('propose.shot.off'),
  early: t('propose.shot.early'),
  format: t('propose.shot.format'),
  unreadable: t('propose.shot.unreadable'),
  limit: t('propose.shot.limit'),
  privacy: t('propose.shot.privacy'),
});
/** Poids lisible : « 412 Ko », « 3,2 Mo ». */
export const sizeText = (bytes) => (bytes >= 1024 * 1024
  ? t('propose.size.mb', { size: locale === 'fr' ? (bytes / 1024 / 1024).toFixed(1).replace('.', ',') : number(bytes / 1024 / 1024, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) })
  : t('propose.size.kb', { size: digits(Math.max(1, Math.round(bytes / 1024))) }));
/** Identifiant opaque d'une capture envoyée (contrat 05 § 6.2) : seul ce texte est gardé dans le brouillon. */
export const MEDIA_REF = /^[A-Za-z0-9._-]{8,1024}$/;
/** Captures publiques par annonce (contrat 05 : 12 au plus). */
const MAX_SHOTS = 12;

/* ---- préremplissage : « Corriger et renvoyer » (spec 08 § 5.1, contrat 09 § 9.2) ---- */
/** Référence d'une soumission à corriger (?resubmit=<ref>) : partie numérique du GID, sinon ''. */
export const correctionRef = (search) => {
  try { const ref = (new URLSearchParams(String(search || '')).get('resubmit') ?? new URLSearchParams(String(search || '')).get('corriger')) || ''; return /^\d{1,20}$/.test(ref) ? ref : ''; } catch { return ''; }
};
/** « Modifier » une annonce en vente (?edit=<ref>, VEND-16) : référence de la soumission publiée, sinon ''. */
export const editRef = (search) => {
  try { const ref = (new URLSearchParams(String(search || '')).get('edit') ?? new URLSearchParams(String(search || '')).get('modifier')) || ''; return /^\d{1,20}$/.test(ref) ? ref : ''; } catch { return ''; }
};
/**
 * Net en vigueur (expectedNet { minor } de GET /submissions/:ref/edit) → saisie du « Prix souhaité », en euros entiers.
 * Mise en forme seulement : les centimes sont retirés du texte, jamais calculés ; un net avec centimes laisse le champ vide.
 */
export function netField(expectedNet) {
  const text = Number.isSafeInteger(expectedNet?.minor) && expectedNet.minor > 0 ? String(expectedNet.minor) : '';
  return /^[1-9]\d*00$/.test(text) ? text.slice(0, -2) : '';
}
/**
 * Mode du brouillon de l'onglet (« Modifier » ou « Corriger et renvoyer ») : gardé avec lui (sessionStorage MODE_KEY)
 * jusqu'à l'envoi ou l'abandon, pour qu'un rechargement ou une reprise envoie toujours `amends` ou `replaces` (jamais une
 * seconde annonce). Seuls le genre, la référence, le jeu et de quoi refaire le bandeau sont gardés, avec l'identifiant du
 * brouillon (`draft`) et le compte (`user`) auxquels il est lié.
 */
export const MODE_KEY = 'fs-propose-mode';
const MODE_REF = /^\d{1,20}$/;
/** Identifiant d'un brouillon prérempli, neuf à chaque préremplissage (jamais repris d'un brouillon effacé). */
export const DRAFT_ID = /^[0-9a-f]{16,32}$/;
const MODE_USER = /^[A-Za-z0-9_-]{1,80}$/;
/**
 * Compte Discord (sub) d'une session, lu sans vérification dans la charge du jeton (comme sessionSub de fs-admin-api.js) :
 * clé d'état d'interface seulement, jamais un droit. '' si le jeton est absent ou illisible.
 */
export function sessionUser(token) {
  try {
    const part = String(token ?? '').split('.')[1] ?? '';
    const sub = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '='))).sub;
    return typeof sub === 'string' && MODE_USER.test(sub) ? sub : '';
  } catch { return ''; }
}
/**
 * Contexte d'une modification ou d'une correction (mode, brouillon lié, compte) ouvert par un autre compte que celui de la
 * session : rend le jeu du brouillon lié à retirer avec le mode ('' si ce brouillon n'est plus là), null si le contexte
 * appartient à ce compte, ou si aucun compte n'est encore connu (vérifié à la connexion).
 */
export function foreignContext(mode, drafts, user) {
  if (!mode || !user || !mode.user || mode.user === user) return null;
  return DRAFT_ID.test(mode.draft ?? '') && drafts?.[mode.game]?.id === mode.draft ? mode.game : '';
}
/**
 * Le mode gardé vaut-il pour ce brouillon et ce compte ? Oui seulement si le brouillon de son jeu porte le même identifiant
 * (un brouillon effacé puis recommencé n'en a plus) et, une session étant connue, si elle est celle du même compte.
 */
export function modeBound(mode, drafts, user = '') {
  return Boolean(mode && DRAFT_ID.test(mode.draft ?? '') && drafts?.[mode.game]?.id === mode.draft && (!user || mode.user === user));
}
const MODE_TARGET = /^(?:title|tags|section:[a-z_]{2,32}|slot:[a-z][a-z0-9_-]{1,31})$/;
/** Mode actif (chargé, pas en attente) → texte à garder, '' sinon. */
export function serializeMode(correction) {
  if (!correction || correction.pending || !['edit', 'fix'].includes(correction.kind) || !MODE_REF.test(correction.ref ?? '') || typeof correction.game !== 'string') return '';
  const text = (value, max) => (typeof value === 'string' ? value.slice(0, max) : '');
  const reason = correction.reason && typeof correction.reason === 'object' ? { label: text(correction.reason.label, 80), text: text(correction.reason.text, 500), advice: text(correction.reason.advice, 300) } : null;
  if (!DRAFT_ID.test(correction.draft ?? '') || !MODE_USER.test(correction.user ?? '')) return '';
  return JSON.stringify({ kind: correction.kind, ref: correction.ref, game: correction.game, draft: correction.draft, user: correction.user,
    ...(correction.kind === 'edit' ? { reference: text(correction.reference, 20), locked: (correction.locked || []).filter((key) => /^[a-z][a-z0-9_]{0,59}$/.test(key)).slice(0, 10) }
      : { targets: (correction.targets || []).filter((target) => MODE_TARGET.test(target)).slice(0, 24), ...(reason ? { reason } : {}) }) });
}
/** Texte gardé → mode { kind, ref, game, … } d'un jeu connu, ou null s'il est illisible. */
export function readMode(raw, games = []) {
  let data;
  try { data = JSON.parse(raw || 'null'); } catch { return null; }
  if (!data || typeof data !== 'object' || !['edit', 'fix'].includes(data.kind) || !MODE_REF.test(data.ref ?? '') || !games.includes(data.game)
    || !DRAFT_ID.test(data.draft ?? '') || !MODE_USER.test(data.user ?? '')) return null;
  const text = (value, max) => (typeof value === 'string' ? value.slice(0, max) : '');
  const bound = { draft: data.draft, user: data.user };
  return data.kind === 'edit'
    ? { kind: 'edit', ref: data.ref, game: data.game, ...bound, reference: /^SITE-[0-9A-F]{8}$/.test(data.reference ?? '') ? data.reference : '', locked: Array.isArray(data.locked) ? data.locked.filter((key) => /^[a-z][a-z0-9_]{0,59}$/.test(key)).slice(0, 10) : [], targets: [] }
    : { kind: 'fix', ref: data.ref, game: data.game, ...bound, targets: Array.isArray(data.targets) ? data.targets.filter((target) => MODE_TARGET.test(target)).slice(0, 24) : [],
      reason: data.reason && typeof data.reason === 'object' ? { label: text(data.reason.label, 80), text: text(data.reason.text, 500), advice: text(data.reason.advice, 300) } : null };
}
/** Refus de GET /submissions/:ref/edit → phrase du bandeau (l'annonce n'est pas modifiable, ou pas maintenant). */
export function editLoadMessage(status, body) {
  if (status === 0) return t('propose.edit_load.no_response');
  if (body?.error === 'edit_pending') return t('propose.edit_load.pending');
  if (body?.error === 'edit_unavailable' || status === 503) return t('propose.edit_load.unavailable');
  if (status === 409) return t('propose.edit_load.locked');
  return t('propose.edit_load.not_found');
}

/** Étape où reprendre selon les éléments visés par le refus (title, tags, section:<id>, slot:<id>) ; sinon « verifier ». */
export function correctionStep(template, targets = []) {
  const game = template?.game;
  for (const target of Array.isArray(targets) ? targets : []) {
    if (target === 'title' || target === 'tags') return 'titre';
    const slot = /^slot:([a-z][a-z0-9_-]{1,31})$/.exec(target)?.[1];
    if (slot && stepOfSlot(game, slot)) return stepOfSlot(game, slot);
    const section = /^section:([a-z_]{2,32})$/.exec(target)?.[1];
    const keys = (template?.sections || []).find((entry) => entry.id === section)?.fields.map((field) => field.key) || [];
    const step = keys.map((key) => stepOfKey(game, key)).find(Boolean);
    if (step) return step;
  }
  return 'verifier';
}
/**
 * Brouillon v4 prérempli depuis des valeurs données (annonce à corriger ou à modifier, ou toute autre source) : titre et
 * étiquettes gardés tels quels, captures déjà envoyées reprises par leur identifiant (jamais d'image), toutes les étapes vues,
 * prix souhaité en vigueur (`price`, saisie en euros) pour une modification.
 * Le résultat passe par la même garde que le stockage (cleanDraft).
 */
export function prefilledDraft(game, { title = '', tags = [], values = {}, media = [], rounded = [] } = {}, { step = 'verifier', price = '', id = '' } = {}) {
  const captures = Object.fromEntries((Array.isArray(media) ? media : []).filter((item) => typeof item?.slot === 'string' && typeof item?.id === 'string')
    .map((item) => [item.slot, { state: 'uploaded', ref: item.id }]));
  /* Les valeurs reçues sont celles publiées : un champ que le vendeur n'avait pas arrondi garde son chiffre exact. */
  const kept = new Set(Array.isArray(rounded) ? rounded : []);
  const rounding = Object.fromEntries(Object.keys(values && typeof values === 'object' ? values : {}).filter((key) => !kept.has(key)).map((key) => [key, 'exact']));
  return cleanDraft({ title, tags, values, captures, rounding, step, visited: stepIds(game), titleEdited: true, tagsSeen: true, ...(price ? { price } : {}), ...(id ? { id } : {}) }, game);
}

/* ------------------------------------------------------------------ interface */

const tabStore = {
  get(key) { try { return window.sessionStorage.getItem(key); } catch { return null; } },
  set(key, value) { try { window.sessionStorage.setItem(key, value); return true; } catch { return false; } },
  remove(key) { try { window.sessionStorage.removeItem(key); } catch { /* stockage indisponible */ } },
};
/** Stockage en mémoire de la modification par l'équipe : jamais le brouillon ni le mode du vendeur de l'onglet. */
const memoryStore = () => {
  const data = new Map();
  return { get: (key) => data.get(key) ?? null, set: (key, value) => { data.set(key, String(value)); return true; }, remove: (key) => { data.delete(key); } };
};

/** Logo Discord (masque CSS de fs-components.css), décoratif. */
const discordIcon = () => h('span', { class: 'fs-discord-icon', 'aria-hidden': 'true' });

const ASSET = /^(?:\/|https:\/\/|http:\/\/(?:127\.0\.0\.1|localhost)[:/])/;
const GAUGE_COLORS = { '🔵': 'var(--fs-gauge-blue)', '🟡': 'var(--fs-gauge-yellow)', '🔴': 'var(--fs-gauge-red)' };
const UNITS = { Days: t('propose.fields.unit_days') };
const plural = (count, one, many) => `${count} ${count > 1 ? many : one}`;

/*
 * `admin` (modification d'une annonce par l'équipe depuis sa fiche, fs-listing-admin.js) : { handle, reference, mode
 * 'direct' | 'review', scroller, onSaved(result), onBusy(busy), text, labels, errorText(status, body), reasonError(text),
 * variant? 'takeoverNew' | 'takeover' (reprise d'une annonce venue de Discord), captures? false, note? }
 * (textes de l'espace équipe fournis par la fiche : ce script du formulaire reste sans texte écrit en dur, comme les
 * autres langues l'exigent). Le même parcours, dans une fenêtre modale : ni choix du
 * jeu, ni accueil, ni connexion, ni conditions de vente ; rien dans le stockage de l'onglet ni dans l'historique ; la
 * dernière étape « Vérifier » demande un motif et enregistre (routes /admin/listings/:handle/edit et …/price). Rend alors
 * { load(data, price) } ; sans `admin`, rien (parcours du vendeur inchangé).
 */
function initialise(root, { admin = null } = {}) {
  if (root.dataset.fsProposeReady) return null;
  root.dataset.fsProposeReady = 'true';
  const store = admin ? memoryStore() : tabStore;
  /* Bloc retiré de la page, ou fenêtre de l'équipe déjà fermée (son évènement « close », qui le retire, arrive plus tard). */
  const detached = () => !root.isConnected || root.closest('dialog')?.open === false;
  const demo = root.closest('[data-fs-demo]') || document;
  const section = root.closest('#sell');
  const service = serviceBase(root.dataset.fsService);
  if (!service) return;
  const $ = (selector) => root.querySelector(selector);
  const radios = [...root.querySelectorAll('[data-fs-propose-game]')];
  const games = radios.map((radio) => radio.value);
  const names = Object.fromEntries(radios.map((radio) => [radio.value, radio.closest('label')?.querySelector('.fs-propose-game-name')?.textContent.trim() || radio.closest('label')?.textContent.trim() || radio.value]));
  const ui = {
    console: $('[data-fs-propose-console]'), current: $('[data-fs-propose-current]'), change: $('[data-fs-propose-change]'), chooser: $('[data-fs-propose-chooser]'),
    note: $('[data-fs-propose-game-note]'), badge: $('[data-fs-propose-badge]'), credits: $('[data-fs-propose-credits]'), saved: $('[data-fs-propose-saved]'),
    rail: $('[data-fs-propose-rail]'), banners: $('[data-fs-propose-banners]'), authError: $('[data-fs-propose-auth-error]'), status: $('[data-fs-propose-form-status]'),
    slot: $('[data-fs-propose-form-slot]'),
  };
  const reduced = () => document.documentElement.dataset.fsMotion === 'reduced' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Défilement voulu par un clic : animé hors mouvement réduit ; sinon (chargement, retour, correction) instantané. */
  const motion = (clicked) => (clicked && !reduced() ? 'smooth' : 'instant');
  /* Aucun jeu d'office : la restauration de formulaire du navigateur ne doit pas cocher un jeu à la place du visiteur. */
  radios.forEach((radio) => { radio.checked = false; });
  const state = {
    game: '', session: null, me: null, lib: null, loading: null, importUi: null, importLoading: null, account: undefined, accountLoading: null, mediaLib: null, mediaLoading: null,
    drafts: {}, restored: new Set(), chooser: true, view: 'chooser', form: null, welcome: null, done: null, step: FIRST_STEP, visited: new Set(), skipped: new Set(), imported: new Set(), revealed: new Set(), importSkip: new Set(),
    editing: false, errorSteps: new Set(), titleEdited: false, tagsSeen: false, rounding: {}, partial: {}, other: {}, busy: false, sending: '',
    /* Captures en mémoire par jeu : { <jeu>: { <slot>: entrée } } ; jamais stockées (seuls les identifiants envoyés vont au brouillon). */
    media: {}, mediaInfo: { enabled: null }, analysis: null, uploading: false, reads: {}, readKeys: new Set(), pendingLogin: false, join: false, afterLogin: null,
    landing: false, returned: false, panel: null,
    /* « Corriger et renvoyer » : { ref, pending, kind: 'fix', reason, targets } tant que l'annonce corrigée n'est pas renvoyée ;
       « Modifier » (VEND-16) : { ref, pending, kind: 'edit', reference, locked } tant que la modification n'est pas envoyée. */
    correction: null,
    /* Prix souhaité (VEND-09) : prices = le service l'annonce (/me, session connue) ; price = saisie gardée hors du DOM. */
    prices: false, price: '',
    /* Ticket vendeur ouvert par le bot à l'envoi (/me → features.sellerTickets) : conditions vente-v6 au lieu de vente-v5. */
    sellerTickets: false,
  };

  /* ---- pack du jeu : icônes, vaisseaux, designs, fond et emblème. Lu dans le JSON #fs-game-pack-<jeu> s'il est déjà
     dans la page, sinon dans son <template data-fs-pack-template> (contenu inerte : rien n'est injecté ni téléchargé,
     la page ne change pas d'habillage). Absent → icônes génériques, cadre FOR SALE inchangé. ---- */
  const packs = {};
  const packOf = (game) => {
    if (!game) return null;
    if (packs[game] !== undefined) return packs[game];
    const script = document.getElementById(`fs-game-pack-${game}`)
      || demo.querySelector?.(`template[data-fs-pack-template="${CSS.escape(game)}"]`)?.content.querySelector(`#fs-game-pack-${CSS.escape(game)}`);
    if (!script) return null;
    packs[game] = readPack(script.textContent, game);
    return packs[game];
  };
  const iconImage = (icon, size, extra = '') => (icon ? h('img', { class: `fs-propose-icon${extra ? ` ${extra}` : ''}`, src: icon.url, alt: '', width: size, height: size, loading: 'lazy', decoding: 'async' }) : null);
  const slotIcon = (icon, size = 28) => (icon ? h('span', { class: 'fs-propose-slot', 'aria-hidden': 'true' }, iconImage(icon, size)) : null);
  const packKeyIcon = (key) => { const pack = packOf(state.game); return pack?.icons[key] ? { key, ...pack.icons[key] } : null; };
  /** Nom affiché d'une option (optionLabels du modèle : FR officiel) ; la valeur envoyée reste l'option. */
  /* Libellé du glossaire (field.i18n.options, intl-glossaire) dans toutes les langues ; sans lui, optionLabels (français) en français, sinon le nom officiel. */
  const optionLabel = (field, option) => {
    const glossary = field?.i18n?.options?.[option];
    if (glossary && typeof glossary === 'object') return pick(glossary) ?? option;
    if (locale !== 'fr') return option;
    return typeof state.lib?.optionLabel === 'function' ? state.lib.optionLabel(field, option) : option;
  };

  /* ---- session (compte du site : fs-account.js) ---- */
  const account = window.FSAccount && window.FSAccount.service === service ? window.FSAccount : null;
  const readSession = () => {
    if (account) return account.session();
    try {
      const saved = JSON.parse(store.get(SESSION_KEY) || 'null');
      if (saved && typeof saved.token === 'string' && TOKEN.test(saved.token) && saved.exp > Date.now()) return saved;
    } catch { /* illisible */ }
    store.remove(SESSION_KEY);
    return null;
  };
  /* Jeton renouvelé par fs-account.js (même connexion, key) : repris ici sans rien relire. */
  const live = () => {
    const next = account && state.session ? account.session() : null;
    if (next && next.token !== state.session.token && next.key !== undefined && next.key === state.session.key) {
      if (state.loggedToken === state.session.token) state.loggedToken = next.token;
      state.session = next;
    }
    return state.session;
  };
  const token = () => { const session = live(); return session && session.exp > Date.now() ? session.token : null; };
  let expiryTimer = 0;
  const dropSession = () => { store.remove(SESSION_KEY); state.session = null; state.me = null; clearTimeout(expiryTimer); };
  const armExpiry = () => {
    clearTimeout(expiryTimer);
    if (!state.session) return;
    expiryTimer = setTimeout(() => {
      if (live() && state.session.exp > Date.now() + 1000) { armExpiry(); return; }
      dropSession(); showAuthError(t('propose.session.expired')); refreshAll();
    }, Math.max(0, Math.min(state.session.exp - Date.now(), SESSION_MAX_MS)));
  };

  /* ---- retour de Discord (redirection) : code déposé par le script en ligne, ou lu ici en repli puis effacé ---- */
  let fragment = { present: false, code: null, error: null };
  if (!account) try {
    const early = JSON.parse(store.get(RETURN_KEY) || 'null');
    if (early && typeof early === 'object') fragment = { present: true, code: typeof early.code === 'string' && CODE.test(early.code) ? early.code : null, error: early.error ?? null };
  } catch { /* illisible */ }
  if (!account) store.remove(RETURN_KEY);
  if (!fragment.present && !account) fragment = parseFragment(window.location.hash);
  if (!admin && /(?:^|[#&])fs_(?:code|error|session)=/.test(window.location.hash)) {
    try { history.replaceState(history.state, '', `${window.location.pathname}${window.location.search}`); } catch { /* adresse inchangée */ }
  }
  const nonce = account ? null : store.get(NONCE_KEY);
  if (fragment.present) store.remove(NONCE_KEY);
  let authError = '';
  if (fragment.present && !fragment.code) authError = fragment.error ? authErrorMessage(fragment.error) : t('propose.common.login_expired');
  else if (fragment.code && !nonce) { authError = t('propose.common.login_expired'); fragment.code = null; }
  if (fragment.code) store.remove(SESSION_KEY);
  /* Modification par l'équipe : la session est celle de la fiche, déjà ouverte (aucun retour de Discord à attendre ici). */
  const returning = admin ? null : account?.returning ?? null;
  /* Retour de Discord encore en cours (code pas encore échangé) : vrai jusqu'à la fin de returning.promise. */
  let returnPending = Boolean(returning);
  state.session = fragment.code || returning ? null : readSession();
  /* Connexion lancée depuis une fiche (ticket, décision 012) : ce bloc ne prend ni le défilement ni le focus. */
  const forTicket = fragment.present && freshTicketIntent(store.get(TICKET_INTENT_KEY));
  const announce = (detail) => {
    window.FSAuthOutcome = Object.freeze({ ...detail, at: Date.now() });
    document.dispatchEvent(new CustomEvent('fs:session', { detail }));
  };
  /* Brouillons de l'onglet : relus au rechargement et au retour de Discord ; jamais effacés au départ. */
  /* Brouillons des jeux fermés à la vente (VEND-01) : copiés à part avant toute réécriture ; repris à la réouverture. */
  const closedDrafts = holdClosedDrafts(store.get(DRAFT_KEY), store.get(CLOSED_DRAFT_KEY), games);
  if (closedDrafts.held) store.set(CLOSED_DRAFT_KEY, closedDrafts.held); else store.remove(CLOSED_DRAFT_KEY);
  if (closedDrafts.restore) store.set(DRAFT_KEY, closedDrafts.restore);
  const savedDrafts = readDraftStore(store.get(DRAFT_KEY), games);
  /* Ancien brouillon multi-jeux : réécrit tout de suite avec le seul jeu du brouillon (spec 21 § 3.1, point 5). */
  if (store.get(DRAFT_KEY) && savedDrafts.game) store.set(DRAFT_KEY, serializeDraftStore(savedDrafts.game, savedDrafts.drafts));
  state.drafts = { ...savedDrafts.drafts };
  Object.keys(state.drafts).forEach((game) => state.restored.add(game));
  /* Lien #fs_import (entrée retirée) : jamais lu. Le snippet l'a effacé et posé le marqueur « ! » ; message neutre. */
  const importLink = !admin && (Boolean(store.get(IMPORT_RETURN_KEY)) || /(?:^|[#&])fs_import=/.test(window.location.hash));
  store.remove(IMPORT_RETURN_KEY);
  store.remove(IMPORT_KEY);
  if (!admin && /(?:^|[#&])fs_import=/.test(window.location.hash)) {
    try { history.replaceState(history.state, '', `${window.location.pathname}${window.location.search}`); } catch { /* adresse inchangée */ }
  }
  /* Jeu de départ, sans jamais en imposer un : jeu du brouillon s'il y a une saisie (retour de connexion compris) ;
     sinon ?game=<jeu>, puis l'écran du jeu actif. Rien → le visiteur choisit. Un ?game= différent du brouillon
     demande ensuite la confirmation du changement de jeu, jamais d'effacement silencieux. */
  /* « Corriger et renvoyer » (?resubmit=<ref>#sell) : gardé dans l'onglet le temps de la connexion, lu ensuite. */
  const CORRECT_KEY = 'fs-propose-correct';
  /* « Modifier » une annonce en vente (?edit=<ref>#sell, VEND-16) : même mécanisme, état `kind: 'edit'`. */
  const EDIT_KEY = 'fs-propose-edit';
  const dropKeys = () => { store.remove(CORRECT_KEY); store.remove(EDIT_KEY); };
  /* Mode du brouillon gardé (rechargement, reprise) : seulement si son brouillon est encore là. */
  const currentUser = () => sessionUser((account ? account.session() : state.session)?.token);
  /* Lu lié à son brouillon seulement : son compte est vérifié juste après (enforceAccount), brouillon compris. */
  let savedMode = (() => { const mode = readMode(store.get(MODE_KEY), games); return modeBound(mode, savedDrafts.drafts) ? mode : null; })();
  if (!savedMode) store.remove(MODE_KEY);
  /** Mode actif écrit avec le brouillon ; aucun mode : la clé est retirée. */
  const keepMode = () => { const value = serializeMode(state.correction); if (value) store.set(MODE_KEY, value); else store.remove(MODE_KEY); };
  /** Abandon de la modification ou de la correction (envoi, déconnexion, effacement, autre jeu) : mode et clés oubliés. */
  const forgetMode = () => { state.correction = null; savedMode = null; dropKeys(); store.remove(MODE_KEY); root.querySelector('[data-fs-propose-banner="correction"]')?.remove(); };
  /** Brouillon prérempli effacé ou recommencé, même pendant le chargement d'un autre lien : le mode gardé ne vaut plus. */
  const unbindMode = () => { savedMode = null; store.remove(MODE_KEY); if (state.correction && !state.correction.pending) forgetMode(); };
  /** Mode gardé, rendu au brouillon qu'il accompagne (lien illisible ou « Garder mon brouillon »). */
  const restoreMode = () => { state.correction = modeBound(savedMode, state.drafts, currentUser()) ? { ...savedMode, pending: false } : null; if (!state.correction) store.remove(MODE_KEY); };
  /* Modification par l'équipe : ni ?resubmit= ni ?edit= (liens du vendeur), l'annonce vient de la fiche. */
  const askedCorrection = admin ? '' : correctionRef(window.location.search) || (/^\d{1,20}$/.test(store.get(CORRECT_KEY) || '') ? store.get(CORRECT_KEY) : '');
  const askedEdit = admin || askedCorrection ? '' : editRef(window.location.search) || (/^\d{1,20}$/.test(store.get(EDIT_KEY) || '') ? store.get(EDIT_KEY) : '');
  if (askedCorrection) { store.set(CORRECT_KEY, askedCorrection); store.remove(EDIT_KEY); state.correction = { ref: askedCorrection, pending: true, kind: 'fix' }; }
  else if (askedEdit) { store.set(EDIT_KEY, askedEdit); state.correction = { ref: askedEdit, pending: true, kind: 'edit' }; }
  else if (savedMode) state.correction = { ...savedMode, pending: false };
  /* Règle unique (revue du 10 octobre 2026) : au démarrage, après chaque attente (préremplissage, /me) et sur « Remplacer »,
     un contexte de modification ou de correction d'un autre compte que celui de la session est retiré, brouillon lié compris. */
  enforceAccount();
  let requested = '';
  try { requested = (new URLSearchParams(window.location.search).get('game') ?? new URLSearchParams(window.location.search).get('univers')) || ''; } catch { /* sans URL */ }
  const pageGame = demo.getAttribute?.('data-fs-universe');
  const backFromLogin = Boolean(fragment.present || (returning && (!returning.intent || returning.intent.kind === 'propose')));
  const savedGame = savedDrafts.drafts[savedDrafts.game] ? savedDrafts.game : '';
  /* Jeu du site (pack présent dans la page) absent du choix : fermé à la vente (VEND-01). Demandé par
     ?game=<jeu>#sell, il n'ouvre aucun jeu d'office, même avec le brouillon d'un autre jeu (gardé, voir plus bas). */
  const closedRequest = (game) => typeof game === 'string' && /^[a-z][a-z0-9-]{1,39}$/.test(game) && !games.includes(game)
    && Boolean(demo.querySelector?.(`template[data-fs-pack-template="${game}"]`) || document.getElementById(`fs-game-pack-${game}`));
  const closedIntent = !admin && !backFromLogin && window.location.hash === '#sell' && closedRequest(requested) ? requested : '';
  /* Modification par l'équipe : le jeu est celui de l'annonce, posé au chargement (load). */
  const initialGame = admin || closedIntent ? '' : [backFromLogin ? savedDrafts.game : '', savedGame, requested, pageGame].find((game) => games.includes(game)) || '';

  /* ---- jeu fermé à la vente (VEND-01) : ?game=<jeu>#sell, brouillon de l'onglet ou lien « Proposer » d'un jeu
     au modèle `selling: false` (absent du choix) → aucun jeu coché, note neutre (role="status"). Son brouillon est gardé
     à part (CLOSED_DRAFT_KEY). La saisie du jeu ouvert à ce moment est mise de côté en brouillon (parkedGame) : choisir
     ensuite un autre jeu y ramène d'abord (« Reprendre … » / « Commencer … »). La note disparaît au choix d'un jeu. Le
     catalogue du jeu (?game=<jeu> sans #sell) ne charge pas les modèles. ---- */
  let closedGame = '';
  let parkedGame = closedIntent && savedGame ? savedGame : '';
  function noteClosedGame(game) {
    if (!closedRequest(game)) return;
    loadTemplates().then((lib) => {
      const tpl = lib.TEMPLATES?.[game];
      if (!tpl || lib.isSelling(tpl) || state.game) return;
      closedGame = game;
      showNote(closedGameNote(tpl.name));
    }).catch(() => {});
  }
  function parkGame() {
    const game = state.game;
    if (!game) return;
    /* Sauvegarde et contrôles différés de la saisie (onEdit) : annulés, la saisie est enregistrée ici, tout de suite. */
    clearTimeout(saveTimer);
    clearTimeout(liveTimer);
    cancelAnimationFrame(frame);
    if (hasEntry(game)) { parkedGame = game; state.restored.add(game); }
    saveDrafts();
    state.panel?.destroy?.();
    Object.assign(state, { game: '', form: null, welcome: null, done: null, panel: null, otherGame: '' });
    ui.slot.replaceChildren();
    ui.banners.replaceChildren();
    radios.forEach((radio) => { radio.checked = false; });
    applyGame();
  }
  /* Après les écouteurs du choix (enregistrés plus loin), qui posent state.game. */
  const dropClosedNote = () => setTimeout(() => { if (closedGame && state.game) { closedGame = ''; showNote(''); } });
  if (!initialGame && !admin) {
    let draftGame = '';
    try { draftGame = JSON.parse(store.get(DRAFT_KEY) || 'null')?.game; } catch { /* illisible */ }
    noteClosedGame([closedIntent, draftGame, ...closedDrafts.games].find(closedRequest));
  }
  /* Avant l'appel à l'action (goTo, enregistré plus loin) : le jeu ouvert est mis de côté, goTo montre alors le choix. */
  if (!admin) document.addEventListener('click', (event) => {
    const game = event.target.closest?.('[data-fs-propose-open]')?.getAttribute('data-fs-propose-open');
    if (!closedRequest(game) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    parkGame();
    noteClosedGame(game);
  });
  ['change', 'keydown'].forEach((type) => ui.chooser.addEventListener(type, dropClosedNote));
  document.addEventListener('fs:universe-change', dropClosedNote);

  /* ---- modèle et modules chargés à la demande ---- */
  const fieldsOf = (template) => template.sections.flatMap((entry) => entry.fields);
  const template = () => state.lib?.TEMPLATES[state.game] ?? null;
  const fieldMap = () => new Map(fieldsOf(template()).map((field) => [field.key, field]));
  const idOf = (key) => `fs-propose-f-${key}`;
  /* Modification par l'équipe : « Vérifier » est la dernière étape (ni conditions de vente ni envoi au vendeur). */
  const allSteps = () => {
    const list = stepsOf(state.game, { prices: state.prices });
    return !admin ? list : list.filter((entry) => entry.id !== CONDITIONS_STEP)
      .map((entry) => (entry.id === PRICE_STEP ? { ...entry, title: admin.text.priceTitle, lead: admin.text.priceLead } : entry));
  };
  /* Parcours du vendeur : sans les étapes entièrement remplies par AccInsight (syncImported), qu'il n'a plus à relire. */
  const steps = () => (state.importSkip.size ? allSteps().filter((entry) => !state.importSkip.has(entry.id)) : allSteps());
  /** Textes qui parlent du prix : ceux d'aujourd'hui tant que le service n'annonce pas le prix souhaité. */
  const copy = () => PRICE_COPY[state.prices ? 'on' : 'off'];
  const termsKey = () => (state.sellerTickets ? 'on' : 'off');
  /** Prix souhaité tel que saisi : le champ de l'étape s'il existe, sinon la saisie gardée (brouillon). */
  const priceText = () => state.form?.querySelector('[name="fs-price"]')?.value ?? state.price;
  const stepById = (id) => allSteps().find((entry) => entry.id === id) || null;
  function loadTemplates() {
    if (state.lib) return Promise.resolve(state.lib);
    state.loading = state.loading || import(root.dataset.fsTemplates);
    return state.loading.then((lib) => (state.lib = lib), (error) => { state.loading = null; throw error; });
  }
  function loadImportUi() {
    if (state.importUi) return Promise.resolve(state.importUi);
    if (!ASSET.test(root.dataset.fsImportUi || '')) return Promise.resolve(null);
    state.importLoading = state.importLoading || import(root.dataset.fsImportUi).then((module) => (state.importUi = module), () => { state.importLoading = null; return null; });
    return state.importLoading;
  }
  function loadAccount() {
    if (state.account !== undefined) return Promise.resolve(state.account);
    const href = root.dataset.fsAccountImport || '';
    state.accountLoading = state.accountLoading || (ASSET.test(href) ? import(href) : Promise.reject(new Error('absent')))
      .then((module) => (state.account = module), () => (state.account = null));
    return state.accountLoading;
  }
  /** Code des captures (préparation, envoi, masquage) : chargé au premier besoin. */
  function loadMedia() {
    if (state.mediaLib) return Promise.resolve(state.mediaLib);
    if (!ASSET.test(root.dataset.fsMedia || '')) return Promise.reject(new Error('absent'));
    state.mediaLoading = state.mediaLoading || import(root.dataset.fsMedia).then((module) => (state.mediaLib = module), (error) => { state.mediaLoading = null; throw error; });
    return state.mediaLoading;
  }
  /** Garde commune à toute lecture : module for-sale-import/1 s'il est livré, puis modèle du jeu. */
  async function guardImport(raw) {
    const [importUi, lib, accountLib] = await Promise.all([loadImportUi(), loadTemplates().catch(() => null), loadAccount()]);
    if (!importUi || !lib) throw new Error(t('propose.import.unavailable'));
    if (!games.includes(raw?.game) || !lib.TEMPLATES[raw.game]) throw new importUi.ImportError(t('propose.import.wrong_game'));
    let normalized = raw;
    if (typeof accountLib?.normalizeImport === 'function') normalized = accountLib.normalizeImport(raw, { allowClient: false }) ?? raw;
    return importUi.sanitizeImport(lib.TEMPLATES[raw.game], normalized, { allowClient: false });
  }

  /* ---- défilement et focus : un seul mouvement, explicite ---- */
  /* Place laissée en haut : scroll-padding-top (en-tête du site + rail + 16 px, fs-propose-form.css), jamais moins que
     le bas réel du rail une fois collé (son top collant + sa hauteur rendue) + 16 px, si les constantes divergeaient. */
  /* Zone qui défile : la page, ou le corps de la fenêtre modale de l'équipe (admin.scroller) ; bords lus à l'écran, la
     place laissée en haut (topInset) est une ordonnée d'écran. */
  const scroller = admin?.scroller ?? null;
  const viewTop = () => (scroller ? scroller.getBoundingClientRect().top : 0);
  const viewBottom = () => (scroller ? scroller.getBoundingClientRect().bottom : window.innerHeight);
  const scrollView = (top, behavior) => (scroller ?? window).scrollBy({ top, behavior });
  const topInset = () => {
    const padding = scroller ? 0 : parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const rail = ui.rail && !ui.rail.hidden ? ui.rail.offsetHeight : 0;
    const stuck = rail ? (parseFloat(getComputedStyle(ui.rail).top) || 0) + rail + 16 : 0;
    return viewTop() + Math.max(16, padding, stuck);
  };
  function reveal(element, clicked = true, block = '') {
    if (!element?.isConnected) return;
    const rect = element.getBoundingClientRect();
    if (rect.top >= topInset() && rect.bottom <= viewBottom() - 16) return;
    element.scrollIntoView({ block: block || (rect.height > (viewBottom() - viewTop()) * 0.6 ? 'start' : 'center'), behavior: motion(clicked) });
  }
  function focusOn(element, clicked = true) {
    if (!element) return;
    element.focus({ preventScroll: true });
    reveal(element, clicked);
  }
  /** Haut d'un élément sous l'en-tête collant, en un seul défilement, seulement s'il n'est pas déjà à sa place. */
  function scrollTop(element, clicked = true) {
    if (!element?.isConnected) return;
    const offset = element.getBoundingClientRect().top - topInset();
    if (offset < -2 || offset > (viewBottom() - viewTop()) * 0.4) scrollView(offset, motion(clicked));
  }
  /** Étape entière à l'écran quand elle y tient (VEND-08 : « Votre pilote » en 1 440 × 900), au plus petit défilement ;
      sinon son haut sous l'en-tête collant, selon scrollTop. */
  function showStep(node, clicked = true) {
    if (!node?.isConnected) return;
    const rect = node.getBoundingClientRect();
    const inset = topInset();
    if (rect.height <= viewBottom() - inset && rect.top >= inset - 2 && rect.bottom > viewBottom()) {
      scrollView(rect.bottom - viewBottom(), motion(clicked));
      return;
    }
    scrollTop(node, clicked);
  }
  /** Résumé d'erreurs : montré avec le titre de l'étape au-dessus (jamais sous l'en-tête collant) quand les deux
   * tiennent dans l'écran ; sinon le résumé seul, en haut, sous l'en-tête. */
  function revealSummary(step, summary) {
    if (!summary?.isConnected) return;
    const inset = topInset();
    const top = step.getBoundingClientRect().top;
    const bottom = summary.getBoundingClientRect().bottom;
    if (top >= inset - 2 && bottom <= viewBottom() - 16) return;
    const anchor = bottom - top <= viewBottom() - inset - 16 ? top : summary.getBoundingClientRect().top;
    scrollView(anchor - inset, motion(true));
  }
  let acted = false;
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => window.addEventListener(type, () => { acted = true; }, { capture: true, passive: true, once: true }));
  /** Retour de Discord (redirection) : le bloc est placé une fois sous l'en-tête, sans animation, si personne n'a agi. */
  function land(focusTarget) {
    const target = ui.console && !ui.console.hidden ? ui.console : section;
    if (!target) return;
    focusTarget?.focus({ preventScroll: true });
    const place = () => {
      if (acted || !target.isConnected) return;
      const offset = target.getBoundingClientRect().top - topInset();
      if (Math.abs(offset) > 2) window.scrollBy({ top: offset, behavior: 'instant' });
    };
    Promise.resolve(document.fonts?.ready).catch(() => {}).then(() => requestAnimationFrame(() => requestAnimationFrame(place)));
  }

  /* ---- messages généraux ---- */
  /** Erreur de connexion ; refus « non-membre » : l'invitation au serveur dans l'alerte, nouvel onglet annoncé (spec 05, GR-19). */
  function showAuthError(message) {
    ui.authError.textContent = message;
    ui.authError.hidden = !message;
    const invite = inviteUrl(root.dataset.fsDiscordInvite);
    if (!message || !invite || message !== authErrorMessage('not_member')) return;
    ui.authError.append(' ', h('a', { class: 'fs-link', href: invite, target: '_blank', rel: 'noopener noreferrer', 'data-fs-auth-invite': true },
      t('propose.session.join_server'), h('span', { class: 'fs-visually-hidden', text: t('propose.common.new_tab') })));
  }
  function showNote(text) { ui.note.textContent = text; ui.note.hidden = !text; }
  function showStatus(text) { ui.status.textContent = text; ui.status.hidden = !text; }
  let savedTimer = 0;
  /** « Brouillon enregistré » : dans la console hors des étapes, dans le rail pendant les étapes (spec 05 § 1.9). */
  function showSaved(saving) {
    if (!ui.saved) return;
    const draft = state.drafts[state.game];
    /* Modification par l'équipe : rien n'est gardé dans l'onglet, aucun « Brouillon enregistré ». */
    const shown = !admin && Boolean(state.game) && state.view !== 'chooser' && state.view !== 'done' && Boolean(draft) && !(isEmptyDraft(draft) && !hasProgress(draft));
    /* Pendant les étapes, le rail montre l'état ; la ligne de la console reste lue (role=status) mais masquée à l'écran. */
    ui.saved.hidden = !shown;
    ui.saved.classList.toggle('fs-visually-hidden', state.view === 'step');
    ui.saved.dataset.state = saving ? 'saving' : 'saved';
    ui.saved.textContent = saving ? t('propose.saved.saving') : t('propose.saved.saved');
    const rail = ui.rail.querySelector('[data-fs-rail-draft]');
    if (!rail) return;
    rail.hidden = !shown || state.view !== 'step';
    rail.dataset.state = ui.saved.dataset.state;
    rail.textContent = ui.saved.textContent;
  }

  /* ---- brouillons ---- */
  /** État du parcours du jeu courant, gardé avec la saisie (brouillon v4). */
  function journey() {
    const captures = {};
    for (const [slot, entry] of Object.entries(state.media[state.game] || {})) {
      if (entry.id && entry.state === 'sent') captures[slot] = { state: 'uploaded', ref: entry.id };
      /* Une capture encore en mémoire serait perdue au rechargement : le brouillon la note « à redéposer » (jamais l'image). */
      else if (entry.state === 'lost' || (entry.blob && !entry.id)) captures[slot] = { state: 'lost' };
    }
    const price = priceText();
    /* Widget à moitié répondu : ses parties répondues, à part (le texte du champ reste vide jusqu'à la réponse complète) ;
       son « Autre formulation », à part aussi : la réponse complète, envoyée, ne l'efface pas. */
    const partial = {};
    const other = {};
    for (const wrap of state.form?.querySelectorAll('[data-fs-widget]') || []) {
      const answers = wrap.fsPartial?.();
      if (answers) partial[wrap.dataset.fsWidget] = answers;
      const text = wrap.fsOther?.();
      if (text) other[wrap.dataset.fsWidget] = text;
    }
    return { step: state.step, visited: [...state.visited], skipped: [...state.skipped], titleEdited: state.titleEdited, tagsSeen: state.tagsSeen,
      ...(state.imported.size ? { imported: [...state.imported] } : {}), ...(state.revealed.size ? { revealed: [...state.revealed] } : {}),
      rounding: Object.fromEntries(Object.entries(state.rounding).filter(([, choice]) => choice === 'exact')), partial, other, captures,
      ...(price.trim() ? { price } : {}), ...(state.draftId ? { id: state.draftId } : {}) };
  }
  function saveDrafts() {
    if (state.form && state.game) state.drafts[state.game] = { ...readInput({ exact: true }), ...journey() };
    /* Saisie mise de côté par une demande de jeu fermé (VEND-01) : elle reste le brouillon de l'onglet. */
    const kept = state.game || parkedGame;
    if (!kept && !Object.values(state.drafts).some((draft) => !isEmptyDraft(draft) || hasProgress(draft))) { store.remove(DRAFT_KEY); return; }
    store.set(DRAFT_KEY, serializeDraftStore(kept, state.drafts));
    clearTimeout(savedTimer);
    showSaved(false);
  }
  let saveTimer = 0;
  const saveSoon = () => { clearTimeout(saveTimer); showSaved(true); saveTimer = setTimeout(saveDrafts, 400); };

  /* ---- jeu du formulaire : ne change que ce bloc (jamais l'univers de la page) ---- */
  const defaultBadge = ui.badge.firstElementChild?.cloneNode(true) || document.createTextNode('');
  /* Cadre FOR SALE : le bloc prend l'accent du jeu (data-fs-universe), son logotype et les icônes de son pack. */
  function applyGame() {
    const game = state.game;
    const pack = packOf(game);
    if (game) { root.setAttribute('data-fs-game-pack', game); root.setAttribute('data-fs-universe', game); }
    else { root.removeAttribute('data-fs-game-pack'); root.removeAttribute('data-fs-universe'); }
    ui.current.textContent = game ? names[game] || game : t('propose.console.choose_game');
    /* Console « Votre annonce » seulement une fois le jeu choisi (spec 05, GR-21) : aucune boîte vide au choix du jeu.
       Modification par l'équipe : jamais (l'en-tête de la fenêtre nomme l'annonce, le jeu ne change pas). */
    ui.console.hidden = !game || Boolean(admin);
    const mark = radios.find((radio) => radio.value === game)?.closest('label')?.querySelector('.fs-propose-game-mark .fs-game-logo-box, .fs-propose-game-emblem svg');
    ui.badge.replaceChildren((mark || defaultBadge).cloneNode(true));
    ui.badge.classList.toggle('is-logo', Boolean(mark?.matches('.fs-game-logo-box')));
    ui.credits.textContent = pack?.credits ? t('propose.console.credits', { credits: pack.credits }) : '';
    ui.credits.hidden = !pack?.credits;
  }
  function applyChooser() {
    ui.chooser.hidden = !state.chooser;
    ui.change.hidden = Boolean(admin) || state.chooser || !state.game;
  }
  /** Captures en mémoire non encore envoyées pour un jeu (elles seraient perdues). */
  const unsent = (game = state.game) => Object.values(state.media[game] || {}).filter((entry) => entry.blob && !entry.id && ['preparing', 'ready', 'uploading', 'error'].includes(entry.state));
  /**
   * Vrai si le vendeur a commencé ce jeu (spec 21 § 3.1) : une valeur, une étiquette, un titre retouché, une capture
   * (même seulement prête), un arrondi choisi, ou une étape atteinte au-delà de la première.
   */
  function hasEntry(game) {
    const current = game === state.game;
    const draft = { ...(current && state.form ? readInput({ exact: true }) : state.drafts[game]) };
    /* Une valeur fixée par le jeu (Nova Horizon : serveur Galaxy) n'est pas une saisie. */
    const fixed = fieldsOf(state.lib?.TEMPLATES[game] || { sections: [] }).filter((field) => field.type === 'choice' && field.options.length === 1).map((field) => field.key);
    if (draft.values) draft.values = Object.fromEntries(Object.entries(draft.values).filter(([key]) => !fixed.includes(key)));
    if (!isEmptyDraft(draft) || Object.values(state.media[game] || {}).some((entry) => entry.state !== 'empty')) return true;
    /* Étape atteinte au-delà de la première (Votre pilote), sans rien saisir : il y a déjà un parcours à perdre. */
    const reached = current && state.form ? [...state.visited].some((id) => id !== FIRST_STEP) : hasProgress(draft);
    return reached || (current && (state.titleEdited || Object.keys(state.rounding).length > 0));
  }
  /** Efface toute la saisie (brouillon, import en attente, captures, arrondis, étapes) : formulaire vierge. */
  function wipeEntry() {
    if (state.game) releaseMedia(state.game);
    state.drafts = {};
    state.restored.clear();
    store.remove(DRAFT_KEY);
    store.remove(IMPORT_KEY);
    unbindMode();
    Object.assign(state, { form: null, welcome: null, done: null, rounding: {}, visited: new Set(), skipped: new Set(), imported: new Set(), revealed: new Set(), importSkip: new Set(), titleEdited: false, tagsSeen: false, review: {}, reads: {}, readChecked: {}, otherGame: '', accountCheck: null });
    state.panel?.destroy?.();
    state.panel = null;
    ui.slot.replaceChildren();
    ui.banners.replaceChildren();
  }
  /** « Choisir un autre jeu » (seule entrée du bloc) ou appel à l'action d'un autre jeu : confirmation s'il y a une saisie. */
  function requestGameChange(to = '') {
    if (state.game && hasEntry(state.game)) { confirmGameChange(to); return; }
    if (to) selectGame(to, { confirmed: true }); else openChooser();
  }
  function openChooser() {
    state.chooser = true;
    applyChooser();
    showView('chooser');
    focusOn(radios.find((radio) => radio.checked) || radios[0]);
  }

  /** Changer de jeu = formulaire vierge : saisie, captures et brouillon de l'ancien jeu effacés (confirmés s'il y en a). */
  function selectGame(game, { confirmed = false, view = 'welcome' } = {}) {
    if (!games.includes(game)) return;
    /* Saisie mise de côté par une demande de jeu fermé (VEND-01) : un autre jeu choisi y ramène d'abord. */
    if (parkedGame && !state.game && !confirmed) { if (parkedGame !== game && hasEntry(parkedGame)) { state.otherGame = game; game = parkedGame; } parkedGame = ''; }
    const previous = state.game;
    if (previous && previous !== game && !confirmed && hasEntry(previous)) { radios.forEach((radio) => { radio.checked = radio.value === previous; }); confirmGameChange(game); return; }
    radios.forEach((radio) => { radio.checked = radio.value === game; });
    if (previous !== game) {
      if (previous) {
        releaseMedia(previous);
        state.restored.delete(previous);
        if (state.correction && !state.correction.pending && state.correction.game === previous) forgetMode();
      }
      /* Un seul brouillon : celui du nouveau jeu, s'il vient d'être prérempli (« Corriger et renvoyer »). */
      for (const key of Object.keys(state.drafts)) if (key !== game) delete state.drafts[key];
      state.game = game;
      state.form = null;
      state.welcome = null;
      ui.banners.replaceChildren();
      state.panel?.destroy?.();
      state.panel = null;
      saveDrafts();
    }
    state.chooser = false;
    applyGame();
    applyChooser();
    openForm(view);
  }
  /**
   * Confirmation en ligne dans la console « Votre annonce » (alertdialog non modal, focus sur le message) :
   * [Changer de jeu] efface la saisie puis ouvre le choix du jeu (ou le jeu demandé) ; [Rester] ne change rien.
   */
  function confirmGameChange(to = '') {
    ui.console.querySelector('[data-fs-propose-banner="game"]')?.remove();
    const message = h('p', { class: 'fs-propose-confirm-text', id: 'fs-propose-confirm-text', tabindex: '-1' }, h('strong', { text: t('propose.confirm_game.message') }));
    const go = h('button', { type: 'button', class: 'fs-btn', 'data-fs-propose-switch': to || 'choisir', text: t('propose.confirm_game.change') });
    const keep = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-propose-stay': true, text: t('propose.confirm_game.stay') });
    const banner = h('div', { class: 'fs-alert fs-propose-confirm', 'data-tone': 'warning', role: 'alertdialog', 'aria-modal': 'false', 'aria-labelledby': 'fs-propose-confirm-text', 'data-fs-propose-banner': 'game' },
      message, h('div', { class: 'fs-propose-actions' }, go, keep));
    ui.console.append(banner);
    state.chooser = false;
    applyChooser();
    go.addEventListener('click', () => {
      banner.remove();
      wipeEntry();
      if (to) selectGame(to, { confirmed: true }); else openChooser();
    });
    keep.addEventListener('click', () => { banner.remove(); applyChooser(); focusOn(ui.change); });
    message.focus({ preventScroll: true });
    reveal(banner);
  }
  /* Clavier : les flèches parcourent les jeux sans les valider ; Entrée ou Espace choisit le jeu en cours. */
  let arrowing = false;
  ui.chooser.addEventListener('keydown', (event) => {
    const radio = event.target.closest?.('[data-fs-propose-game]');
    if (!radio) return;
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) { arrowing = true; return; }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      radio.checked = true;
      if (radio.value === state.game) { state.chooser = false; applyChooser(); if (state.view === 'chooser') showWelcome(); } else selectGame(radio.value);
    }
  });
  ui.chooser.addEventListener('pointerdown', () => { arrowing = false; });
  radios.forEach((radio) => radio.addEventListener('change', () => {
    if (!radio.checked) return;
    if (arrowing) { arrowing = false; return; }
    selectGame(radio.value);
  }));
  /* Le jeu déjà choisi, choisi de nouveau : le choix se replie et le parcours reprend (aucun événement change). */
  radios.forEach((radio) => radio.addEventListener('click', () => {
    if (radio.value !== state.game || !state.chooser || !state.form) return;
    state.chooser = false;
    applyChooser();
    if (state.view === 'chooser') showWelcome();
  }));
  ui.change.addEventListener('click', () => requestGameChange());
  document.addEventListener('fs:game-skin-change', () => applyGame());
  /* Écran d'un jeu ouvert ailleurs sur la page (tuile, rubrique « Jeu » des filtres) : ce jeu est présélectionné tant
     que le parcours n'a pas commencé, en silence (ni #sell dans l'historique, ni défilement, ni focus : le visiteur
     regarde le catalogue). Un brouillon saisi ou des captures non envoyées gardent leur jeu (aucune confirmation ici). */
  if (!admin) document.addEventListener('fs:universe-change', (event) => {
    const id = event.detail?.id;
    if (!games.includes(id) || id === state.game || (state.view === 'step' && state.form) || (state.game && hasEntry(state.game))) return;
    selectGame(id, { view: 'silent' });
  });

  /* ---- ouverture : le formulaire se construit sans session (spec 03 § 3.3) ---- */
  async function openForm(view = 'welcome') {
    if (!state.game) { showView('chooser'); return; }
    if (!state.lib || !state.importUi) {
      showStatus(t('propose.loading.form'));
      try { await Promise.all([loadTemplates(), loadImportUi()]); } catch {
        showStatus(t('propose.loading.failed'));
        return;
      }
    }
    if (!state.game) return;
    if (state.form) { if (view !== 'silent' && state.view !== 'step') showWelcome(); return; }
    if (!template()) { showStatus(t('propose.loading.unavailable_game')); return; }
    showStatus('');
    buildForm();
    probeMedia();
    probeJoin();
    const draft = state.drafts[state.game];
    if (view === 'resume' && draft?.step) {
      if (token()) { go(draft.step, { dir: 'forward', clicked: false, replace: true }); return; }
      /* Retour de Discord par redirection, échange du code pas encore fini (course avec le chargement des modèles) :
         l'accueil s'affiche et loggedIn ouvre l'étape du brouillon à l'arrivée de la session. */
      if (fragment.code || returnPending) state.afterLogin = draft.step;
    }
    if (view === 'silent') showWelcome({ clicked: false, push: false, focus: false }); else showWelcome();
  }

  /* ---- construction : une carte d'étape par étape du plan, dans un seul formulaire ---- */
  const estText = (seconds) => (seconds < 60 ? t('propose.step_head.est_seconds', { seconds: digits(seconds) })
    : seconds % 60 ? t('propose.step_head.est_minutes_seconds', { minutes: digits(Math.floor(seconds / 60)), seconds: digits(seconds % 60) })
      : t('propose.step_head.est_minutes', { minutes: digits(Math.floor(seconds / 60)) }));
  const lower = (text) => (text ? text.charAt(0).toLocaleLowerCase(locale) + text.slice(1) : text);
  const slotsOf = () => captureSlotsOf(template());
  const captureSlotsOf = (tpl) => (typeof state.lib?.captureSlots === 'function' ? state.lib.captureSlots(tpl) : (tpl?.captures?.slots || []));
  const slotDef = (id) => slotsOf().find((entry) => entry.id === id) || null;
  const isPublic = (def) => def?.visibility === 'public' && def?.channel !== 'ticket';
  const shotUi = (id) => CAPTURE_UI[state.game]?.[id] || ['receipt', templateText(slotDef(id), 'label') || id];
  /** Vaisseau des en-têtes d'étape et de la carte de « Vérifier » : premier design coché (le plus attirant), sinon un vaisseau d'ambiance. */
  function headShip() {
    const pack = packOf(state.game);
    const ships = state.form ? [...state.form.querySelectorAll('input[name="f-ships"]:checked')].map((box) => box.value) : (state.drafts[state.game]?.values?.ships || []);
    return chosenDesigns(pack, ships)[0] || (pack?.ships.length ? pack.ships[shipIndex(`APERCU${state.game}`, pack.ships.length)] : null);
  }
  const artStyle = (pack, focus) => (pack?.art && safeUrl(pack.art.url) ? `--fs-step-art: url("${pack.art.url}"); --fs-step-art-focus: ${focus || pack.art.focus};` : null);

  /** Schéma d'écran dessiné (SHOT_SCHEMAS) : uniquement des visuels du pack, jamais une vraie capture. */
  function schemaOf(key, { tag = t('propose.schema.example'), masks = true } = {}) {
    const spec = SHOT_SCHEMAS[key] || SHOT_SCHEMAS.receipt;
    const pack = packOf(state.game);
    let images = [];
    if (spec.fill?.icons) images = spec.fill.icons.map((name) => pack?.icons[name]?.url || '');
    else if (spec.fill?.ships) images = Array.from({ length: spec.fill.ships }, (_, index) => pack?.ships[index % Math.max(1, pack?.ships.length || 1)]?.url || '');
    else if (spec.fill?.designs) images = (pack?.designs || []).slice(0, spec.fill.designs).map((design) => design.url);
    else images = Array.from({ length: spec.fill?.rows || 4 }, () => '');
    const cells = (spec.layout === 'grid' || spec.layout === 'bar') && images.length % spec.cols ? [...images, ...Array(spec.cols - (images.length % spec.cols)).fill('')] : images;
    return h('span', { class: 'fs-shot-schema', 'data-layout': spec.layout, 'aria-hidden': 'true', style: `--cols: ${spec.cols}` },
      h('span', { class: 'fs-shot-schema-tabs' }, Array.from({ length: spec.tabs }, (_, index) => h('i', { class: index === 0 ? 'is-on' : null }))),
      h('span', { class: 'fs-shot-schema-grid' }, cells.map((url) => h('span', {}, url ? h('img', { src: url, alt: '', loading: 'lazy', decoding: 'async' }) : null))),
      (masks ? spec.masks || [] : []).map((mask) => h('span', { class: 'fs-shot-schema-mask', style: `--x: ${mask.x}; --y: ${mask.y}; --w: ${mask.w}; --h: ${mask.h}`, text: mask.label })),
      tag ? h('span', { class: 'fs-shot-schema-tag', text: tag }) : null);
  }

  /**
   * En-tête d'étape (spec 05 § 1.9) : icône dans un carré, surtitre, titre, chapeau (calé sur le bord du corps par la
   * feuille). kicker : texte (accueil : nom du jeu) ou nœud déjà construit (stepKicker).
   */
  function stepHead(entry, { kicker, title, idPrefix = 'fs-step' } = {}) {
    const pack = packOf(state.game);
    const icon = entry.icon === 'emblem' ? (pack?.emblem ? { url: pack.emblem } : packKeyIcon('rank')) : packKeyIcon(entry.icon) || packKeyIcon('rank');
    const ship = headShip();
    return h('header', { class: 'fs-step-head', style: artStyle(pack, entry.artFocus) },
      h('span', { class: 'fs-step-icon', 'aria-hidden': 'true' }, icon ? h('img', { src: icon.url, alt: '', width: 36, height: 36, decoding: 'async' }) : null),
      h('div', { class: 'fs-step-heading' },
        typeof kicker === 'string' ? h('p', { class: 'fs-label fs-step-kicker', text: kicker }) : kicker,
        h('h3', { class: 'fs-step-title', id: `${idPrefix}-${entry.id}-title`, tabindex: '-1', text: title || entry.title })),
      h('p', { class: 'fs-step-lead', 'data-fs-step-lead': true, text: frenchSpacing(entry.lead) }),
      ship ? h('img', { class: 'fs-step-ship', 'data-fs-step-ship': true, src: ship.url, alt: '', width: ship.width, height: ship.height, decoding: 'async', loading: 'lazy', style: `--ship-w: ${Math.round(ship.width / 1.5)}px` }) : null);
  }
  /**
   * Surtitre d'étape (spec 05, GR-07) : « Étape n sur N · Phase · ≈ durée », sans durée à « Vérifier » et aux conditions.
   * Le numéro est repeint à chaque changement d'étape (paintKickers : l'étape « Votre prix » peut s'insérer en route).
   */
  function stepKicker(entry) {
    return h('p', { class: 'fs-label fs-step-kicker', 'data-fs-step-kicker': true },
      h('span', { class: 'fs-kicker-step', text: t('propose.kicker.step', { current: digits(indexOf(entry.id) + 1), total: digits(steps().length) }) }), ' · ',
      h('span', { class: 'fs-kicker-phase', text: PHASE_NAMES[entry.phase] }),
      FINAL_STEPS.includes(entry.id) ? null : [' · ', h('span', { class: 'fs-kicker-time', text: estText(entry.est || 30) })]);
  }
  function paintKickers() {
    const list = steps();
    for (const [index, entry] of list.entries()) {
      const label = stepNode(entry.id)?.querySelector('.fs-kicker-step');
      if (label) label.textContent = t('propose.kicker.step', { current: digits(index + 1), total: digits(list.length) });
    }
  }

  /* ---- champs (spec 05 § 1.3 : grille de 12 colonnes, anatomie partagée par sous-grille) ---- */
  function hintFor(field) {
    const own = FIELD_HINTS[state.game]?.[field.key] ?? FIELD_HINTS['*'][field.key];
    if (own) return frenchSpacing(own);
    if (field.type === 'integer' && !field.ratioOf && field.max !== undefined) return t('propose.fields.range_hint', { min: digits(field.min ?? 0), max: digits(field.max) });
    return '';
  }
  const fieldName = (field) => FIELD_LABELS[state.game]?.[field.key] || FIELD_LABELS['*'][field.key] || (field.i18n?.label ? templateText(field, 'label') : '') || statName(field.label, state.game);
  const labelOf = (key) => {
    if (key === 'title') return titleLabel(template() || {});
    if (key === 'tags') return t('propose.fields.tags');
    if (key === 'commit') return t('propose.fields.commit');
    if (key === 'media') return t('propose.fields.media');
    if (key === 'expectedNet') return t('propose.fields.expected_net');
    if (admin?.labels?.[key]) return admin.labels[key];
    if (key.startsWith('shot-')) return templateText(slotDef(key.slice(5)), 'label') || t('propose.fields.shot');
    if (key.startsWith('read-')) return t('propose.fields.read_values');
    const field = fieldsOf(template()).find((item) => item.key === key);
    return field ? fieldName(field) : key;
  };
  /** Marque « Obligatoire » unique (spec 21 § 2.3) : champs, groupes, capture obligatoire, étiquettes, engagement. */
  const requiredMark = () => h('span', { class: 'fs-field-req fs-propose-req', 'data-fs-required': true, text: t('propose.fields.required') });
  /** Marque « Facultatif » : dans une étape où presque tout est obligatoire (VEND-04), seuls les facultatifs sont marqués. */
  const optionalMark = () => h('span', { class: 'fs-field-req fs-propose-req', 'data-fs-optional': true, text: t('propose.fields.optional') });
  /*
   * Icône d'un champ : celle du pack, même clé que les filtres et les cartes (direction 22a § 1.5). Exceptions : pas
   * d'icône de plateforme quand le pack n'en a pas de vraie (RG) ; changement de faction RG = glyphe ⇄ de la carte
   * (jamais l'emblème Helios) ; une note « Autres » reprend l'icône de son champ.
   */
  const NO_ICON = { redgalaxy: ['platform'] };
  const GLYPHS = { redgalaxy: { faction_change_available: '⇄' } };
  function fieldIcon(field) {
    if (NO_ICON[state.game]?.includes(field.key)) return null;
    const parent = field.key.endsWith('_note') ? fieldMap().get(field.key.slice(0, -5)) : null;
    if (parent) return packIcon(packOf(state.game), parent.label, parent.key);
    /* Critère 30 : dans une même étape, deux champs différents n'ont jamais la même image ; le second reste sans icône. */
    const icon = packIcon(packOf(state.game), field.label, field.key);
    if (!icon || !state.stepIcons) return icon;
    if (state.stepIcons.has(icon.url)) return null;
    state.stepIcons.add(icon.url);
    return icon;
  }
  /** Emplacement d'icône de 20 px ; vide, il n'occupe aucune place (fs-propose-form.css) : le libellé reste au bord du champ. */
  function labelIcon(field = null) {
    const glyph = field ? GLYPHS[state.game]?.[field.key] : '';
    const icon = field && !glyph ? fieldIcon(field) : null;
    return h('span', { class: `fs-field-icon fs-propose-slot${glyph ? ' fs-propose-glyph' : ''}`, 'aria-hidden': 'true', text: glyph || null },
      icon ? h('img', { class: 'fs-propose-icon', src: icon.url, alt: '', width: 20, height: 20, loading: 'lazy', decoding: 'async' }) : null);
  }
  /** Contenu du libellé : icône, nom, marque « Facultatif » (ou « Obligatoire » hors règle d'étape), badge « Lu ». */
  function labelParts(field, name = fieldName(field)) {
    const mark = state.markOptional ? (field.required ? null : optionalMark()) : (field.required ? requiredMark() : null);
    return [labelIcon(field), h('span', { class: 'fs-propose-label-text' },
      h('span', { class: 'fs-propose-label-name', text: name }),
      mark,
      h('span', { class: 'fs-read-badge', 'data-fs-read-badge': true, hidden: true }, t('propose.fields.read_badge'), h('span', { class: 'fs-visually-hidden', text: t('propose.fields.read_badge_more') })))];
  }
  const errorLine = (id) => h('p', { class: 'fs-field-error fs-propose-error', id: `${id}-error`, 'data-fs-error': true, hidden: true });
  const hintLine = (id, text) => (text ? h('p', { class: 'fs-field-hint fs-propose-hint', id: `${id}-hint`, text }) : null);
  const conflictLine = () => h('p', { class: 'fs-read-conflict', 'data-fs-read-conflict': true, hidden: true });
  /**
   * Rangée « libellé » d'un champ : p.fs-field-head › label (contrôle unique), ou legend.fs-field-head (groupe
   * d'options) ; à droite, `meta` (compteur, état de jauge, « Effacer »). L'icône reste dans le libellé.
   */
  function fieldHead(field, { id = null, legend = false, name, meta = null } = {}) {
    const label = h(legend ? 'span' : 'label', { class: 'fs-field-label fs-propose-label', for: legend ? null : id }, labelParts(field, name));
    return h(legend ? 'legend' : 'p', { class: 'fs-field-head' }, label, meta);
  }
  const fieldCtl = (...parts) => h('div', { class: 'fs-field-ctl' }, parts);
  /** Rangée « message » : lecture, conflit, erreur puis aide (critère 9) ; l'erreur remplace l'aide à l'écran (feuille). */
  const fieldMsg = (...parts) => h('div', { class: 'fs-field-msg' }, parts);

  /*
   * Largeur d'un champ sur la grille de 12 (spec 05 § 2, règle de taille ; remplace sizeOf et les lignes de liste) :
   * courte (3) : entier borné, Oui/Non, valeur fixe ; tiers (4) : grand nombre ; demi (6) : choix de 2 à 5 (segmenté ou
   * cartes), liste, texte court, Premium ; jauge (6 ou 12 selon la zone) ; pleine (12) : multichoix et texte long. Sur
   * téléphone : courtes par deux, le reste en pleine largeur, Oui/Non toujours en pleine largeur (fs-m-pleine). Les
   * anciennes classes fs-size-* restent posées en secondaire le temps de la migration.
   */
  const BIG_NUMBERS = ['experience', 'honor', 'rankpoints'];
  function widthOf(field) {
    if (field.type === 'integer') return field.ratioOf ? 'jauge' : field.key === 'premium' ? 'demi' : BIG_NUMBERS.includes(field.key) ? 'tiers' : 'courte';
    if (field.type === 'boolean') return 'courte';
    if (field.type === 'choice') return field.options.length === 1 ? 'courte' : 'demi';
    if (field.type === 'text') return (field.maxLength ?? 200) <= 60 ? 'demi' : 'pleine';
    return 'pleine';
  }
  const OLD_SIZES = { courte: 's', tiers: 'm', demi: 'm', jauge: 'l', pleine: 'l' };
  const widthClass = (field, width = widthOf(field)) => `fs-w-${width} fs-size-${OLD_SIZES[width]}${field?.type === 'boolean' ? ' fs-m-pleine' : ''}`;
  /**
   * Champ à groupe d'options : div.fs-field (sous-grille) › fieldset.fs-field-set (nom du groupe gardé, mise en page
   * effacée par la feuille) › légende, contrôle, message. `group` : attributs du fieldset (aria-required, aria-describedby).
   */
  function optionField(field, { classes = '', attrs = {}, group = {}, legend, ctl, msg, width }) {
    return h('div', { class: `fs-field fs-propose-field ${classes} ${widthClass(field, width)}`, 'data-fs-field': field.key, ...attrs },
      h('fieldset', { class: 'fs-field-set', ...group }, legend, ctl, msg));
  }

  /** Crans de rareté d'un design (même code que les cartes Hangar : 3 Rare, 2 Premium), nommés pour les lecteurs d'écran. */
  const TIER_PIPS = { rarest: ['rare', 3], paid: ['premium', 2] };
  function tierPips(tier) {
    const entry = TIER_PIPS[tier];
    if (!entry) return null;
    return h('span', { class: `fs-tier-pips fs-tier-pips--${entry[0]}`, role: 'img', 'aria-label': DESIGN_TIER_NAMES[tier] },
      [1, 2, 3].map((index) => h('b', { class: index > entry[1] ? 'is-off' : null })));
  }
  /**
   * Tuiles de vaisseaux (vaisseaux du hangar) : grille complète dans l'ordre du modèle, rien de replié (VEND-05) ; une case
   * par vaisseau (Tab, Espace), cochée = coche et contour ; rareté en crans ; filtre par nom au-delà de 12 ; compteur
   * vivant (role=status) à droite du libellé.
   */
  function designField(field, value, id, described, hint) {
    const pack = packOf(state.game);
    const checked = new Set(Array.isArray(value) ? value : []);
    const byLabel = new Map((pack?.designs || []).map((design) => [design.label, design]));
    const box = (option, index) => {
      const design = byLabel.get(option);
      return h('label', { class: 'fs-tile fs-propose-design', 'data-tier': design?.tier || 'standard', 'data-fs-design-name': option.toLowerCase() },
        h('input', { type: 'checkbox', name: `f-${field.key}`, value: option, id: index === 0 ? id : null, checked: checked.has(option) }),
        /* Case dessinée dans le coin : cochée = case pleine et coche, en plus du contour (jamais la couleur seule). */
        h('span', { class: 'fs-box', 'aria-hidden': 'true' }),
        design ? h('img', { class: 'fs-propose-design-img', src: design.url, alt: '', width: design.width, height: design.height, loading: 'lazy', decoding: 'async' }) : h('span', { class: 'fs-propose-design-img', 'aria-hidden': 'true' }),
        /* Crans dans la rangée du nom, devant lui, comme la tuile de la fiche (fs-listing-detail-fleet) : jamais une
           rangée à part, qui grandissait chaque ligne de la grille (lignes égales, grid-auto-rows: 1fr). */
        h('span', { class: 'fs-propose-design-name' }, tierPips(design?.tier), h('span', { class: 'fs-tile-label', text: alphaLabel(option) })));
    };
    const grid = h('div', { class: 'fs-tiles fs-propose-design-grid fs-propose-design-grid--lg', id: `${id}-grid` }, field.options.map((option, index) => box(option, index)));
    const boxes = [...grid.children];
    const count = h('span', { class: 'fs-field-meta fs-propose-design-count', role: 'status', 'data-fs-design-count': true });
    const filterId = `${id}-filter`;
    const filter = field.options.length > DESIGN_FILTER_MIN ? h('input', { class: 'fs-input fs-input--compact fs-propose-design-filter', id: filterId, type: 'search', autocomplete: 'off', spellcheck: 'false', 'aria-controls': `${id}-grid`, placeholder: t('propose.designs_grid.filter_placeholder'), enterkeyhint: 'search' }) : null;
    const other = fieldMap().has('other_ships');
    const fieldset = h('fieldset', { class: 'fs-field-set fs-propose-designs', 'aria-describedby': described, 'data-fs-design-grid': true },
      fieldHead(field, { legend: true, meta: count }),
      fieldCtl(filter ? h('div', { class: 'fs-pick-tools' }, h('label', { class: 'fs-visually-hidden', for: filterId, text: t('propose.designs_grid.filter_label') }), filter) : null, grid),
      fieldMsg(errorLine(id), hintLine(id, hint)));
    /* Compteur et filtre : relancés à la frappe dans le filtre et à chaque case cochée (onEdit appelle fsSync). */
    fieldset.fsSync = () => {
      const query = filter ? filter.value.trim().toLowerCase() : '';
      let visible = 0;
      boxes.forEach((label) => { label.hidden = Boolean(query) && !label.dataset.fsDesignName.includes(query); if (!label.hidden) visible += 1; });
      count.textContent = designCountText(boxes.filter((label) => label.querySelector('input').checked).length, { query, visible, other });
    };
    filter?.addEventListener('input', fieldset.fsSync);
    fieldset.fsSync();
    return h('div', { class: `fs-field fs-propose-field fs-propose-field-multichoice ${widthClass(field)}`, 'data-fs-field': field.key }, fieldset);
  }
  const alphaLabel = (option) => String(option).replace(/-a$/, '-α');

  /*
   * Contrôle par nature de valeur (spec 21 § 1.1, spec 05 § 1.7) : 1 option → valeur fixe ; faction → cartes à logo ;
   * 2 à 5 → segmenté ; 6 et plus → liste native (base-select dans le formulaire), « FR (EN) », insigne en tête et dans
   * chaque option ; multichoix illustré → tuiles de vaisseaux ; plus de 20 options → recherche ; sinon cases en tuiles.
   * Ordre interne : libellé, contrôle, puis arrondi ou conflit, erreur, aide (critère 9).
   */
  const serverField = (field) => field.key === 'server' || field.key === 'other_servers';
  const optionText = (field, option) => (serverField(field) ? SERVERS[option] || optionLabel(field, option) : optionLabel(field, option));
  /** Libellé d'une option dans une liste : « Capitaine (Captain) » quand le nom affiché diffère du nom du jeu. */
  const selectText = (field, option) => { const text = optionText(field, option); return !serverField(field) && text !== option ? `${text} (${option})` : text; };
  const optionIcon = (option) => packKeyIcon(normalizeKey(option));
  const clearButton = (field) => h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-field-clear', 'data-fs-clear': field.key, text: t('propose.fields.clear'), 'aria-label': t('propose.fields.clear_label', { name: fieldName(field) }) });
  const required = (field) => (field.required ? 'true' : null);
  /**
   * Case « Aucun » d'une liste obligatoire qui peut être vide en jeu (`noneOption`, VEND-04) : exclusive (syncNone),
   * envoyée sous la valeur publiée du modèle (« None »), en dernier dans la liste. null pour une liste sans cette case.
   */
  function noneBox(field, chosen = []) {
    if (typeof field.noneOption !== 'string') return null;
    return h('label', { class: 'fs-check fs-option fs-option--none' },
      h('input', { type: 'checkbox', name: `f-${field.key}`, value: field.noneOption, 'data-fs-none': true, checked: chosen.includes(field.noneOption) }),
      h('span', { class: 'fs-box', 'aria-hidden': 'true' }), h('span', { text: t('propose.fields.none') }));
  }
  /** « Aucun » et les autres cases d'une même liste s'excluent : cocher l'un décoche les autres. */
  function syncNone(block, target) {
    if (!block || target?.type !== 'checkbox' || !target.checked || !block.querySelector('[data-fs-none]')) return;
    const boxes = [...block.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(target.name)}"]`)];
    if (target.matches('[data-fs-none]')) { boxes.filter((box) => box !== target).forEach((box) => { box.checked = false; }); block.fsClearPicks?.(); }
    else boxes.filter((box) => box.matches('[data-fs-none]')).forEach((box) => { box.checked = false; });
  }
  const COMBO_MIN = 20;
  const comboOf = (field) => field.type === 'multichoice' && !illustrated(field) && field.options.length > COMBO_MIN;
  /** Grille illustrée seulement si chaque option a son image dans le pack (vaisseaux) ; sinon recherche ou cases. */
  function illustrated(field) {
    const designs = new Set((packOf(state.game)?.designs || []).map((design) => design.label));
    return (field.options || []).length > 0 && field.options.every((option) => designs.has(option));
  }
  /** Oui / Non, choix courts, missions, arrondi : segmenté (.fs-seg), radio native sous chaque segment. */
  const segment = (inputAttrs, label, extraClass = '') => h('label', { class: `fs-seg-opt fs-choice-option${extraClass}` }, h('input', { type: 'radio', ...inputAttrs }), typeof label === 'string' ? h('span', { text: label }) : label);

  function fieldBlock(field, value) {
    const id = idOf(field.key);
    const hint = hintFor(field);
    const described = hint ? `${id}-hint` : null;
    const key = field.key;
    const widget = WIDGETS[state.game]?.[key];
    if (widget) return widget(field, value, { id, hint, described, partial: state.partial[key], otherText: state.other[key] });
    if (key === 'premium' && field.type === 'integer') return premiumBlock(field, value, { id, hint, described });
    /* Jauge à crans (ratios du modèle) : 0 et « non précisé » distincts, couleur de la pastille du modèle. */
    if (field.type === 'integer' && field.ratioOf) {
      const min = field.min ?? 0; const max = field.max ?? field.ratioOf;
      const current = value === undefined || value === null || value === '' ? null : Number(value);
      const wrap = optionField(field, { classes: 'fs-gauge', group: { 'aria-describedby': described, 'aria-required': required(field) },
        attrs: { 'data-fs-gauge-total': field.ratioOf, style: field.emoji && GAUGE_COLORS[field.emoji] ? `--fs-gauge-c: ${GAUGE_COLORS[field.emoji]}` : null },
        legend: fieldHead(field, { legend: true, meta: [h('span', { class: 'fs-field-meta fs-gauge-state', 'data-fs-gauge-state': true }), field.required ? null : clearButton(field)] }),
        ctl: fieldCtl(h('div', { class: 'fs-crans fs-gauge-crans', role: 'radiogroup', 'aria-label': fieldName(field) },
          Array.from({ length: max - min + 1 }, (_, index) => min + index).map((count) => h('label', { class: 'fs-cran fs-gauge-cran', 'data-fs-cran': String(count) },
            h('input', { type: 'radio', name: `f-${key}`, value: String(count), id: count === min ? id : null, checked: current === count, 'aria-label': t('propose.fields.gauge_of', { value: digits(count), total: digits(field.ratioOf) }) }),
            h('span', { 'aria-hidden': 'true', text: String(count) }))))),
        msg: fieldMsg(conflictLine(), errorLine(id), hintLine(id, hint)) });
      syncGauge(wrap);
      return wrap;
    }
    if (field.type === 'boolean') {
      /* Oui / Non explicites, sans présélection (VEND-04) ; « Effacer » seulement pour un champ facultatif. */
      const current = value === true || value === 'true' ? 'true' : value === false || value === 'false' ? 'false' : '';
      return optionField(field, { classes: 'fs-propose-field-boolean', group: { 'aria-describedby': described, 'aria-required': required(field) },
        legend: fieldHead(field, { legend: true, meta: field.required ? null : clearButton(field) }),
        ctl: fieldCtl(h('div', { class: 'fs-seg fs-choice' }, [['true', t('propose.common.yes')], ['false', t('propose.common.no')]].map(([choice, label], index) =>
          segment({ name: `f-${key}`, value: choice, id: index === 0 ? id : null, checked: choice === current }, label)))),
        msg: fieldMsg(conflictLine(), errorLine(id), hintLine(id, hint)) });
    }
    if (field.type === 'multichoice') {
      const chosen = Array.isArray(value) ? value : [];
      if (illustrated(field)) return designField(field, chosen, id, described, hint);
      if (comboOf(field)) return comboBlock(field, chosen, { id, hint, described });
      const checked = new Set(chosen);
      const limit = field.maxItems && field.maxItems < field.options.length ? field.maxItems : 0;
      /* Plus de 8 cases : un filtre au-dessus de la liste et le compte des cases cochées à droite du libellé. */
      const long = field.options.length > 8;
      const filter = long ? h('input', { class: 'fs-input fs-input--compact fs-propose-design-filter', id: `${id}-filter`, type: 'search', autocomplete: 'off', spellcheck: 'false', enterkeyhint: 'search', placeholder: t('propose.fields.filter_placeholder'), 'aria-controls': `${id}-list` }) : null;
      const wrap = optionField(field, { classes: 'fs-propose-field-multichoice', attrs: { 'data-fs-max': limit || null }, group: { 'aria-describedby': described },
        legend: fieldHead(field, { legend: true, meta: long ? h('span', { class: 'fs-field-meta fs-checks-count', 'data-fs-checks-count': true, role: 'status' }) : null }),
        ctl: fieldCtl(filter ? h('div', { class: 'fs-pick-tools' }, h('label', { class: 'fs-visually-hidden', for: `${id}-filter`, text: t('propose.fields.filter_label', { name: lower(fieldName(field)) }) }), filter) : null,
          h('div', { class: 'fs-checks fs-options fs-options--grid', id: `${id}-list` }, field.options.map((option, index) => h('label', { class: 'fs-check fs-option', 'data-fs-filter-text': normalizeKey(`${optionText(field, option)} ${option}`) },
            h('input', { type: 'checkbox', name: `f-${key}`, value: option, id: index === 0 ? id : null, checked: checked.has(option) }),
            h('span', { class: 'fs-box', 'aria-hidden': 'true' }), iconImage(optionIcon(option), 20, 'fs-option-icon'), h('span', { text: optionText(field, option) }))), noneBox(field, chosen))),
        msg: fieldMsg(errorLine(id), hintLine(id, hint)) });
      if (limit) syncMax(wrap);
      syncChecks(wrap);
      filter?.addEventListener('input', () => {
        const needle = normalizeKey(filter.value);
        wrap.querySelectorAll('[data-fs-filter-text]').forEach((label) => { label.hidden = Boolean(needle) && !label.dataset.fsFilterText.includes(needle) && !label.querySelector('input').checked; });
      });
      return wrap;
    }
    if (field.type === 'choice') {
      if (field.options.length === 1) {
        /* Une seule option (Nova Horizon : Galaxy) : fixée et affichée en lecture seule, envoyée comme aujourd'hui. */
        return h('div', { class: `fs-field fs-propose-field fs-propose-field-fixed ${widthClass(field)}`, 'data-fs-field': key },
          h('p', { class: 'fs-field-head', id: `${id}-label` }, h('span', { class: 'fs-field-label fs-propose-label' }, labelParts(field))),
          fieldCtl(h('p', { class: 'fs-propose-fixed', 'aria-labelledby': `${id}-label`, 'aria-describedby': described, text: optionText(field, field.options[0]) }),
            h('input', { type: 'hidden', name: `f-${key}`, value: field.options[0] })),
          fieldMsg(errorLine(id), hintLine(id, hint)));
      }
      if (field.options.length <= 5) {
        /* Faction : cartes à logo de 32 px à la hauteur des autres contrôles (les logos RG portent du texte, illisibles plus petit) ; sinon segmenté. */
        const cards = key === 'company' && field.options.every((option) => optionIcon(option));
        const option = (choice, index) => {
          const input = { name: `f-${key}`, value: choice, id: index === 0 ? id : null, checked: choice === value };
          if (!cards) return segment(input, h('span', {}, iconImage(optionIcon(choice), 20, 'fs-option-icon'), optionText(field, choice)), ' fs-option');
          return h('label', { class: 'fs-option' }, h('input', { type: 'radio', ...input }),
            iconImage(optionIcon(choice), 32, 'fs-option-icon'), h('span', { class: 'fs-card-name', text: optionText(field, choice) }));
        };
        return optionField(field, { classes: 'fs-propose-field-choice', group: { 'aria-describedby': described, 'aria-required': required(field) },
          legend: fieldHead(field, { legend: true, meta: field.required ? null : clearButton(field) }),
          ctl: fieldCtl(h('div', { class: cards ? 'fs-options fs-option-cards' : 'fs-seg fs-choice fs-options' }, field.options.map(option))),
          msg: fieldMsg(conflictLine(), errorLine(id), hintLine(id, hint)) });
      }
      /* Liste : insigne de 24 px dans chaque option (liste ouverte base-select), le texte gardé tel quel (option.text). */
      const select = h('select', { class: 'fs-select', id, name: `f-${key}`, 'aria-describedby': described, 'aria-required': required(field) },
        h('option', { value: '', text: field.required ? t('propose.fields.choose') : t('propose.fields.unspecified') }),
        field.options.map((option) => {
          const icon = optionIcon(option);
          return h('option', { value: option, selected: option === value },
            icon ? h('img', { class: 'fs-opt-icon', src: icon.url, alt: '', width: 24, height: 24, loading: 'lazy', decoding: 'async' }) : null, selectText(field, option));
        }));
      const icon = h('img', { class: 'fs-select-icon', alt: '', width: 28, height: 28, decoding: 'async', hidden: true });
      const wrap = h('div', { class: `fs-field fs-propose-field fs-propose-field-choice ${widthClass(field)}`, 'data-fs-field': key },
        fieldHead(field, { id }), fieldCtl(h('div', { class: 'fs-select-box' }, icon, select)), fieldMsg(conflictLine(), errorLine(id), hintLine(id, hint)));
      syncSelectIcon(wrap);
      return wrap;
    }
    if (field.type === 'integer') return numberBlock(field, value, { id, hint, described });
    return textBlock(field, value, { id, hint, described });
  }
  /** Insigne de la valeur choisie en tête de la liste (grade), seulement si le pack en a une ; jamais agrandi. */
  function syncSelectIcon(wrap) {
    const select = wrap.querySelector('select');
    const img = wrap.querySelector('.fs-select-icon');
    if (!select || !img) return;
    const icon = select.value ? optionIcon(select.value) : null;
    img.hidden = !icon;
    wrap.querySelector('.fs-select-box').classList.toggle('has-icon', Boolean(icon));
    if (icon && img.getAttribute('src') !== icon.url) {
      img.onload = () => img.classList.toggle('is-small', img.naturalHeight > 0 && img.naturalWidth / img.naturalHeight > 1.3 && img.naturalHeight < 28);
      img.src = icon.url;
    }
  }
  /** « Effacer » n'existe que s'il y a une valeur à effacer (22 § 2, point 2). */
  function syncClear(block) {
    const button = block?.querySelector('[data-fs-clear]');
    if (!button) return;
    const key = button.dataset.fsClear;
    button.hidden = !block.querySelector(`input:is([name="f-${CSS.escape(key)}"], [name="p-${CSS.escape(key)}"]):checked`);
  }
  /** Compte des cases cochées d'une longue liste, à droite du libellé : « 2 cochées sur 13 » (« Aucun » à part). */
  function syncChecks(block) {
    const count = block?.querySelector('[data-fs-checks-count]');
    if (!count) return;
    const boxes = [...block.querySelectorAll('.fs-checks input[type="checkbox"]:not([data-fs-none])')];
    const checked = boxes.filter((box) => box.checked).length;
    count.textContent = t('propose.fields.checked_count', { count: checked, total: digits(boxes.length) });
  }
  /**
   * Nombre : unité dans le champ (à droite), lecture d'un raccourci (« = 25 300 000 ») dans la rangée message, arrondi
   * publié ou exact en segmenté sous le champ. label : nœud de libellé d'un nombre interne (jours du Premium,
   * enrichissements) ; width : largeur imposée.
   */
  function numberBlock(field, value, { id, hint, described, name = `f-${field.key}`, label = null, unit = '', width = null } = {}) {
    const key = field.key;
    const round = roundable(field) && !unit;
    const input = h('input', { class: 'fs-input fs-num-input', id, name, type: 'text', inputmode: field.max === undefined ? 'decimal' : 'numeric', enterkeyhint: 'next',
      autocomplete: 'off', spellcheck: 'false', maxlength: 24, placeholder: ' ', 'aria-describedby': described, 'aria-required': required(field) });
    if (value !== undefined && value !== null && value !== '') { const number = parseNumber(value); input.value = number === null ? String(value) : groupDigits(number); }
    const suffix = unit || (field.unit ? UNITS[field.unit] || field.unit : '');
    const wrap = h('div', { class: `fs-field fs-num fs-propose-field fs-propose-field-integer ${width ? widthClass(null, width) : widthClass(field)}`, 'data-fs-field': label ? null : key },
      h('p', { class: 'fs-field-head' }, h('label', { class: 'fs-field-label fs-propose-label', for: id }, label ? [labelIcon(), label] : labelParts(field))),
      fieldCtl(h('div', { class: `fs-num-box${suffix ? ' has-unit' : ''}` }, input, suffix ? h('span', { class: 'fs-num-unit', text: suffix }) : null),
        round ? h('fieldset', { class: 'fs-num-round', 'data-fs-round': key, hidden: true },
          h('legend', { text: t('propose.rounding.legend') }),
          h('div', { class: 'fs-seg fs-choice' },
            segment({ name: `r-${key}`, value: 'round', checked: state.rounding[key] !== 'exact' }, h('span', {}, h('b', { 'data-fs-round-value': 'round' }), h('small', { text: t('propose.rounding.round') }))),
            segment({ name: `r-${key}`, value: 'exact', checked: state.rounding[key] === 'exact' }, h('span', {}, h('b', { 'data-fs-round-value': 'exact' }), h('small', { text: t('propose.rounding.exact') })))),
          h('p', { class: 'fs-num-round-note', text: t('propose.rounding.note') })) : null),
      fieldMsg(h('p', { class: 'fs-readout', 'data-fs-readout': true, hidden: true }),
        label ? null : conflictLine(), label ? null : errorLine(id), label ? null : hintLine(id, hint)));
    if (round) syncRound(wrap);
    return wrap;
  }
  /** Lecture d'un raccourci pendant la frappe (« 25,3 M » → « = 25 300 000 ») ; rien pour un chiffre déjà en clair. */
  function syncReadout(block) {
    const input = block?.querySelector('.fs-num-input');
    const readout = block?.querySelector(':scope > .fs-field-msg > [data-fs-readout]');
    if (!input || !readout) return;
    const number = parseNumber(input.value);
    const plain = /^[\d\s\u00a0\u202f.,'’]*$/.test(input.value.trim());
    readout.hidden = number === null || plain;
    readout.textContent = readout.hidden ? '' : `= ${digits(number)}`;
  }
  /** Texte vraiment ouvert : compteur à droite du libellé à partir de 80 % de la limite ; lien et prix signalés à la frappe. */
  function textBlock(field, value, { id, hint, described, name = `f-${field.key}`, label = null } = {}) {
    const max = field.maxLength ?? 200;
    const input = h('input', { class: 'fs-input', id, name, type: 'text', autocomplete: 'off', spellcheck: 'false', enterkeyhint: 'next', maxlength: max,
      'aria-describedby': [described, `${id}-count`].filter(Boolean).join(' '), 'aria-required': required(field) });
    if (value !== undefined && value !== null) input.value = String(value);
    const wrap = h('div', { class: `fs-field fs-propose-field fs-propose-field-text ${label ? widthClass(null, 'pleine') : widthClass(field)}`, 'data-fs-field': label ? null : field.key, 'data-fs-max-length': max },
      h('p', { class: 'fs-field-head' }, h('label', { class: 'fs-field-label fs-propose-label', for: id }, label ? [labelIcon(), label] : labelParts(field)),
        h('span', { class: 'fs-field-meta fs-counter', id: `${id}-count`, 'data-fs-counter': true, hidden: true })),
      fieldCtl(input),
      fieldMsg(label ? null : conflictLine(), label ? null : errorLine(id), label ? null : hintLine(id, hint)));
    syncCounter(wrap);
    return wrap;
  }
  function syncCounter(wrap) {
    const input = wrap?.querySelector('input.fs-input');
    syncCount(input, wrap?.querySelector('[data-fs-counter]'), { max: Number(input?.maxLength) || 200, from: 0.8,
      format: (length, max) => t('propose.fields.char_counter', { length: digits(length), max: digits(max) }) });
  }

  /** « Autres serveurs » (WarUniverse) : le serveur principal de l'étape 1 n'y figure pas. */
  function syncOtherServers() {
    const main = state.form?.querySelector('[name="f-server"]:checked')?.value ?? state.form?.querySelector('select[name="f-server"]')?.value ?? '';
    state.form?.querySelectorAll('input[name="f-other_servers"]').forEach((box) => {
      const own = Boolean(main) && box.value === main;
      if (own) box.checked = false;
      box.closest('label').hidden = own;
    });
  }
  /** Multichoix plafonné (maxItems) : les cases restantes deviennent inactives, sans jamais disparaître. */
  function syncMax(block) {
    const max = Number(block?.dataset.fsMax) || 0;
    const boxes = [...block.querySelectorAll('input[type="checkbox"]')];
    const full = max > 0 && boxes.filter((box) => box.checked).length >= max;
    boxes.forEach((box) => { box.disabled = full && !box.checked; });
  }
  /*
   * Premium : « Premium actif » Oui · Non, puis les jours restants si Oui (spec 21 § 1.1), dans la même rangée (spec 05 :
   * demi = Oui/Non courte + jours courte). Non envoie 0. Le libellé « Jours restants » reste lu, l'unité est dans le champ.
   */
  function premiumBlock(field, value, { id, hint, described }) {
    const number = value === undefined || value === null || value === '' ? null : parseNumber(value);
    const state0 = number === null ? '' : number > 0 ? 'true' : 'false';
    const days = numberBlock(field, number > 0 ? number : '', { id, described, name: `f-${field.key}`, label: h('span', { class: 'fs-propose-label-text', text: t('propose.fields.premium_days') }), unit: t('propose.fields.unit_days'), width: 'courte' });
    days.classList.add('fs-premium-days');
    days.hidden = state0 !== 'true';
    const hidden = h('input', { type: 'hidden', name: `f-${field.key}`, value: state0 === 'false' ? '0' : '', 'data-fs-premium-off': true, disabled: state0 !== 'false' });
    const wrap = optionField(field, { classes: 'fs-propose-field-premium', group: { 'aria-describedby': described, 'aria-required': required(field) },
      legend: fieldHead(field, { legend: true, name: field.i18n?.label ? templateText(field, 'label') : t('propose.fields.premium_active'), meta: field.required ? null : clearButton(field) }),
      ctl: fieldCtl(h('div', { class: 'fs-premium' }, h('div', { class: 'fs-seg fs-choice' }, [['true', t('propose.common.yes')], ['false', t('propose.common.no')]].map(([choice, label], index) =>
        segment({ name: `p-${field.key}`, value: choice, id: index === 0 ? `${id}-active` : null, checked: choice === state0, 'data-fs-premium': true }, label))), days, hidden)),
      msg: fieldMsg(conflictLine(), errorLine(id), hintLine(id, hint)) });
    syncPremium(wrap);
    return wrap;
  }
  function syncPremium(block) {
    const active = block.querySelector('[data-fs-premium]:checked')?.value ?? '';
    const days = block.querySelector('.fs-premium-days');
    const off = block.querySelector('[data-fs-premium-off]');
    days.hidden = active !== 'true';
    days.querySelector('input').disabled = active !== 'true';
    /* Oui sans jours : rien n'est envoyé (le contrat n'a qu'un nombre) ; « Continuer » le signale (champ obligatoire). */
    let note = block.querySelector('[data-fs-premium-note]');
    if (!note) { note = h('p', { class: 'fs-field-hint', 'data-fs-premium-note': true, text: t('propose.fields.premium_note') }); (block.querySelector('[data-fs-error]') || days).after(note); }
    note.hidden = !(active === 'true' && !days.querySelector('input').value.trim());
    off.disabled = active !== 'false';
    off.value = active === 'false' ? '0' : '';
  }

  /*
   * Grandes listes (DO, NH : vaisseaux et designs) : recherche, liste filtrée, choix retirables, maxItems au plus. Liste
   * limitée à une autre (`within`, NH : designs mis en avant) : une option de la liste citée n'est proposée que cochée
   * plus haut ; décochée, elle est retirée des choix (fsPrune, appelé par onEdit). Avec `withinOnlySince`, toute option
   * doit y être cochée (NH : plus de cosmétiques de moteur, 15 octobre 2026).
   */
  function comboBlock(field, chosen, { id, hint, described }) {
    const key = field.key;
    const scope = new Set(field.within ? fieldMap().get(field.within)?.options || [] : []);
    const owned = () => new Set([...(state.form?.querySelectorAll(`input[name="f-${CSS.escape(field.within)}"]:checked`) || [])].map((box) => box.value));
    const only = field.within && field.withinOnlySince !== undefined;
    const allowed = (option, own = owned()) => (!only && !scope.has(option)) || own.has(option);
    const limit = field.maxItems || field.options.length;
    const listId = `${id}-list`;
    const input = h('input', { class: 'fs-input fs-combo-input', id, type: 'search', role: 'combobox', autocomplete: 'off', spellcheck: 'false', enterkeyhint: 'search',
      'aria-expanded': 'false', 'aria-controls': listId, 'aria-autocomplete': 'list', 'aria-describedby': [described, `${id}-picked`].filter(Boolean).join(' '), placeholder: t('propose.combo.placeholder') });
    /* tabindex -1 : la liste n'est pas un arrêt de tabulation (Chrome rend focalisable une zone défilante) ; le clavier
       la parcourt depuis la saisie (flèches, aria-activedescendant), selon le motif combobox. */
    const list = h('ul', { class: 'fs-combo-list', id: listId, role: 'listbox', 'aria-label': fieldName(field), 'aria-multiselectable': 'true', tabindex: '-1', hidden: true });
    const picked = h('ul', { class: 'fs-combo-picked', id: `${id}-picked`, 'aria-label': t('propose.combo.picked_label', { name: fieldName(field) }) });
    const status = h('p', { class: 'fs-field-hint fs-combo-status', role: 'status' });
    const boxes = h('div', { hidden: true });
    const none = noneBox(field, chosen);
    const wrap = h('div', { class: `fs-field fs-propose-field fs-propose-field-combo ${widthClass(field)}`, 'data-fs-field': key, 'data-fs-max': limit, 'data-fs-within': field.within || null },
      fieldHead(field, { id }),
      fieldCtl(h('div', { class: 'fs-combo' }, input, list), picked, status, boxes, none ? h('div', { class: 'fs-checks fs-options' }, none) : null),
      fieldMsg(errorLine(id), hintLine(id, hint)));
    /* « Aucun » coché (onEdit) : les choix déjà faits sont retirés. */
    wrap.fsClearPicks = () => { boxes.replaceChildren(); render(); };
    /* Choix retirés (case décochée, ou brouillon repris d'avant la règle) : dits dans le statut, jamais en silence. */
    wrap.fsPrune = () => {
      const own = owned();
      const stray = [...boxes.querySelectorAll('input')].filter((box) => !allowed(box.value, own));
      if (!stray.length) return false;
      stray.forEach((box) => box.remove());
      render();
      status.textContent = t('propose.combo.pruned', { count: stray.length, names: stray.map((box) => optionText(field, box.value)).join(', ') });
      return true;
    };
    let active = -1;
    const selected = () => [...boxes.querySelectorAll('input')].map((box) => box.value);
    const render = () => {
      const values = selected();
      picked.replaceChildren(...values.map((option) => h('li', {}, h('button', { type: 'button', class: 'fs-chip fs-chip--remove', 'data-fs-combo-remove': option },
        optionText(field, option), h('span', { class: 'fs-visually-hidden', text: t('propose.combo.remove_from', { name: lower(fieldName(field)) }) }), h('span', { 'aria-hidden': 'true', text: ' ×' })))));
      status.textContent = values.length >= limit ? t('propose.combo.limit', { limit: digits(limit) }) : '';
    };
    const options = (query) => {
      const needle = normalizeKey(query);
      const taken = new Set(selected());
      const own = owned();
      return field.options.filter((option) => !taken.has(option) && allowed(option, own) && (!needle || normalizeKey(optionText(field, option)).includes(needle) || normalizeKey(option).includes(needle))).slice(0, 12);
    };
    const open = () => {
      const items = options(input.value);
      active = items.length ? Math.min(Math.max(active, 0), items.length - 1) : -1;
      list.replaceChildren(...items.map((option, index) => h('li', { role: 'option', id: `${id}-o${index}`, 'data-value': option, 'aria-selected': 'false', class: index === active ? 'is-active' : null, text: optionText(field, option) })));
      /* Option de la liste de référence non cochée (NH : vaisseau absent de la grille) : le dire, plutôt qu'« Aucun résultat ». */
      const needle = normalizeKey(input.value);
      const own = owned();
      const unchecked = needle && [...scope].some((option) => !own.has(option) && (normalizeKey(optionText(field, option)).includes(needle) || normalizeKey(option).includes(needle)));
      if (!items.length && input.value.trim()) list.append(h('li', { class: 'fs-combo-empty', role: 'presentation', text: unchecked ? t('propose.combo.check_first') : t('propose.combo.no_result') }));
      list.hidden = document.activeElement !== input || !list.children.length;
      input.setAttribute('aria-expanded', String(!list.hidden));
      if (active >= 0) input.setAttribute('aria-activedescendant', `${id}-o${active}`); else input.removeAttribute('aria-activedescendant');
      /* Option active toujours visible dans la liste (12 options pour 280 px), sans faire défiler la page. */
      const current = list.querySelector('.is-active');
      if (current && !list.hidden) {
        if (current.offsetTop < list.scrollTop) list.scrollTop = current.offsetTop;
        else if (current.offsetTop + current.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = current.offsetTop + current.offsetHeight - list.clientHeight;
      }
      requestAnimationFrame(place);
    };
    /* Liste jamais sous la barre d'actions collante (GR-06) : ouverte vers le haut quand la place manque dessous et qu'il y
       en a davantage au-dessus, hauteur bornée à la place disponible ; recalculée à la fin d'un défilement. */
    const place = () => {
      list.classList.remove('is-up');
      list.style.removeProperty('max-height');
      if (list.hidden || !list.isConnected) return;
      const box = input.getBoundingClientRect();
      const foot = input.closest('.fs-step')?.querySelector('.fs-step-foot');
      const floor = Math.min(viewBottom(), foot?.getBoundingClientRect().height ? foot.getBoundingClientRect().top : viewBottom()) - 8;
      const below = floor - box.bottom - 4;
      const above = box.top - 4 - Math.max(viewTop() + 8, topInset() - 8);
      const need = list.offsetHeight;
      if (need <= below) return;
      const up = above > below;
      if (up) list.classList.add('is-up');
      const room = up ? above : below;
      if (need > room) list.style.maxHeight = `${Math.max(120, Math.floor(room))}px`;
    };
    (scroller ?? window).addEventListener('scrollend', () => { if (!list.hidden) place(); }, { passive: true });
    const add = (option) => {
      if (!option || selected().includes(option)) return;
      if (selected().length >= limit) { status.textContent = t('propose.combo.limit', { limit: digits(limit) }); return; }
      boxes.append(h('input', { type: 'checkbox', name: `f-${key}`, value: option, checked: true, tabindex: '-1' }));
      if (none) none.querySelector('input').checked = false;
      input.value = '';
      active = -1;
      render();
      open();
      onEdit({ type: 'change', target: input });
    };
    for (const option of chosen.filter((item) => field.options.includes(item)).slice(0, limit)) boxes.append(h('input', { type: 'checkbox', name: `f-${key}`, value: option, checked: true, tabindex: '-1' }));
    input.addEventListener('input', () => { active = 0; open(); });
    input.addEventListener('focus', open);
    input.addEventListener('blur', () => setTimeout(() => { if (document.activeElement !== input) { list.hidden = true; input.setAttribute('aria-expanded', 'false'); } }, 150));
    input.addEventListener('keydown', (event) => {
      const items = [...list.querySelectorAll('[role="option"]')];
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!items.length) return;
        active = (active + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        open();
      } else if (event.key === 'Enter') {
        event.preventDefault();
        add(items[active]?.dataset.value);
      } else if (event.key === 'Escape') { list.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    });
    /* Le choix se fait au clic, pas à l'appui : au toucher, poser le doigt pour faire défiler la liste choisissait l'option
       touchée (pointerdown) et redessinait la liste, qui ne défilait plus. Un défilement n'émet ni mousedown ni clic.
       mousedown empêché : la saisie garde le focus (liste ouverte, clavier mobile). Pas pointerdown : empêché, il supprime
       le clic au toucher sous WebKit (Safari et Chrome sur iPhone). */
    list.addEventListener('mousedown', (event) => { if (event.target.closest('[role="option"]')) event.preventDefault(); });
    list.addEventListener('click', (event) => { const item = event.target.closest('[role="option"]'); if (item) add(item.dataset.value); });
    picked.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fs-combo-remove]');
      if (!button) return;
      boxes.querySelector(`input[value="${CSS.escape(button.dataset.fsComboRemove)}"]`)?.remove();
      render();
      (picked.querySelector('button') || input).focus({ preventScroll: true });
      onEdit({ type: 'change', target: input });
    });
    render();
    return wrap;
  }

  /*
   * Widgets du thème sérialisés dans le texte actuel du modèle (spec 21 § 6, B.1) : contrat et synchro inchangés.
   * À la relecture, un texte non reconnu reste dans « Autre formulation » (rien n'est perdu). Réponse obligatoire
   * (VEND-04) : tant qu'une partie manque, le texte reste vide et « Continuer » le signale ; les parties déjà répondues
   * sont gardées à part dans le brouillon (`partial`) et remises à la reprise. Une réponse complète passe avant le
   * texte repris, qui reste gardé à part (`other`) et remis dans « Autre formulation » à la reprise. `read` : parties
   * répondues, telles que saisies ; `serialize` : leur texte, vide si une partie manque. Champ pleine largeur, posé sur
   * la même grille que les autres (spec 05 § 2.2).
   */
  function serialWidget(field, value, { id, hint, described, partial, otherText }, { parse, read, serialize, body }) {
    const text = typeof value === 'string' ? value.trim() : '';
    const parsed = text ? parse(text) : null;
    const kept = otherText || (text && parsed === null ? value : '');
    const hidden = h('input', { type: 'hidden', name: `f-${field.key}`, value: '' });
    const other = textBlock({ key: `${field.key}-other`, maxLength: field.maxLength ?? 200 }, kept, { id: `${id}-other`, name: `w-${field.key}-other`, label: h('span', { class: 'fs-propose-label-text', text: t('propose.widgets.other_wording') }) });
    /* « Autre formulation » seulement pour un texte repris non reconnu (rien n'est perdu) ; sinon, aucun champ libre. */
    const fold = kept ? h('div', { class: 'fs-widget-other' }, other) : null;
    const wrap = optionField(field, { classes: 'fs-propose-field-widget', attrs: { 'data-fs-widget': field.key }, group: { 'aria-describedby': described }, width: 'pleine',
      legend: fieldHead(field, { legend: true }),
      ctl: fieldCtl(body(parsed || partial || {}, id), fold, hidden),
      msg: fieldMsg(conflictLine(), errorLine(id), hintLine(id, hint)) });
    wrap.fsSerialize = () => { hidden.value = serialize(read(wrap)) || (fold ? other.querySelector('input').value.trim() : ''); };
    /* Brouillon : parties répondues d'une réponse incomplète ; rien si elle est complète ou vide. Texte de « Autre formulation ». */
    wrap.fsPartial = () => { const answers = read(wrap); return serialize(answers) || !Object.keys(answers).length ? null : answers; };
    wrap.fsOther = () => (fold ? other.querySelector('input').value.trim() : '');
    wrap.fsSerialize();
    return wrap;
  }
  const MISSIONS = Object.freeze(['Protos', 'Zeta', 'East', 'Kratos', 'Futurium']);
  /* Chaque mission répondue, sans présélection (VEND-04) : « Pas faite » est une réponse (0), pas un vide. */
  const MISSION_RUNS = Object.freeze([['0', t('propose.widgets.mission_not_done')], ['1', 'x1'], ['2', 'x2']]);
  const ENRICHMENTS = Object.freeze([['laser', 'Laser', 'shots', t('propose.widgets.enrichment_laser')], ['rockets', 'Rockets', 'shots', t('propose.widgets.enrichment_rockets')],
    ['shield', 'Shield', 'min', t('propose.widgets.enrichment_shield')], ['speed', 'Speed', 'min', t('propose.widgets.enrichment_speed')]]);
  /** Parties répondues d'un widget : { nom: valeur saisie } sans les vides. */
  const answered = (entries) => Object.fromEntries(entries.filter(([, answer]) => answer));
  const WIDGETS = {
    waruniverse: {
      /* Une rangée par mission : nom (demi) et segmenté à 3 choix (demi). */
      star_missions: (field, value, ctx) => serialWidget(field, value, ctx, {
        /* Texte relu : les 5 missions répondues (absente : pas faite). */
        parse: (text) => { const runs = parseStarMissions(text); return runs && Object.fromEntries(MISSIONS.map((name) => [name, runs[name] || '0'])); },
        read: (wrap) => answered(MISSIONS.map((name) => [name, wrap.querySelector(`[name="w-sm-${name}"]:checked`)?.value])),
        serialize: (runs) => (MISSIONS.every((name) => runs[name]) ? serializeStarMissions(runs) : ''),
        body: (runs, id) => h('div', { class: 'fs-missions' }, MISSIONS.map((name) => h('div', { class: 'fs-mission', role: 'radiogroup', 'aria-labelledby': `${id}-${name}` },
          h('span', { class: 'fs-mission-name', id: `${id}-${name}`, text: name }),
          h('div', { class: 'fs-seg fs-choice' }, MISSION_RUNS.map(([runs0, label]) => segment({ name: `w-sm-${name}`, value: runs0, checked: String(runs[name] ?? '') === runs0 }, label)))))),
      }),
      enrichments: enrichmentsWidget,
    },
    /* Enrichissements du raffinage, sur la même base que WarUniverse (retours du 15 octobre 2026). */
    novahorizon: {
      enrichments: enrichmentsWidget,
    },
  };
  /* Quatre nombres courts, unité dans le champ, sur une grille de 12 comme les autres quantités. */
  function enrichmentsWidget(field, value, ctx) {
    return serialWidget(field, value, ctx, {
      parse: parseEnrichments,
      read: (wrap) => answered(ENRICHMENTS.map(([part]) => [part, wrap.querySelector(`[name="w-en-${part}"]`)?.value.trim()])),
      serialize: (answers) => {
        const parts = Object.fromEntries(ENRICHMENTS.map(([part]) => [part, parseNumber(answers[part] ?? '')]));
        return Object.values(parts).includes(null) ? '' : serializeEnrichments(parts);
      },
      body: (parts, id) => h('div', { class: 'fs-form-grid fs-step-fields' }, ENRICHMENTS.map(([part, , unit, label]) => numberBlock({ key: `en-${part}`, type: 'integer', min: 0 }, parts[part] ?? '', {
        id: `${id}-${part}`, name: `w-en-${part}`, label: h('span', { class: 'fs-propose-label-text', text: label }), unit: unit === 'min' ? t('propose.widgets.unit_minutes') : t('propose.widgets.unit_shots'), width: 'courte' }))),
    });
  }
  /** État de la jauge à droite du libellé : « 6 sur 8 » (rien tant qu'aucun cran n'est choisi) ; crans jusqu'à la valeur marqués. */
  function syncGauge(wrap) {
    const chosen = wrap.querySelector('input:checked');
    const total = wrap.dataset.fsGaugeTotal;
    wrap.querySelector('[data-fs-gauge-state]').textContent = chosen ? t('propose.fields.gauge_of', { value: digits(chosen.value), total: digits(total) }) : '';
    const value = chosen ? Number(chosen.value) : -1;
    wrap.querySelectorAll('[data-fs-cran]').forEach((cran) => cran.classList.toggle('is-on', Number(cran.dataset.fsCran) <= value));
  }
  /** Arrondi proposé sous un grand nombre (au-delà du seuil), mis à jour à la sortie du champ. */
  function syncRound(wrap) {
    const round = wrap.querySelector('[data-fs-round]');
    if (!round) return;
    const number = parseNumber(wrap.querySelector('.fs-num-input').value);
    const show = number !== null && number > ROUND_THRESHOLD && roundPublic(number) !== number;
    round.hidden = !show;
    if (!show) return;
    round.querySelector('[data-fs-round-value="round"]').textContent = digits(roundPublic(number));
    round.querySelector('[data-fs-round-value="exact"]').textContent = digits(number);
  }

  /**
   * Groupe de champs d'une étape (spec 05 § 2) : titre (fieldset + légende), aide sous le titre, puis la grille de 12 ;
   * tout est visible (rien de replié, VEND-04). Un groupe sans titre garde la même grille.
   */
  function groupBlock(group, values) {
    const fields = fieldMap();
    const keys = group.fields.filter((key) => fields.has(key));
    const blocks = keys.map((key) => fieldBlock(fields.get(key), values[key]));
    /* Groupe d'un seul champ au même nom (« Star Missions », « Vaisseaux ») : le libellé du champ n'est pas répété à
       l'écran (fs-field--sole : masqué visuellement par la feuille, toujours lu ; la rangée garde compteur et « Effacer »).
       `sole` : même règle quand le nom du champ reste en anglais du jeu (NH « Enrichments » sous « Enrichissements »). */
    if (group.title && blocks.length === 1 && (group.sole || normalizeKey(fieldName(fields.get(keys[0]))) === normalizeKey(group.title))) blocks[0].classList.add('fs-field--sole');
    const grid = h('div', { class: 'fs-form-grid fs-step-fields' }, blocks);
    const hint = group.hint ? h('p', { class: 'fs-step-group-hint', text: frenchSpacing(group.hint) }) : null;
    if (!group.title) return h('div', { class: 'fs-step-group' }, hint, grid);
    const icon = packKeyIcon(group.icon);
    return h('fieldset', { class: 'fs-step-group' },
      h('legend', { class: 'fs-step-group-title' }, icon ? h('img', { src: icon.url, alt: '', width: 20, height: 20, loading: 'lazy', decoding: 'async' }) : null, group.title),
      hint, grid);
  }
  /** Champ montré pour ces valeurs : déclencheur `requiredIf` à plus de 0 ou oui, aucune dispense `requiredUnless` active. */
  const fieldShown = (field, values) => (!Array.isArray(field.requiredIf) || field.requiredIf.some((key) => state.lib.activeValue(values[key])))
    && !(Array.isArray(field.requiredUnless) && field.requiredUnless.some((key) => state.lib.activeValue(values[key])));
  /** Champs conditionnels (`requiredIf`, NH : niveau Wingman ; `requiredUnless`, RG : recherches au maximum, NH : lignes
      du labo au maximum, inutiles quand tout est complet) : montrés seulement quand leur condition le demande. Une liste
      dispensée se décoche aussi (demande de l'équipe du 29 octobre 2026) : repasser à « Non » repart d'une liste vide. */
  function syncConditional() {
    if (!state.form || typeof state.lib?.activeValue !== 'function') return;
    const values = readInput({ exact: true }).values;
    for (const field of fieldsOf(template()).filter((item) => Array.isArray(item.requiredIf) || Array.isArray(item.requiredUnless))) {
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(field.key)}"]`);
      if (!block) continue;
      block.hidden = !fieldShown(field, values) || hiddenImport(field.key);
      if (block.hidden && field.type === 'multichoice' && state.lib.waived?.(field, values)) {
        const checked = [...block.querySelectorAll('input[type="checkbox"]:checked')];
        checked.forEach((input) => { input.checked = false; });
        if (checked.length) syncChecks(block);
      }
    }
    syncImported();
    /* Un groupe dont tous les champs sont masqués (« Full Labs » ou « Recherche complète » oui) ne garde pas son titre seul. */
    state.form.querySelectorAll('.fs-step-group').forEach((group) => {
      const blocks = [...group.querySelectorAll('[data-fs-field]')];
      group.hidden = blocks.length > 0 && blocks.every((block) => block.hidden);
    });
    syncImportSteps();
  }
  /*
   * Import AccInsight (retours du 3 novembre 2026) : le vendeur ne relit plus ce que l'outil a rempli. Chaque champ
   * importé et valide est masqué ; une étape qui n'a plus rien à saisir sort du parcours (la piste, les numéros et
   * Continuer la sautent). Vérifier montre toujours tout ; son « Modifier » rouvre l'étape entière (revealed).
   */
  const importStep = (key) => STEP_PLAN[state.game]?.find((entry) => stepKeys(entry).includes(key))?.id ?? null;
  const hiddenImport = (key) => state.imported.has(key) && !state.revealed.has(importStep(key)) && !state.importErrors?.has(key);
  function syncImported() {
    if (!state.imported.size) { state.importErrors = new Set(); return; }
    /* Une valeur importée invalide (hors des bornes du modèle) reste à corriger : jamais masquée. */
    state.importErrors = new Set(Object.keys(validationErrors()).filter((key) => state.imported.has(key)));
    const conditional = new Set(fieldsOf(template()).filter((item) => Array.isArray(item.requiredIf) || Array.isArray(item.requiredUnless)).map((item) => item.key));
    for (const key of state.imported) {
      if (conditional.has(key)) continue;
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
      if (block) block.hidden = hiddenImport(key);
    }
  }
  function syncImportSteps() {
    const before = [...state.importSkip].join();
    state.importSkip = new Set();
    if (state.imported.size && !admin) {
      for (const entry of STEP_PLAN[state.game] || []) {
        const blocks = [...(stepNode(entry.id)?.querySelectorAll('[data-fs-field]') || [])];
        const imported = stepKeys(entry).some((key) => hiddenImport(key));
        if (imported && (state.view !== 'step' || entry.id !== state.step) && !entry.captures?.some((slot) => isPublic(slotDef(slot) || {})) && blocks.every((block) => block.hidden)) state.importSkip.add(entry.id);
      }
    }
    if ([...state.importSkip].join() !== before && state.view === 'step') { paintKickers(); renderRail(); }
  }

  /* ---- emplacements de capture (.fs-shot) ---- */
  const shotViews = {};
  const windowShare = () => Boolean(state.importUi?.windowShareAvailable?.(window));
  /** Libellé du niveau : « Obligatoire si Founder ou Pioneer » pour un emplacement rendu obligatoire par des réponses. */
  /** Badge du niveau : « Obligatoire si … » devient le badge « Obligatoire » ; la condition va dans une ligne à part (spec 05 § 1.7). */
  const conditional = (def) => Array.isArray(def.requiredIf) && def.requiredIf.length > 0 && def.level !== 'required';
  const levelText = (def) => (conditional(def) ? LEVEL_NAMES.required : LEVEL_NAMES[def.level] || LEVEL_NAMES.bonus);
  /* « A ou B ou C » en français (texte d'avant) ; ailleurs, la disjonction de la langue (Intl.ListFormat). */
  const orList = (items) => {
    if (locale === 'fr') return items.join(' ou ');
    try { return new Intl.ListFormat(locale, { type: 'disjunction' }).format(items); } catch { return items.join(' / '); }
  };
  const conditionText = (def) => t('propose.shots.condition', { fields: orList(def.requiredIf.map((key) => fieldName(fieldMap().get(key) || { label: key }))) });
  /** Ligne « Dans le jeu : Pilote › Résumé · EN : Pilot › Overview » (une ligne, Y2). */
  const whereLine = (def, tag = 'p', title = null) => {
    const screen = templateText(def, 'screen');
    return h(tag, { class: 'fs-shot-where' }, title ? [h('b', { text: title }), t('propose.shots.colon')] : t('propose.shots.in_game'), h(title ? 'span' : 'b', { text: screen }),
      def.screenEn && def.screenEn !== screen ? h('span', { class: 'fs-shot-where-en' }, ' · ', h('abbr', { title: t('propose.shots.in_english'), text: 'EN' }), `${t('propose.shots.colon')}${def.screenEn}`) : null);
  };
  /*
   * Emplacement de capture (spec 05 § 1.8) : titre et badge, visibilité, où la trouver, ce qu'elle prouve, exemple dessiné
   * jamais replié, dépôt, « Ajouter une capture ». Équipe seulement : ni bouton ni sélecteur de fichier (confidentialité).
   */
  function shotBlock(def) {
    const [schemaKey] = shotUi(def.id);
    const staff = !isPublic(def);
    const label = lower(templateText(def, 'label'));
    const view = {};
    const mandatory = def.level === 'required' && !conditional(def);
    view.title = h('h5', { class: 'fs-shot-title' }, templateText(def, 'label'), ' ', mandatory ? requiredMark() : h('span', { class: `fs-badge fs-shot-level fs-shot-level--${conditional(def) ? 'required' : def.level || 'bonus'}`, text: levelText(def) }));
    const head = h('div', { class: 'fs-shot-head' }, view.title,
      h('p', { class: 'fs-shot-visibility', 'data-visibility': staff ? 'staff' : 'public', text: staff ? SHOT_TEXT.staff : SHOT_TEXT.public }),
      conditional(def) ? h('p', { class: 'fs-shot-condition', text: conditionText(def) }) : null,
      def.screen ? whereLine(def) : null,
      def.proves ? h('p', { class: 'fs-shot-proves', text: frenchSpacing(t(staff ? 'propose.shots.proves_staff' : 'propose.shots.proves_buyer', { text: lower(templateText(def, 'proves')) })) }) : null);
    view.main = h('p', { class: 'fs-shot-cta-main' });
    view.alt = h('p', { class: 'fs-shot-cta-alt', hidden: true });
    view.pick = staff ? null : h('button', { type: 'button', class: 'fs-btn fs-btn--lg', 'data-shot-pick': def.id }, h('span', { 'data-shot-pick-label': true, text: t('propose.shots.add') }), h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label }) }));
    view.window = !staff && windowShare() ? h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-shot-fine', 'data-shot-window': def.id }, t('propose.shots.window'), h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label }) })) : null;
    view.input = staff ? null : h('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp', hidden: true, tabindex: '-1', 'aria-hidden': 'true', 'aria-required': mandatory ? 'true' : null, 'data-shot-input': def.id });
    view.zone = h('div', { class: 'fs-shot-zone', 'data-shot-drop': staff ? null : def.id },
      schemaOf(schemaKey),
      h('div', { class: 'fs-shot-cta' }, view.main, view.alt,
        def.mask ? h('p', { class: 'fs-shot-mask' }, h('span', {}, h('b', { text: t('propose.shots.before') }), lower(templateText(def, 'mask')))) : null,
        staff ? null : h('div', { class: 'fs-shot-buttons' }, view.pick, view.window),
        staff ? null : h('p', { class: 'fs-shot-formats', text: t('propose.shots.formats') })),
      view.input);
    view.thumb = h('img', { alt: t('propose.shots.thumb_alt', { label }), decoding: 'async' });
    view.figure = h('figure', { class: 'fs-shot-thumb' }, zoomButton(view.thumb, templateText(def, 'label')));
    view.status = h('p', { class: 'fs-shot-status', role: 'status' });
    view.name = h('p', { class: 'fs-shot-name' });
    view.progress = h('progress', { class: 'fs-shot-progress', max: 100, value: 0, 'aria-label': t('propose.shots.progress', { label }) });
    view.maskButton = h('button', { type: 'button', class: 'fs-btn', 'data-shot-mask': def.id }, t('propose.shots.mask'), h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label }) }));
    view.replace = h('button', { type: 'button', class: 'fs-btn', 'data-shot-replace': def.id }, t('propose.shots.replace'), h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label }) }));
    view.remove = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-shot-remove': def.id }, t('propose.shots.remove'), h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label }) }));
    view.cancel = h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-shot-cancel', 'data-shot-cancel': def.id }, t('propose.shots.cancel'), h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label }) }));
    view.file = staff ? null : h('div', { class: 'fs-shot-file' }, view.figure, h('div', { class: 'fs-shot-info' }, view.status, view.name, view.progress,
      h('div', { class: 'fs-shot-actions' }, view.maskButton, view.replace, view.remove, view.cancel)));
    view.tool = h('div', { 'data-shot-tool': def.id });
    view.extra = h('div', { 'data-shot-extra': def.id });
    view.error = h('p', { class: 'fs-field-error fs-propose-error', id: `fs-shot-${def.id}-error`, 'data-fs-error': true, role: 'alert', hidden: true });
    view.root = h('div', { class: 'fs-shot', 'data-slot': def.id, 'data-level': def.level, 'data-visibility': staff ? 'staff' : 'public', 'data-state': staff ? 'ticket' : 'empty', 'data-fs-field': `shot-${def.id}` },
      head, view.zone, view.file, view.tool, view.extra, view.error);
    shotViews[def.id] = view;
    return view.root;
  }

  /* Aperçu agrandissable (VEND-13) : la vignette est un bouton qui ouvre la capture en grand. */
  const zoomButton = (img, title) => h('button', { type: 'button', class: 'fs-shot-zoom', 'data-shot-zoom': title, 'aria-label': t('propose.shots.zoom_aria', { label: lower(title) }) },
    img, h('span', { class: 'fs-shot-zoom-hint', 'aria-hidden': 'true', text: t('propose.shots.zoom') }));
  let shotViewer = null;
  /** Visionneuse du catalogue (fs-ui-dialog.js) : focus gardé dedans, Échap, clic hors de l'image ou × pour fermer, focus rendu. */
  function openShotViewer(button) {
    const source = button.querySelector('img');
    if (!source?.getAttribute('src')) return;
    shotViewer ??= viewer({ closeLabel: t('propose.shots.close_viewer'), attrs: { 'data-fs-shot-viewer': true },
      onClose: () => shotViewer.img.removeAttribute('src') });
    shotViewer.title.textContent = button.dataset.shotZoom;
    Object.assign(shotViewer.img, { src: source.src, alt: source.alt });
    shotViewer.open({ opener: button, host: root });
  }

  /** Repli « Où trouver ces infos ? » : schéma et chemins FR / EN des écrans de l'étape. */
  function whereBlock(defs) {
    if (!defs.length) return null;
    return h('details', { class: 'fs-step-where' }, h('summary', { text: frenchSpacing(t('propose.shots.where_summary')) }),
      h('div', { class: 'fs-step-where-body' }, schemaOf(shotUi(defs[0].id)[0], { tag: '' }),
        h('ul', { class: 'fs-step-where-list' }, defs.filter((def) => def.screen).map((def) => whereLine(def, 'li', templateText(def, 'label'))))));
  }

  const nextButton = () => h('button', { type: 'button', class: 'fs-btn fs-btn--primary fs-btn--lg fs-btn--spinner fs-step-next', 'data-fs-step-next': true },
    h('span', { class: 'fs-step-next-text' }, h('span', { 'data-fs-next-main': true, text: t('propose.nav.continue') })), h('span', { 'aria-hidden': 'true', text: ' →' }));
  /** « Précédent » : la flèche seule sur téléphone (le texte reste lu, masqué visuellement par la feuille). */
  const prevButton = (text = t('propose.nav.back')) => h('button', { type: 'button', class: 'fs-btn fs-btn--lg fs-step-prev', 'data-fs-step-prev': true },
    h('span', { class: 'fs-step-prev-arrow', 'aria-hidden': 'true', text: '← ' }), h('span', { class: 'fs-step-prev-text', text }));
  /** « Envoyer l'annonce » (VEND-11) : dans la barre d'actions des conditions, à la place de « Continuer » (spec 05, GR-15). */
  const sendButton = () => h('button', { type: 'submit', class: 'fs-btn fs-btn--primary fs-btn--lg fs-btn--spinner fs-propose-send', 'data-fs-propose-send': true });
  /** Modification par l'équipe : « Enregistrer » (administrateur, appliqué tout de suite) ou « Proposer » (relu par un administrateur). */
  const adminSaveButton = () => h('button', { type: 'submit', class: 'fs-btn fs-btn--primary fs-btn--lg fs-btn--spinner fs-propose-send', 'data-fs-admin-save': true },
    h('span', { 'data-fs-admin-save-label': true, text: admin.text[admin.mode === 'review' ? 'proposeButton' : 'saveButton'] }));
  /**
   * Règle d'une étape (VEND-04) : quand la plupart de ses champs sont obligatoires, une phrase le dit une fois et seuls
   * les facultatifs portent une marque ; une quantité vide se remplit d'un 0. Sinon, chaque obligatoire porte sa marque.
   */
  function stepRule(fields) {
    const optional = fields.filter((field) => !field.required);
    state.markOptional = fields.length > 0 && optional.length * 2 < fields.length;
    if (!state.markOptional) return null;
    const quantities = fields.some((field) => field.type === 'integer' && field.required && (field.min ?? 0) === 0);
    return h('p', { class: 'fs-step-rule fs-step-required', 'data-fs-step-rule': true },
      `${t(optional.length ? 'propose.rule.all_but_optional' : 'propose.rule.all')}${quantities ? t('propose.rule.zero') : ''}`);
  }
  /** Grands nombres de l'aide « Chiffres lus dans le jeu » (spec 05, GR-17) : progression et monnaies, jamais les quantités. */
  const BIG_KEYS = Object.freeze(['experience', 'honor', 'rankpoints', 'credits', 'red_matter', 'celestium', 'platinium', 'golds', 'bitcoin', 'uridium', 'nova_core', 'aetherium']);
  const NUMBERS_HINT = t('propose.rule.numbers');

  /*
   * Une étape du jeu (spec 05 § 2) : résumé d'erreurs, note, puis, si l'étape a une capture publique, l'établi (côté
   * « Vos captures » d'abord dans le DOM, critère 23 ; colonne simple, jamais collante), règle d'étape, aide des grands
   * nombres, groupes titrés, captures « équipe » à envoyer dans le ticket, « Où trouver ces infos ? ».
   */
  function buildStep(entry, draft, index, count) {
    const values = draft.values || {};
    const defs = entry.captures.map(slotDef).filter(Boolean);
    const node = h('fieldset', { class: 'fs-step', 'data-fs-step': entry.id, 'aria-labelledby': `fs-step-${entry.id}-title`, hidden: true });
    const summary = h('div', { class: 'fs-alert fs-propose-alert fs-propose-summary', 'data-tone': 'danger', role: 'alert', tabindex: '-1', 'data-fs-step-summary': true, hidden: true });
    const body = h('div', { class: 'fs-step-body' }, summary);
    if (entry.id === 'titre') body.append(...titleBlocks(draft));
    else if (entry.id === 'verifier') body.append(reviewBlocks(), ...(admin ? [adminSaveBlocks()] : []));
    else if (entry.id === CONDITIONS_STEP) body.append(conditionsBlocks());
    /* Modification par l'équipe : net vendeur et commission (bloc fourni par fs-listing-admin.js, rien n'est calculé ici). */
    else if (entry.id === PRICE_STEP) body.append(admin ? adminPriceBlock() : priceBlock());
    else {
      if (entry.note) body.append(h('p', { class: 'fs-alert fs-propose-note', text: frenchSpacing(entry.note) }));
      const fields = fieldMap();
      const keys = stepKeys(entry);
      /* Aide des grands nombres : une fois, seulement si l'étape a un grand nombre et que son sous-titre ne dit pas déjà comment les taper. */
      const big = keys.some((key) => BIG_KEYS.includes(key) && roundable(fields.get(key)));
      const hint = big && entry.numbersHint !== false && !/arrondi/i.test(entry.lead || '') ? h('p', { class: 'fs-step-rule fs-step-numbers', 'data-fs-step-numbers': true, text: NUMBERS_HINT }) : null;
      const rule = stepRule(keys.map((key) => fields.get(key)).filter(Boolean));
      state.stepIcons = new Set();
      const groups = entry.groups.map((group) => groupBlock(group, values));
      state.stepIcons = null;
      state.markOptional = false;
      const shown = defs.filter(isPublic);
      const staff = defs.filter((def) => !isPublic(def));
      /* Captures « équipe seulement » : jamais dans la colonne des captures ; en fin d'étape, à envoyer dans le ticket. */
      const ticket = staff.length ? h('section', { class: 'fs-step-ticket', 'aria-labelledby': `fs-step-${entry.id}-ticket` },
        h('h4', { class: 'fs-step-ticket-title', id: `fs-step-${entry.id}-ticket`, text: t('propose.shots.to_ticket') }), staff.map(shotBlock)) : null;
      const where = whereBlock(defs.filter((def) => def.screen));
      if (shown.length) {
        /* Mode sans captures (service éteint) : un seul avis en tête de la colonne, avec la liste des captures (paintDegraded). */
        const side = h('div', { class: 'fs-bench-side', 'data-fs-step-shots': entry.id },
          h('h4', { class: 'fs-bench-title', text: t('propose.shots.yours') }),
          h('div', { class: 'fs-alert fs-propose-note fs-shots-off', 'data-fs-shots-off': true, hidden: true },
            h('p', { text: SHOT_TEXT.off }), h('ul', { class: 'fs-shots-off-list' }, shown.map((def) => h('li', { text: templateText(def, 'label') })))),
          shown.map(shotBlock),
          h('p', { class: 'fs-propose-fine fs-shot-privacy', text: SHOT_TEXT.privacy }), where);
        body.append(h('div', { class: 'fs-bench' }, side, h('div', { class: 'fs-bench-main' }, rule, hint, groups, ticket)));
      } else body.append(...[rule, hint, ...groups, ticket, where].filter(Boolean));
    }
    /* Modification par l'équipe : « Vérifier » enregistre ; la première étape n'a pas de « Précédent » (aucun accueil). */
    const back = prevButton();
    if (admin && index === 0) back.hidden = true;
    const foot = h('footer', { class: 'fs-step-foot' }, back,
      admin && entry.id === 'verifier' ? adminSaveButton() : entry.id === CONDITIONS_STEP ? sendButton() : [h('p', { class: 'fs-step-next-name', 'data-fs-next-name': true }), nextButton()]);
    node.append(stepHead(entry, { kicker: stepKicker(entry), title: entry.heading || entry.title }), body, foot);
    node.dataset.index = String(index);
    node.dataset.count = String(count);
    return node;
  }

  /** Valeur reprise non reconnue (choix fermé) : champ vidé, « À revoir » et la valeur d'origine rappelée en texte. */
  function markReview() {
    for (const [key, raw] of Object.entries(state.review || {})) {
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
      if (!block || block.hasAttribute('data-fs-review')) continue;
      block.setAttribute('data-fs-review', '');
      (block.querySelector('.fs-propose-label-text, legend, label') || block).append(h('span', { class: 'fs-badge fs-target-badge', text: t('propose.review_note.badge') }));
      block.querySelector('[data-fs-error]')?.before(h('p', { class: 'fs-field-hint fs-review-note', text: t('propose.review_note.unknown_value', { value: String(raw).slice(0, 80) }) }));
    }
    /* Valeur connue mais exclue de la liste (carburant du P.E.T.) : retirée avec un avertissement, jamais « à revoir ». */
    for (const key of state.ignoredKeys || []) {
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
      if (!block || block.querySelector('[data-fs-ignored-note]')) continue;
      block.querySelector('[data-fs-error]')?.before(h('p', { class: 'fs-field-hint', 'data-fs-ignored-note': true, text: t(key === 'pet_gear' ? 'propose.review_note.rex_removed' : 'propose.review_note.value_removed') }));
    }
  }

  /* ---- étape Titre : suggestion, marqueurs, étiquettes suggérées (spec 03 § 5.6) ---- */
  /*
   * Badge « Suggestion FOR SALE » et « Reprendre la suggestion » dans la rangée du libellé, champ et aide plafonnés
   * par la feuille (spec 05 § 2.3) ; étiquettes en puces sous la consigne. Aucun aperçu en direct.
   */
  /** Libellé du titre : celui du modèle (traduit s'il l'est ; texte français gardé en français), sinon le nôtre. */
  const titleLabel = (tpl) => pick(tpl.i18n?.title) || (locale === 'fr' ? tpl.title?.label : '') || t('propose.title_step.label');
  function titleBlocks(draft) {
    const tpl = template();
    const pack = packOf(state.game);
    const id = 'fs-propose-title-input';
    const input = h('input', { class: 'fs-input', id, name: 'fs-title', type: 'text', autocomplete: 'off', enterkeyhint: 'done', maxlength: tpl.title?.maxLength ?? 120, 'aria-required': 'true', 'aria-describedby': `${id}-hint ${id}-count` });
    input.value = draft.title || '';
    const titleField = h('div', { class: 'fs-field fs-propose-field fs-propose-field-title fs-w-pleine fs-size-l', 'data-fs-field': 'title' },
      h('p', { class: 'fs-field-head' },
        h('label', { class: 'fs-field-label fs-propose-label', for: id }, labelIcon(), h('span', { class: 'fs-propose-label-text' },
          h('span', { class: 'fs-propose-label-name', text: titleLabel(tpl) }), requiredMark())),
        h('span', { class: 'fs-field-meta fs-title-meta' }, h('span', { class: 'fs-badge', 'data-tone': 'accent', 'data-fs-title-badge': true, text: t('propose.title_step.badge') }),
          h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-title-reset': true, hidden: true, text: t('propose.title_step.reset') }),
          h('span', { class: 'fs-counter', id: `${id}-count`, 'data-fs-title-count': true, hidden: true }))),
      fieldCtl(input),
      fieldMsg(errorLine(id), h('p', { class: 'fs-field-hint fs-propose-hint', id: `${id}-hint`, text: frenchSpacing(t('propose.title_step.hint')) })));
    const suggestBox = h('div', { class: 'fs-title-suggest' }, h('div', { class: 'fs-form-grid' }, titleField),
      h('div', { class: 'fs-chips', role: 'group', 'aria-label': t('propose.title_step.add_to_title'), 'data-fs-title-markers': true }));
    /* Étiquettes (spec 21 § 3.4) : message dès l'arrivée, rangée « Suggérées pour votre compte » (mêmes cases que la
       liste, déplacées, jamais cochées par le site), puis la liste complète. */
    const minTags = Number(tpl.minTags) || 0;
    const tags = h('div', { class: 'fs-field fs-propose-field fs-propose-tags fs-w-pleine fs-size-l', 'data-fs-field': 'tags' },
      h('fieldset', { class: 'fs-field-set', 'aria-describedby': 'fs-propose-tags-hint', 'aria-required': minTags ? 'true' : null },
        h('legend', { class: 'fs-field-head' }, h('span', { class: 'fs-field-label fs-propose-label' }, labelIcon(),
          h('span', { class: 'fs-propose-label-text' }, h('span', { class: 'fs-propose-label-name', text: t('propose.title_step.tags') }), minTags ? requiredMark() : null))),
        fieldCtl(h('p', { class: 'fs-field-hint fs-propose-hint fs-tags-hint', id: 'fs-propose-tags-hint', text: frenchSpacing(t(minTags ? 'propose.title_step.tags_hint_min' : 'propose.title_step.tags_hint')) }),
          h('div', { class: 'fs-tags-suggested', 'data-fs-tags-suggested': true },
            h('p', { class: 'fs-tags-suggested-title', text: t('propose.title_step.suggested') }),
            h('div', { class: 'fs-options', 'data-fs-tags-suggested-list': true }),
            h('p', { class: 'fs-field-hint', 'data-fs-tags-none': true, hidden: true, text: t('propose.title_step.no_suggestion') })),
          h('div', { class: 'fs-options fs-propose-tag-list', 'data-fs-tags-list': true }, tpl.tags.map((tag, index) => h('label', { class: 'fs-option fs-propose-tag', 'data-fs-tag': tag },
            h('input', { type: 'checkbox', name: 'fs-tags', value: tag, id: index === 0 ? 'fs-propose-f-tags' : null, checked: (draft.tags || []).includes(tag) }),
            iconImage(packIcon(pack, tag), 20, 'fs-propose-tag-icon'), h('span', { text: tagLabel(tag) }), h('small', { class: 'fs-chip-note', 'data-fs-tag-note': true, hidden: true }))))),
        fieldMsg(errorLine('fs-propose-f-tags'))));
    return [suggestBox, h('div', { class: 'fs-form-grid' }, tags)];
  }

  /* ---- étape Votre prix (VEND-09) : un seul champ, entier en euros, unité « € » dans le champ ; aucun calcul ---- */
  function priceBlock() {
    const id = 'fs-propose-f-expectedNet';
    const input = h('input', { class: 'fs-input fs-propose-price-input', id, name: 'fs-price', type: 'text', inputmode: 'numeric', autocomplete: 'off', spellcheck: 'false',
      enterkeyhint: 'done', maxlength: 12, 'aria-required': 'true', 'aria-describedby': `${id}-hint` });
    input.value = state.price || '';
    return h('div', { class: 'fs-form-grid' }, h('div', { class: 'fs-field fs-num fs-propose-field fs-propose-price fs-w-tiers fs-size-m', 'data-fs-field': 'expectedNet' },
      h('p', { class: 'fs-field-head' }, h('label', { class: 'fs-field-label fs-propose-label', for: id }, labelIcon(), h('span', { class: 'fs-propose-label-text' },
        h('span', { class: 'fs-propose-label-name', text: t('propose.price_step.label') }), h('span', { class: 'fs-visually-hidden', text: t('propose.price_step.in_euros_sr') }), requiredMark()))),
      fieldCtl(h('div', { class: 'fs-num-box has-unit fs-propose-price-box' }, input, h('span', { class: 'fs-num-unit fs-propose-price-unit', 'aria-hidden': 'true', text: '€' }))),
      fieldMsg(errorLine(id), hintLine(id, t('propose.price_step.hint')))));
  }

  /*
   * ---- étape Vérifier (VEND-10) : la carte telle qu'en vitrine, la galerie des captures publiques et les captures « équipe »
   * à envoyer dans le ticket, puis « Votre annonce » : une ligne par étape (liste de description), 3 valeurs au plus.
   * Plus de texte Discord, de panneau des preuves ni de reçu d'achat ici ; « Continuer » mène aux conditions de vente. ----
   */
  function reviewBlocks() {
    return h('div', { class: 'fs-review' },
      h('div', { class: 'fs-review-card' },
        h('div', { 'data-fs-review-card': true }),
        h('ul', { class: 'fs-review-gallery', 'data-fs-review-gallery': true, 'aria-label': t('propose.review_step.gallery') }),
        h('p', { class: 'fs-review-caption', 'data-fs-review-caption': true, text: t('propose.review_step.caption') }),
        h('p', { class: 'fs-review-staff', 'data-fs-review-staff': true, hidden: true })),
      h('div', { class: 'fs-review-main' },
        h('div', { class: 'fs-alert fs-propose-banner', 'data-tone': 'warning', 'data-fs-review-lost': true, hidden: true }),
        h('h4', { class: 'fs-step-group-title fs-review-list-title', id: 'fs-review-list-title', text: t('propose.review_step.list_title') }),
        h('dl', { class: 'fs-review-list', 'data-fs-review-list': true, 'aria-labelledby': 'fs-review-list-title' })));
  }

  /*
   * ---- étape Conditions de vente (VEND-11) : les six points (liste numérotée), la case liée à son libellé et à son
   * erreur, la connexion Discord au clic sur « Envoyer l'annonce », la petite ligne de relecture. Même texte pour tous
   * les jeux ; la version suit le ticket vendeur (termsList, syncTerms). ----
   */
  function termsList() {
    return h('ol', { class: 'fs-terms-list', 'data-fs-terms': TERMS_VERSIONS[termsKey()] }, SALE_TERMS[termsKey()].map(([lead, rest]) => h('li', {}, h('strong', { text: lead }), rest)));
  }
  /**
   * Version des conditions affichée remise à jour dès que /me la change (session connue avant les conditions), saisie
   * gardée. Case déjà cochée : décochée, avec un mot sous la case, l'acceptation portait sur l'autre texte.
   */
  function syncTerms() {
    const list = stepNode(CONDITIONS_STEP)?.querySelector('[data-fs-terms]');
    if (!list || list.dataset.fsTerms === TERMS_VERSIONS[termsKey()]) return;
    list.replaceWith(termsList());
    const box = stepNode(CONDITIONS_STEP)?.querySelector('[name="fs-commit"]');
    if (box?.checked) { box.checked = false; setError('commit', siteError(t('propose.step_errors.terms_changed'))); }
  }
  function conditionsBlocks() {
    return h('div', { class: 'fs-terms' },
      h('div', { class: 'fs-alert fs-propose-banner', 'data-tone': 'warning', 'data-fs-review-lost': true, hidden: true }),
      termsList(),
      h('div', { class: 'fs-review-send' },
        h('div', { class: 'fs-field fs-propose-field', 'data-fs-field': 'commit' },
          h('label', { class: 'fs-commit' }, h('input', { class: 'fs-checkbox', type: 'checkbox', name: 'fs-commit', id: 'fs-propose-commit', 'aria-required': 'true', 'aria-describedby': 'fs-propose-commit-error' }),
            h('span', {}, h('span', { 'data-fs-commit-label': true, text: TERMS_COMMIT.seller }), ' ', requiredMark())),
          errorLine('fs-propose-commit')),
        /* Identité Discord sous la case ; « Envoyer l'annonce » est dans la barre d'actions (sendButton, spec 05 GR-15). */
        h('div', { class: 'fs-review-auth', 'data-fs-review-auth': true }),
        h('p', { class: 'fs-propose-status', role: 'status', 'data-fs-propose-send-status': true }),
        h('p', { class: 'fs-propose-fine', 'data-fs-review-fine': true, text: TERMS_FINE })));
  }

  /* ---- accueil du jeu (spec 03 § 3.2) ---- */
  function buildWelcome() {
    const tpl = template();
    const [x, y] = GAME_TIMES[state.game] || [8, 12];
    const prep = WELCOME_PREP[state.game] || { slots: [], second: '' };
    const first = slotDef(prep.slots[0]);
    const entry = { id: 'accueil', icon: 'emblem', lead: t('propose.welcome.lead', { min: x, max: y }) };
    const start = h('button', { type: 'button', class: 'fs-btn fs-btn--primary fs-btn--lg fs-btn--spinner fs-step-next', 'data-fs-propose-start': true },
      h('span', { class: 'fs-step-next-text' }, h('span', { text: t('propose.welcome.start') }), h('small')), h('span', { 'aria-hidden': 'true', text: ' →' }));
    const welcome = h('section', { class: 'fs-step fs-propose-welcome', 'aria-labelledby': 'fs-welcome-accueil-title', 'data-fs-propose-welcome': true, hidden: true },
      stepHead(entry, { kicker: names[state.game] || tpl.name, title: t('propose.welcome.title', { game: names[state.game] || tpl.name }), idPrefix: 'fs-welcome' }),
      h('div', { class: 'fs-step-body' },
        h('div', { 'data-fs-welcome-banner': true }),
        h('div', { class: 'fs-step-group' },
          h('p', { class: 'fs-step-group-title', text: t('propose.welcome.prep') }),
          h('ul', { class: 'fs-welcome-prep' },
            first ? h('li', {}, schemaOf(shotUi(first.id)[0], { tag: '' }), h('span', {}, t('propose.welcome.prep_shot', { label: lower(templateText(first, 'label')) }), h('small', { text: t('propose.welcome.essential') }))) : null,
            prep.slots[1] ? h('li', {}, schemaOf(shotUi(prep.slots[1])[0], { tag: '' }), h('span', {}, prep.second, h('small', { text: t('propose.welcome.convince') }))) : null,
            h('li', {}, schemaOf(Object.keys(SHOT_SCHEMAS).find((key) => key.startsWith(`${{ waruniverse: 'wu', redgalaxy: 'rg', darkorbit: 'do', novahorizon: 'nh' }[state.game]}-`) && SHOT_SCHEMAS[key].layout === 'profile') || 'receipt', { tag: '', masks: false }),
              h('span', {}, t('propose.welcome.game_open'), h('small', { text: t('propose.welcome.game_open_why') }))))),
        h('p', { class: 'fs-welcome-line', 'data-fs-welcome-discord': true }),
        h('p', { class: 'fs-welcome-line', 'data-fs-welcome-tip': true, hidden: true, text: t('propose.welcome.tip') }),
        h('p', { class: 'fs-welcome-never', text: t('propose.welcome.never') }),
        h('div', { 'data-fs-tware-slot': true })),
      h('footer', { class: 'fs-step-foot' }, start));
    start.addEventListener('click', () => enter(FIRST_STEP, { origin: start }));
    paintDiscordLine(welcome);
    return welcome;
  }
  /** Ligne Discord et bouton de l'accueil : l'invitation s'ouvre dans un nouvel onglet ; sans session, « Commencer »
      annonce la connexion Discord (nouvelle fenêtre). */
  function paintDiscordLine(welcome = state.welcome) {
    const line = welcome?.querySelector('[data-fs-welcome-discord]');
    if (!line) return;
    const label = welcome.querySelector('[data-fs-propose-start] .fs-step-next-text > span');
    const startText = t(token() ? 'propose.welcome.start' : state.pendingLogin ? 'propose.welcome.connecting' : 'propose.welcome.login_to_start');
    if (label && label.textContent !== startText) label.textContent = startText;
    /* Sans session, le bouton ouvre la connexion Discord dans une nouvelle fenêtre : dit aux lecteurs d'écran. */
    const startButton = welcome.querySelector('[data-fs-propose-start]');
    if (token()) startButton?.removeAttribute('aria-label');
    else startButton?.setAttribute('aria-label', t('propose.welcome.new_window_aria', { label: startText }));
    const { text, invite } = discordWelcome({ join: state.join, invite: root.dataset.fsDiscordInvite, connected: Boolean(token()) });
    /* Inchangée : rien n'est reconstruit (le lien d'invitation garde le focus pendant les rafraîchissements). */
    if (line.dataset.fsShown === `${text}|${invite}`) return;
    line.dataset.fsShown = `${text}|${invite}`;
    line.replaceChildren(text, ...(invite ? [t('propose.welcome.not_member'),
      h('a', { class: 'fs-link', href: invite, target: '_blank', rel: 'noopener noreferrer', 'data-fs-welcome-invite': true }, t('propose.welcome.join_server'), h('span', { class: 'fs-visually-hidden', text: t('propose.common.new_tab') })),
      t('propose.welcome.come_back')] : []));
  }
  /* Ajout au serveur à la connexion (GET /features → join, public, sans session) : cache d'onglet de 5 min partagé avec
     fs-ticket.js, relu à chaque ouverture du formulaire ; la promesse ne couvre que la lecture en cours. Faux si
     illisible (la ligne sans ajout reste). */
  let joinPromise = null;
  function probeJoin() {
    joinPromise ??= (async () => {
      const cached = readJoinCache(store.get(JOIN_KEY));
      if (cached !== null) return cached;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${service}/features`, { mode: 'cors', credentials: 'omit', signal: controller.signal });
        const join = response.ok && (await response.json().catch(() => null))?.join === true;
        if (response.ok) store.set(JOIN_KEY, JSON.stringify({ at: Date.now(), join }));
        return join;
      } catch { return false; } finally { clearTimeout(timer); }
    })().finally(() => { joinPromise = null; });
    return joinPromise.then((join) => {
      if (join === state.join) return;
      state.join = join;
      paintDiscordLine();
      renderAuth();
    });
  }

  function buildForm() {
    const tpl = template();
    const draft = state.drafts[state.game] || { title: '', tags: [], values: {} };
    state.price = draft.price || '';
    /* Identifiant du brouillon prérempli (lien du mode gardé) ; un brouillon neuf n'en a pas. */
    state.draftId = draft.id || '';
    state.imported = new Set(draft.imported || []);
    state.revealed = new Set(draft.revealed || []);
    state.importSkip = new Set();
    /* Étape « prix » d'un brouillon alors que le service ne l'annonce pas (encore) : reprise au titre. */
    state.step = draft.step && !stepById(draft.step) && draft.step === PRICE_STEP ? 'titre' : draft.step || FIRST_STEP;
    state.visited = new Set(draft.visited || []);
    state.skipped = new Set(draft.skipped || []);
    state.titleEdited = draft.titleEdited === true;
    state.tagsSeen = draft.tagsSeen === true;
    state.rounding = { ...(draft.rounding || {}) };
    state.partial = { ...(draft.partial || {}) };
    state.other = { ...(draft.other || {}) };
    /* Attestation AccInsight : elle ne vaut que pour l'import fait dans ce formulaire (revue Duo de la !262). */
    Object.assign(state, { errorSteps: new Set(), editing: false, reads: {}, readKeys: new Set(), accountCheck: null });
    for (const key of Object.keys(shotViews)) delete shotViews[key];
    restoreMedia(draft.captures || {});
    /* Choix fermés : valeurs ramenées à l'option du modèle ; une valeur inconnue est vidée et marquée « à revoir ». */
    const report = { ignored: [] };
    const upgraded = typeof state.lib.upgradeLegacyValues === 'function' ? state.lib.upgradeLegacyValues(tpl, draft.values || {}, report) : (draft.values || {});
    const closed = restoreClosedValues(tpl, upgraded, (field, raw) => (typeof state.lib.matchOption === 'function' ? state.lib.matchOption(field, raw) : (field.options.includes(raw) ? raw : null)));
    draft.values = closed.values;
    state.review = closed.review;
    state.ignoredKeys = [...new Set([...report.ignored, ...(closed.ignored.length ? fieldsOf(tpl).filter((field) => Array.isArray(field.ignored)).map((field) => field.key) : [])])];
    const list = allSteps();
    const form = h('form', { class: 'fs-propose-form', novalidate: true, 'data-fs-propose-form': true, 'data-game': state.game, 'aria-label': t('propose.form.aria', { game: names[state.game] || tpl.name }), hidden: true },
      h('p', { class: 'fs-step-live', role: 'status', 'aria-live': 'polite', 'data-fs-step-live': true }),
      list.map((entry, index) => buildStep(entry, draft, index, list.length)));
    state.form = form;
    markReview();
    syncOtherServers();
    /* Brouillon repris : un design mis en avant dont le vaisseau n'est pas coché est retiré, et le statut le dit. */
    form.querySelectorAll('[data-fs-within]').forEach((combo) => combo.fsPrune?.());
    syncConditional();
    form.querySelectorAll('[data-fs-clear]').forEach((button) => syncClear(button.closest('[data-fs-field]')));
    state.welcome = buildWelcome();
    state.done = null;
    ui.slot.replaceChildren(state.welcome, form);
    form.addEventListener('input', onEdit);
    form.addEventListener('change', onEdit);
    form.addEventListener('focusout', onLeave);
    form.addEventListener('submit', onSubmit);
    form.addEventListener('click', onClick);
    form.addEventListener('keydown', onKeydown);
    form.addEventListener('pointerdown', rememberChoice, true);
    form.addEventListener('animationend', (event) => { if (event.target.classList?.contains('fs-step-body')) event.target.closest('.fs-step')?.removeAttribute('data-enter'); });
    bindShots(form);
    Object.keys(shotViews).forEach(renderShot);
    paintDegraded();
    mountTware();
    refreshDerived();
    /* Brouillon d'une modification ou d'une correction (rechargement, reprise) : bandeau et éléments marqués de nouveau. */
    if (state.correction && !state.correction.pending && state.correction.game === state.game) markCorrection();
  }

  /* ---- vues : choix du jeu, accueil, étape, succès ---- */
  const stepNode = (id) => state.form?.querySelector(`[data-fs-step="${CSS.escape(id)}"]`) || null;
  const indexOf = (id) => steps().findIndex((entry) => entry.id === id);
  function showView(view) {
    state.view = view;
    ui.chooser.hidden = !state.chooser && view !== 'chooser';
    if (view === 'chooser') { state.chooser = true; ui.chooser.hidden = false; }
    if (state.welcome) state.welcome.hidden = view !== 'welcome';
    if (state.form) state.form.hidden = view !== 'step';
    if (state.done) state.done.hidden = view !== 'done';
    ui.rail.hidden = view !== 'step';
    ui.change.hidden = Boolean(admin) || state.chooser || !state.game || view === 'done';
    showSaved(false);
  }

  function showWelcome({ clicked = true, push = true, dir = 'back', focus = true } = {}) {
    if (!state.welcome) return;
    showView('welcome');
    const draft = state.drafts[state.game];
    const banner = state.welcome.querySelector('[data-fs-welcome-banner]');
    banner.replaceChildren();
    if (state.restored.has(state.game) && draft && (hasProgress(draft) || !isEmptyDraft(draft))) banner.append(resumeBanner(draft));
    state.welcome.querySelector('[data-fs-welcome-tip]').hidden = state.analysis !== true || !slotsOf().some(isPublic);
    if (!reduced()) { state.welcome.removeAttribute('data-enter'); void state.welcome.offsetWidth; state.welcome.dataset.enter = dir; }
    if (push) pushHistory({ view: 'welcome' });
    if (!focus) return;
    scrollTop(ui.console || state.welcome, clicked);
    state.welcome.querySelector('.fs-step-title')?.focus({ preventScroll: true });
  }
  /** « Bon retour ! » : reprise du brouillon à l'étape exacte, ou effacement confirmé en ligne (spec 03 § 3.6). */
  function resumeBanner(draft) {
    /* Étape « prix » pas (encore) annoncée par le service : reprise à l'étape posée par buildForm (le titre). */
    const entry = stepById(draft.step || FIRST_STEP) || stepById(state.step) || stepById(FIRST_STEP);
    const lost = Object.values(draft.captures || {}).some((capture) => capture.state === 'lost');
    const resume = h('button', { type: 'button', class: 'fs-btn fs-btn--primary', 'data-fs-propose-resume': true, text: t('propose.resume.resume') });
    const reset = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-propose-reset': true, text: t('propose.resume.restart') });
    const other = state.otherGame && state.otherGame !== state.game ? state.otherGame : '';
    const text = other
      ? h('p', {}, t('propose.resume.other_in_progress', { game: names[state.game], step: indexOf(entry.id) + 1, title: entry.title }))
      : h('p', {}, h('strong', { text: t('propose.resume.welcome_back') }), t('propose.resume.waiting', { game: names[state.game], step: indexOf(entry.id) + 1, title: entry.title }),
        lost ? t('propose.resume.lost') : '');
    if (other) resume.textContent = t('propose.resume.resume_game', { game: names[state.game] });
    if (!token()) resume.setAttribute('aria-label', t('propose.welcome.new_window_aria', { label: resume.textContent }));
    const start = other ? h('button', { type: 'button', class: 'fs-btn', 'data-fs-propose-other': other, text: t('propose.resume.start_game', { game: names[other] || other }) }) : null;
    start?.addEventListener('click', () => requestGameChange(other));
    const actions = h('div', { class: 'fs-propose-actions' }, resume, start || reset);
    const banner = h('div', { class: 'fs-alert fs-propose-banner', role: 'status', 'data-fs-propose-banner': 'resume' }, text, actions);
    resume.addEventListener('click', () => { state.restored.delete(state.game); state.otherGame = ''; enter(entry.id, { origin: resume }); });
    reset.addEventListener('click', () => {
      const erase = h('button', { type: 'button', class: 'fs-btn', 'data-fs-propose-erase': true, text: t('propose.resume.erase') });
      const cancel = h('button', { type: 'button', class: 'fs-btn fs-btn--link', text: t('propose.shots.cancel') });
      text.textContent = t('propose.resume.erase_confirm', { game: names[state.game] });
      actions.replaceChildren(erase, cancel);
      erase.addEventListener('click', () => {
        unbindMode();
        delete state.drafts[state.game];
        state.restored.delete(state.game);
        releaseMedia(state.game);
        state.form = null;
        saveDrafts();
        buildForm();
        showWelcome({ push: false });
        applyChooser();
      });
      cancel.addEventListener('click', () => { banner.replaceWith(resumeBanner(draft)); state.welcome.querySelector('[data-fs-propose-resume]')?.focus({ preventScroll: true }); });
      erase.focus({ preventScroll: true });
    });
    return banner;
  }

  /* ---- historique : une entrée par étape sur #sell (arbitrage 8) ---- */
  function pushHistory(entry, replace = false) {
    /* Modification par l'équipe (fenêtre modale) : l'adresse de la fiche ne change pas. */
    if (admin) return;
    const base = history.state && typeof history.state === 'object' ? history.state : {};
    const data = { ...base, fsPropose: { game: state.game, ...entry } };
    try {
      if (replace) history.replaceState(data, '', '#sell');
      else history.pushState(data, '', '#sell');
    } catch { /* historique indisponible */ }
  }
  if (!admin) window.addEventListener('popstate', (event) => {
    const entry = event.state?.fsPropose;
    if (!state.form || state.busy) return;
    saveDrafts();
    if (!entry || entry.game !== state.game) {
      if (state.view === 'welcome' || state.view === 'step') { state.chooser = true; showView('chooser'); applyChooser(); }
      return;
    }
    if (entry.view === 'welcome' || !token()) showWelcome({ push: false, clicked: false });
    else if (entry.step && stepById(entry.step)) go(entry.step, { push: false, dir: indexOf(entry.step) < indexOf(state.step) ? 'back' : 'forward', clicked: false });
  });

  /* ---- navigation entre étapes ---- */
  /**
   * Entrée dans le parcours (« Commencer », « Reprendre », reprise d'un brouillon) : connecté, l'étape s'ouvre ; sinon
   * la connexion Discord passe d'abord, puis loggedIn ouvre l'étape demandée (state.afterLogin).
   */
  function enter(id, { origin = null } = {}) {
    if (token()) { state.afterLogin = null; go(id, { dir: 'forward' }); return; }
    state.afterLogin = id;
    startLogin({ origin });
  }
  function go(id, { dir = 'forward', push = true, clicked = true, replace = false, editing, focusKey = null } = {}) {
    /* Étape remplie par AccInsight, rouverte (Modifier sur Vérifier, lien d'erreur) : elle revient dans le parcours, entière. */
    if (state.importSkip.has(id)) { state.revealed.add(id); syncConditional(); }
    const entry = stepById(id);
    if (!entry || !state.form) return;
    if (editing !== undefined) state.editing = editing;
    if (FINAL_STEPS.includes(id)) state.editing = false;
    ui.banners.querySelector('[data-fs-propose-banner="game"]')?.remove();
    state.step = id;
    state.visited.add(id);
    state.restored.delete(state.game);
    showView('step');
    for (const node of state.form.querySelectorAll('[data-fs-step]')) node.hidden = node.dataset.fsStep !== id;
    const node = stepNode(id);
    /* Correction demandée : le bandeau suit le vendeur en haut de chaque étape. */
    const correction = ui.banners.querySelector('[data-fs-propose-banner="correction"]') || state.form.querySelector('[data-fs-propose-banner="correction"]');
    if (correction && state.correction && !state.correction.pending) node.querySelector('[data-fs-step-summary]').after(correction);
    if (id === 'titre') enterTitle();
    if (id === 'verifier') renderReview();
    if (id === CONDITIONS_STEP) renderConditions();
    paintKickers();
    updateFoot();
    renderRail();
    refreshDerived();
    if (!reduced()) { node.removeAttribute('data-enter'); void node.offsetWidth; node.dataset.enter = dir; }
    if (push || replace) pushHistory({ step: id }, replace);
    saveDrafts();
    const live = state.form.querySelector('[data-fs-step-live]');
    live.textContent = '';
    requestAnimationFrame(() => { live.textContent = t('propose.nav.live', { step: indexOf(id) + 1, total: steps().length, title: entry.heading || entry.title }); });
    if (focusKey) return;
    const title = node.querySelector('.fs-step-title');
    title?.focus({ preventScroll: true });
    /* Défilement mesuré une fois l'étape mise en page (deux images : images, replis, arrondi), puis vérifié une seule
       fois à la fin du défilement doux : un titre resté hors de l'écran est replacé sans animation. Jamais quand le
       focus a déjà quitté le titre : la personne tabule dans l'étape, son défilement de focus prime (GR-06). */
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (state.step !== id) return;
      showStep(node, clicked);
      setTimeout(() => {
        if (state.step !== id || !title?.isConnected || document.activeElement !== title) return;
        const rect = title.getBoundingClientRect();
        if (rect.top < topInset() - 2 || rect.bottom > viewBottom()) scrollTop(node, false);
      }, 600);
    }));
  }
  const nextId = (id) => steps()[indexOf(id) + 1]?.id;
  const prevId = (id) => steps()[indexOf(id) - 1]?.id;
  function next() {
    const id = state.step;
    if (id === CONDITIONS_STEP) return;
    /* Vérifier → Conditions de vente, seulement si toute l'annonce est complète (sinon les points à revoir, avec un lien). */
    if (id === 'verifier') { if (admin) adminSend(); else if (listingReady()) go(CONDITIONS_STEP, { dir: 'forward' }); return; }
    const errors = stepErrors(id);
    /* Tout est obligatoire (VEND-04) : résumé « n champs à compléter » (role=alert), focus sur le premier champ en erreur. */
    if (Object.keys(errors).length) { showStepErrors(id, errors, t('propose.error_summary.fields_to_complete', { count: Object.keys(errors).length }), { focusField: true }); return; }
    showStepErrors(id, {});
    state.errorSteps.delete(id);
    if (state.editing) { go('verifier', { dir: 'forward' }); return; }
    go(nextId(id), { dir: 'forward' });
  }
  function previous() {
    const id = state.step;
    const before = prevId(id);
    if (!before) { saveDrafts(); showWelcome({ dir: 'back' }); return; }
    go(before, { dir: 'back' });
  }

  /* ---- progression : rail des étapes (spec 05 § 1.9, L-04 ; direction 04 § 3.1) ---- */
  /** Étape vue = faite (« Continuer » l'a validée) ; une étape passée d'un ancien brouillon reste atteignable, sans état. */
  function stepState(id) {
    if (id === state.step) return 'current';
    if (state.errorSteps.has(id)) return 'error';
    return state.visited.has(id) ? 'done' : '';
  }
  /**
   * Rail (nav « Étapes de l'annonce », un seul par page ; collant et opaque par la feuille) : logotype du jeu, « Étape n
   * sur N » et nom de l'étape (« 3/9 » sur téléphone), segments par phase (décoratifs : fait, courant, à venir, erreur),
   * « Brouillon enregistré », puis « Étapes » qui ouvre la liste nommée. Seules les étapes visitées y sont atteignables ;
   * aria-current="step" sur la courante. La liste se referme après un choix.
   */
  function renderRail() {
    const list = steps();
    const current = indexOf(state.step);
    const entry = list[current];
    const states = Object.fromEntries(list.map((item) => [item.id, stepState(item.id)]));
    const meta = (item) => (states[item.id] === 'error' ? t('propose.rail.to_review') : states[item.id] === 'done' ? t('propose.rail.done') : '');
    const bar = list.map((item, index) => h('i', { 'data-phase-start': index === 0 || list[index - 1].phase !== item.phase ? '' : null, 'data-state': states[item.id] || null }));
    const segments = STEP_PHASES.map((phase) => {
      const items = list.filter((item) => item.phase === phase);
      if (!items.length) return null;
      return h('li', { class: 'fs-rail-phase', 'data-phase': phase, 'data-current': entry.phase === phase ? '' : null, style: `--n: ${items.length}` },
        h('span', { class: 'fs-rail-phase-name', text: PHASE_NAMES[phase] }),
        h('span', { class: 'fs-rail-segs' }, items.map((item) => h('i', { class: 'fs-rail-seg', 'data-state': states[item.id] || null }))));
    });
    const phases = STEP_PHASES.map((phase) => {
      const items = list.map((item, index) => [item, index]).filter(([item]) => item.phase === phase);
      if (!items.length) return null;
      return h('li', { class: 'fs-step-rail-phase', style: `--n: ${items.length}` }, h('span', { class: 'fs-step-rail-phase-name', text: PHASE_NAMES[phase] }),
        h('ol', { class: 'fs-step-rail-steps' }, items.map(([item, index]) => {
          const reachable = item.id !== state.step && (state.visited.has(item.id) || state.skipped.has(item.id));
          const button = h('button', { type: 'button', class: 'fs-step-rail-btn', 'data-fs-rail-step': item.id, 'aria-current': item.id === state.step ? 'step' : null,
            'aria-disabled': reachable || item.id === state.step ? null : 'true', title: item.title },
          h('span', { class: 'fs-step-rail-node', 'aria-hidden': 'true', text: String(index + 1) }),
          h('span', { class: 'fs-step-rail-label', text: item.title }), h('span', { class: 'fs-step-rail-meta', text: meta(item) ? ` · ${meta(item)}` : '' }));
          button.addEventListener('click', () => {
            if (!reachable) return;
            ui.rail.querySelector('.fs-step-rail-more').open = false;
            go(item.id, { dir: index < current ? 'back' : 'forward', editing: FINAL_STEPS.includes(state.step) && !FINAL_STEPS.includes(item.id) ? true : undefined });
          });
          return h('li', { class: 'fs-step-rail-item', 'data-state': states[item.id] || null }, button);
        })));
    });
    const more = h('details', { class: 'fs-rail-steps fs-step-rail-more', open: ui.rail.querySelector('.fs-step-rail-more')?.open || null },
      h('summary', { class: 'fs-rail-toggle fs-step-rail-compact' },
        h('span', { class: 'fs-step-rail-toggle-open', text: t('propose.rail.steps') }), h('span', { class: 'fs-step-rail-toggle-close', text: t('propose.rail.hide') })),
      h('ol', { class: 'fs-step-rail' },
        h('li', { class: 'fs-step-rail-game' }, h('span', { class: 'fs-step-rail-node', 'aria-hidden': 'true' }), h('span', { text: t('propose.rail.game', { game: names[state.game] }) })),
        phases, h('li', { class: 'fs-step-rail-end', 'aria-hidden': 'true' }, h('span', { 'aria-hidden': 'true' }))));
    const logo = ui.badge.firstElementChild?.cloneNode(true);
    ui.rail.replaceChildren(
      h('span', { class: 'fs-rail-game', 'aria-hidden': 'true' }, logo || null),
      h('p', { class: 'fs-rail-where' },
        h('span', { class: 'fs-rail-count' }, h('span', { class: 'fs-rail-count-long', text: t('propose.rail.count', { step: current + 1, total: list.length }) }),
          h('span', { class: 'fs-rail-count-short', 'aria-hidden': 'true', text: `${current + 1}/${list.length}` })),
        h('span', { class: 'fs-rail-sep', 'aria-hidden': 'true', text: ' · ' }), h('span', { class: 'fs-rail-name', text: entry.title })),
      h('ol', { class: 'fs-rail-phases', 'aria-hidden': 'true' }, segments),
      h('span', { class: 'fs-rail-draft', 'data-fs-rail-draft': true, hidden: true }),
      more,
      h('span', { class: 'fs-stepper-bar fs-rail-bar fs-step-rail-bar', 'aria-hidden': 'true' }, bar));
    showSaved(false);
  }

  /**
   * Barre d'actions (spec 05 § 1.9) : « Précédent », « Ensuite : <étape suivante> », « Continuer » (« Retour au
   * récapitulatif » en édition, toujours sur une ligne, critère 34).
   */
  function updateFoot() {
    const node = stepNode(state.step);
    const main = node?.querySelector('[data-fs-next-main]');
    if (main) main.textContent = t(state.editing ? 'propose.nav.to_summary' : 'propose.nav.continue');
    const name = node?.querySelector('[data-fs-next-name]');
    if (!name) return;
    const target = stepById(state.editing ? 'verifier' : nextId(state.step));
    name.replaceChildren(...(target ? [t('propose.nav.then'), h('strong', { text: target.title })] : []));
    name.hidden = !target;
  }

  /* ---- lecture de la saisie ---- */
  /**
   * Saisie du formulaire au format du modèle. exact : chiffres tels que tapés (brouillon) ; sinon chiffres publiés
   * (arrondi proposé pour les grands nombres, sauf si le vendeur a choisi l'exact). Un nombre illisible est passé tel
   * quel : le validateur le signale.
   */
  function readInput({ exact = false } = {}) {
    const form = state.form;
    const tpl = template();
    if (!form || !tpl) return { title: '', tags: [], values: {} };
    const values = {};
    for (const field of fieldsOf(tpl)) {
      const name = `f-${field.key}`;
      /* Champ conditionnel (NH : niveau Wingman) : ni montré ni envoyé tant que son déclencheur vaut 0 (VEND-04, Q-V04) ;
         champ dispensé (RG : recherches au maximum quand la recherche est complète) : ni montré ni envoyé. */
      if (typeof state.lib?.activeValue === 'function' && !fieldShown(field, values)) continue;
      if (field.type === 'multichoice') {
        const list = [...form.querySelectorAll(`input[name="${name}"]:checked`)].map((box) => box.value);
        if (list.length) values[field.key] = list;
        continue;
      }
      if (field.type === 'boolean') {
        const checked = form.querySelector(`input[name="${name}"]:checked`);
        if (checked) values[field.key] = checked.value === 'true';
        continue;
      }
      const control = form.querySelector(`[name="${name}"]:not(:disabled)`);
      const raw = control?.type === 'radio' ? form.querySelector(`[name="${name}"]:checked`)?.value ?? '' : control?.value ?? '';
      if (raw.trim() === '') continue;
      if (field.type !== 'integer') { values[field.key] = raw; continue; }
      const number = parseNumber(raw);
      if (number === null) { values[field.key] = normalizeInteger(raw); continue; }
      values[field.key] = String(!exact && roundable(field) && state.rounding[field.key] !== 'exact' ? roundPublic(number) : number);
    }
    return { title: form.querySelector('[name="fs-title"]')?.value ?? '', tags: [...form.querySelectorAll('[name="fs-tags"]:checked')].map((box) => box.value), values };
  }
  /** Valeurs validées (types du modèle), même lecture que la carte de « Vérifier ». */
  const publishedValues = () => previewListing(state.lib, template(), readInput()).values;

  /* ---- validation par étape (spec 03 § 5.1) ---- */
  const degraded = () => state.mediaInfo.enabled === false;
  const present = (slot) => ['preparing', 'ready', 'uploading', 'sent'].includes(mediaOf(slot)?.state);
  function requiredSlotIds() {
    const tpl = template();
    const values = publishedValues();
    return typeof state.lib.requiredSlots === 'function' ? state.lib.requiredSlots(tpl, values) : slotsOf().filter((def) => def.level === 'required').map((def) => def.id);
  }
  function validationErrors() {
    try { checkSubmission(state.lib, template(), readInput()); return {}; } catch (error) {
      if (!error?.errors) throw error;
      return error.errors;
    }
  }
  function stepErrors(id, all = validationErrors()) {
    const entry = stepById(id);
    const keys = id === 'titre' ? ['title', 'tags'] : stepKeys(entry);
    const errors = Object.fromEntries(Object.entries(all).filter(([key]) => keys.includes(key)));
    const required = requiredSlotIds();
    for (const slot of entry.captures) {
      const def = slotDef(slot);
      if (!def || !isPublic(def) || !required.includes(slot) || degraded() || present(slot)) continue;
      errors[`shot-${slot}`] = siteError(t('propose.step_errors.shot_missing', { label: lower(templateText(def, 'label')) }));
    }
    if (state.reads[id] && !state.form.querySelector(`[name="read-${id}"]`)?.checked) errors[`read-${id}`] = siteError(t('propose.step_errors.read_check'));
    if (id === CONDITIONS_STEP && !state.form.querySelector('[name="fs-commit"]')?.checked) errors.commit = siteError(t('propose.step_errors.commit'));
    if (id === PRICE_STEP && !admin) { const net = parseExpectedNet(priceText()); if (net.error) errors.expectedNet = net.error; }
    /* Modification par l'équipe : net et commission relus par le bloc du prix (fs-listing-admin.js). */
    if (id === PRICE_STEP && admin) Object.assign(errors, state.adminPrice?.errors?.() ?? {});
    return errors;
  }

  /* ---- erreurs (résumé par étape, message sous chaque champ) ---- */
  function setError(key, message) {
    const block = state.form?.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
    if (!block) return false;
    const error = block.querySelector('[data-fs-error]');
    const control = block.querySelector('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="file"]):not([type="search"]), select');
    const group = block.matches('fieldset') ? block : block.querySelector('fieldset');
    const target = control || group || block.querySelector('input');
    /* Câblage commun (fs-ui.js) : texte, aria-invalid, erreur en tête de aria-describedby, état .is-invalid du bloc. */
    setFieldError({ control, target, error, field: block, message: message ? `${capitalize(displayError(message, errorContext(key)))}.` : '' });
    block.querySelector('.fs-commit')?.classList.toggle('is-invalid', Boolean(message));
    /* L'erreur qui cite déjà les bornes (« de 1 à 50 ») masque l'aide « De 1 à 50. » qui la répéterait. */
    const bounds = block.querySelector('.fs-propose-hint');
    if (bounds && locale === 'fr' && /^De -?\d+ à -?\d+\.$/.test(bounds.textContent)) bounds.hidden = Boolean(message) && /\(de -?\d+ à -?\d+\)/.test(error?.textContent || '');
    /* Hors du français : même règle, sur les deux bornes de l'aide (« From 1 to 50. ») retrouvées entre parenthèses dans l'erreur. */
    else if (bounds && locale !== 'fr') {
      const pair = (text) => { const found = String(text).match(/-?\d+/g); return found?.length === 2 ? found.join('|') : ''; };
      const hint = bounds.textContent.length < 40 ? pair(bounds.textContent) : '';
      if (hint) bounds.hidden = Boolean(message) && [...(error?.textContent || '').matchAll(/\(([^)]*)\)/g)].some((group) => pair(group[1]) === hint);
    }
    return true;
  }
  /** Contexte d'un message sous le champ : nom affiché et nature (choix, nombre, étiquettes). */
  function errorContext(key) {
    if (key === 'tags') return { name: t('propose.title_step.tags'), kind: 'tags' };
    const field = fieldMap().get(key);
    if (!field) return null;
    const premium = key === 'premium' && field.type === 'integer';
    const kind = WIDGETS[state.game]?.[key] ? key : premium ? 'premium' : field.type === 'boolean' ? 'boolean' : field.type === 'choice' ? 'choice'
      : field.type === 'multichoice' ? (key === 'ships' ? 'ships' : 'multichoice') : field.type === 'integer' ? 'number' : '';
    return { name: fieldName(field), kind, min: field.min, max: field.max, none: typeof field.noneOption === 'string',
      active: premium && state.form?.querySelector(`[name="p-${CSS.escape(key)}"]:checked`)?.value === 'true' };
  }
  /* Contrôle à atteindre : saisie ou liste (recherche d'une grande liste comprise), sinon la case choisie, sinon la première
     case ou le bouton de capture (grille des vaisseaux : la première case, jamais son filtre). */
  const controlOf = (block) => block?.querySelector('.fs-combo-input, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="file"]):not([type="search"]), select')
    || block?.querySelector('input:checked:not([type="hidden"])') || block?.querySelector('[data-shot-pick], input:not([type="hidden"]):not([type="file"]):not([type="search"])')
    || block?.querySelector('input[type="search"]');
  /** Atteindre un champ : active l'étape qui le contient (en édition depuis Vérifier), puis focus et défilement. */
  function goToField(key, clicked = true) {
    const slotStep = key.startsWith('shot-') ? stepOfSlot(state.game, key.slice(5)) : key.startsWith('read-') ? key.slice(5) : key === 'commit' ? CONDITIONS_STEP : key === 'media' ? 'verifier' : stepOfKey(state.game, key);
    if (slotStep && slotStep !== state.step) go(slotStep, { dir: indexOf(slotStep) < indexOf(state.step) ? 'back' : 'forward', editing: FINAL_STEPS.includes(state.step) && !FINAL_STEPS.includes(slotStep) ? true : undefined, focusKey: key });
    const block = state.form?.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
    if (!block) return;
    for (let details = block.closest('details'); details; details = details.parentElement?.closest('details')) details.open = true;
    const control = controlOf(block);
    const label = control?.closest('label');
    if (label?.hidden) label.hidden = false;
    focusOn(control || block, clicked);
  }
  /**
   * Résumé d'erreurs de l'étape (role=alert ; spec 05 § 1.10) : en-tête « n champs à compléter : » et « Aller au
   * premier », puis une ligne par message, les champs au même message regroupés (« Anka, Atlas, Pusat : indiquez 0… »),
   * un lien par champ ; au-delà de 4 lignes, les suivantes dans « Voir les n autres ». Message sous chaque champ. Focus
   * sur le résumé, ou sur le premier champ en erreur (focusField : « Continuer », VEND-04) ; quiet : résumé recalculé
   * sans déplacer le focus (lecture d'une capture).
   */
  const SUMMARY_LINES = 4;
  function showStepErrors(id, errors, intro = '', { focusField = false, quiet = false } = {}) {
    const node = stepNode(id);
    if (!node) return;
    node.querySelectorAll('[data-fs-field].is-invalid').forEach((block) => setError(block.dataset.fsField, ''));
    const placed = {}; const unplaced = [];
    for (const [key, message] of Object.entries(errors)) {
      if (key === '_') unplaced.push(capitalize(locale === 'fr' ? String(message) : displayError(String(message))));
      else if (setError(key, message)) placed[key] = message;
      else unplaced.push(t('propose.error_summary.line', { label: labelOf(key), message: displayError(message) }));
    }
    const summary = node.querySelector('[data-fs-step-summary]');
    const order = [...state.form.querySelectorAll('[data-fs-field]')].map((block) => block.dataset.fsField);
    const groups = errorGroups(placed, order, labelOf, errorContext);
    const total = Object.keys(placed).length + unplaced.length;
    if (!total) { summary.hidden = true; summary.replaceChildren(); return; }
    const link = ({ key, label }) => {
      const target = controlOf(state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`));
      const anchor = h('a', { class: 'fs-link', href: `#${target?.id || 'sell'}`, 'data-fs-error-link': key, text: label });
      anchor.addEventListener('click', (event) => { event.preventDefault(); goToField(key); });
      return anchor;
    };
    const line = (group) => h('li', {}, group.items.flatMap((item, index) => [index ? ', ' : '', link(item)]), t('propose.error_summary.group_tail', { message: group.message }));
    const firstKey = groups[0]?.items[0]?.key;
    const goFirst = firstKey && Object.keys(placed).length > 1 ? h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-summary-first', 'data-fs-summary-first': firstKey, text: t('propose.error_summary.go_first') }) : null;
    goFirst?.addEventListener('click', () => goToField(firstKey));
    const rest = groups.slice(SUMMARY_LINES);
    const hidden = rest.reduce((sum, group) => sum + group.items.length, 0);
    summary.replaceChildren(...[h('p', { class: 'fs-summary-head' }, h('strong', { class: 'fs-propose-summary-text', text: intro || t('propose.error_summary.points_to_review', { count: total }) }), goFirst ? ' ' : null, goFirst),
      ...unplaced.map((text) => h('p', { class: 'fs-propose-summary-text', text })),
      groups.length ? h('ul', { class: 'fs-propose-summary-list' }, groups.slice(0, SUMMARY_LINES).map(line)) : null,
      rest.length ? h('details', { class: 'fs-summary-more' }, h('summary', { text: t('propose.error_summary.see_others', { count: hidden }) }),
        h('ul', { class: 'fs-propose-summary-list' }, rest.map(line))) : null].filter(Boolean));
    summary.hidden = false;
    if (quiet) return;
    const first = focusField && firstKey ? controlOf(state.form.querySelector(`[data-fs-field="${CSS.escape(firstKey)}"]`)) : null;
    if (!first) { summary.focus({ preventScroll: true }); revealSummary(node, summary); return; }
    /* Focus sur le premier champ en erreur : titre, résumé et champ dans l'écran s'ils y tiennent ensemble, sinon le champ. */
    first.focus({ preventScroll: true });
    const inset = topInset();
    const top = node.getBoundingClientRect().top;
    if (first.getBoundingClientRect().bottom - top <= viewBottom() - inset - 16) revealSummary(node, first);
    else reveal(first);
    /* Défilement doux interrompu (défilement de focus du clavier encore en cours) : vérifié une fois, champ replacé sans animation. */
    setTimeout(() => { if (document.activeElement === first) reveal(first, false); }, 600);
  }

  /** Résumé d'erreurs d'une étape : retiré dès qu'il ne reste plus rien à corriger dans l'étape. */
  function clearSummary(id) {
    const summary = stepNode(id)?.querySelector('[data-fs-step-summary]');
    if (!summary || summary.hidden || FINAL_STEPS.includes(id) || Object.keys(stepErrors(id)).length) return;
    summary.hidden = true;
    summary.replaceChildren();
  }
  /** Résumé déjà affiché, recalculé sans déplacer le focus (valeurs lues sur une capture, spec 05 § 1.10). */
  function refreshSummary(id) {
    const summary = stepNode(id)?.querySelector('[data-fs-step-summary]');
    if (!summary || summary.hidden || FINAL_STEPS.includes(id)) return;
    const errors = stepErrors(id);
    const count = Object.keys(errors).length;
    if (!count) { clearSummary(id); return; }
    showStepErrors(id, errors, t('propose.error_summary.fields_to_complete', { count }), { quiet: true });
  }

  /* Pointeur enfoncé : la vérification de sortie attend le relâchement (sinon le message déplacerait le bouton visé). */
  let pressing = false;
  let deferred = null;
  const release = () => { pressing = false; const run = deferred; deferred = null; if (run) setTimeout(run, 0); };
  document.addEventListener('pointerdown', () => { pressing = true; }, true);
  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);
  /** Sortie d'un champ rempli : format des grands nombres, arrondi proposé, puis seul ce champ est vérifié. */
  function onLeave(event) {
    if (pressing) { deferred = () => onLeave({ target: event.target, relatedTarget: null }); return; }
    if (!state.form?.contains(event.target)) return;
    const block = event.target.closest?.('[data-fs-field]');
    const key = block?.dataset.fsField;
    if (!key || block.contains(event.relatedTarget)) return;
    if (event.target.matches?.('.fs-num-input')) {
      const number = parseNumber(event.target.value);
      if (number !== null) event.target.value = groupDigits(number);
      syncReadout(event.target.closest('.fs-num'));
      syncRound(block);
      refreshDerived();
    }
    const control = controlOf(block);
    if (!control || control.type === 'checkbox' || control.type === 'radio' || String(control.value || '').trim() === '') return;
    const errors = key === 'expectedNet' ? stepErrors(PRICE_STEP) : validationErrors();
    if (errors[key]) setError(key, errors[key]);
  }

  /* ---- saisie ---- */
  let frame = 0;
  let liveTimer = 0;
  function onEdit(event) {
    const target = event.target;
    if (target.matches?.('.fs-propose-design-filter')) return;
    if (target.name?.startsWith('r-') && target.checked) state.rounding[target.name.slice(2)] = target.value === 'exact' ? 'exact' : 'round';
    if (target.name === 'fs-title' && event.type === 'input') { state.titleEdited = target.value.trim() !== suggestion(); syncTitle(); }
    if (target.name === 'fs-tags') { syncTags(); if (event.type === 'change') arrangeTags(); }
    if (target.name?.startsWith('read-')) (state.readChecked ||= {})[target.name.slice(5)] = target.checked;
    if (target.name === 'fs-price') state.price = target.value;
    const block = target.closest?.('[data-fs-field]');
    const key = block?.dataset.fsField;
    if (block?.matches('.fs-gauge')) syncGauge(block);
    if (target.matches?.('[data-fs-premium]') || target.closest?.('.fs-premium-days')) syncPremium(block);
    if (target.type === 'radio') syncClear(block);
    if (target.matches?.('select')) syncSelectIcon(block);
    if (target.matches?.('input[type="text"]')) syncCounter(target.closest('.fs-propose-field-text'));
    if (target.matches?.('.fs-num-input')) syncReadout(target.closest('.fs-num'));
    if (target.type === 'checkbox') syncChecks(block);
    if (block?.dataset.fsMax && target.type === 'checkbox') syncMax(block);
    syncNone(block, target);
    if (target.name === 'f-server') syncOtherServers();
    /* Case décochée d'une liste de référence (NH : vaisseaux) : les choix qui en dépendent sont retirés. */
    if (target.type === 'checkbox' && target.name?.startsWith('f-')) {
      state.form.querySelectorAll(`[data-fs-within="${CSS.escape(target.name.slice(2))}"]`).forEach((combo) => combo.fsPrune?.());
    }
    syncConditional();
    block?.fsSerialize?.();
    target.closest?.('[data-fs-design-grid]')?.fsSync?.();
    if (key && target.matches?.('input[name^="f-"]:not([type="radio"]):not([type="checkbox"])') && event.type === 'input') unmarkRead(key);
    if (key && block.classList.contains('is-invalid')) {
      const own = key === 'commit' || key === 'expectedNet' || key.startsWith('read-') || Object.hasOwn(admin?.labels ?? {}, key);
      const errors = key === 'adminReason' ? { adminReason: admin.reasonError(target.value) } : own ? stepErrors(state.step) : validationErrors();
      setError(key, errors[key] || '');
      if (!errors[key]) clearSummary(state.step);
    }
    /* Texte libre : un prix ou un lien est signalé pendant la frappe (après 600 ms), jamais un champ simplement vide. */
    if (key && event.type === 'input' && target.matches?.('input[type="text"]:not(.fs-num-input)')) {
      clearTimeout(liveTimer);
      liveTimer = setTimeout(() => {
        const message = validationErrors()[key];
        if (message && /prix|lien/i.test(message)) setError(key, message);
      }, 600);
    }
    saveSoon();
    updateFoot();
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { refreshDerived(); if (state.step === 'verifier') renderReview(); });
  }
  /** Booléen facultatif désélectionnable : un 2e clic sur l'option choisie remet « non précisé » (spec 03 § 2.8 B). Un champ
      obligatoire garde sa réponse (VEND-04). */
  function rememberChoice(event) {
    const option = event.target.closest?.('.fs-propose-field-boolean .fs-seg-opt');
    if (option?.closest('[aria-required="true"]')) return;
    const input = option?.querySelector('input');
    if (input) input.dataset.was = String(input.checked);
  }
  function clearField(key) {
    state.form.querySelectorAll(`input:is([name="f-${CSS.escape(key)}"], [name="p-${CSS.escape(key)}"])`).forEach((input) => { input.checked = false; delete input.dataset.was; });
    const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
    if (block?.matches('.fs-gauge')) syncGauge(block);
    if (block?.matches('.fs-propose-field-premium')) { block.querySelector('.fs-premium-days input').value = ''; syncPremium(block); }
    syncClear(block);
    if (block && block.contains(document.activeElement) === false) (block.querySelector('input:not([type="hidden"]):not(:disabled)') || block).focus?.({ preventScroll: true });
    unmarkRead(key);
    onEdit({ type: 'change', target: block?.querySelector('input') || block });
  }
  function onClick(event) {
    const target = event.target;
    const radio = target.closest?.('.fs-propose-field-boolean .fs-seg-opt input[type="radio"]');
    if (radio && radio.dataset.was === 'true') {
      radio.checked = false;
      delete radio.dataset.was;
      syncClear(radio.closest('[data-fs-field]'));
      onEdit({ type: 'change', target: radio });
      return;
    }
    const button = target.closest?.('button');
    if (!button || !state.form.contains(button)) return;
    if (button.matches('[data-fs-step-next]')) next();
    else if (button.matches('[data-fs-step-prev]')) previous();
    else if (button.dataset.fsClear) clearField(button.dataset.fsClear);
    else if (button.matches('[data-fs-title-reset]')) {
      state.titleEdited = false;
      state.form.querySelector('[name="fs-title"]').value = suggestion();
      syncTitle();
      saveSoon();
      state.form.querySelector('[name="fs-title"]').focus({ preventScroll: true });
    } else if (button.dataset.fsMarker) {
      const input = state.form.querySelector('[name="fs-title"]');
      const max = template().title?.maxLength ?? 120;
      const text = [input.value.trim(), button.dataset.fsMarker].filter(Boolean).join(' I ');
      input.value = [...text].slice(0, max).join('');
      state.titleEdited = true;
      onEdit({ type: 'input', target: input });
      syncTitle();
      (state.form.querySelector('[data-fs-marker]') || input).focus({ preventScroll: true });
    } else if (button.dataset.fsReviewGo) {
      const id = button.dataset.fsReviewGo;
      /* Modifier une étape dont AccInsight a rempli des champs : ils redeviennent visibles pour être corrigés. */
      if (!state.revealed.has(id) && stepKeys(stepById(id)).some((key) => state.imported.has(key))) { state.revealed.add(id); syncConditional(); }
      if (button.dataset.fsReviewKey) goToField(button.dataset.fsReviewKey);
      else go(id, { dir: 'back', editing: true });
    } else if (button.dataset.fsReadGo) go(button.dataset.fsReadGo, { dir: indexOf(button.dataset.fsReadGo) < indexOf(state.step) ? 'back' : 'forward' });
    else if (button.matches('[data-fs-propose-logout]')) logout();
  }
  /** Entrée dans un champ : passe au champ suivant de l'étape ; sur le dernier, Continuer. Jamais un envoi avant Vérifier. */
  function onKeydown(event) {
    const target = event.target;
    if (event.key === 'Enter' && !event.isComposing && target.matches?.('input:not([type="checkbox"]):not([type="radio"]):not([type="file"])')) {
      event.preventDefault();
      if (target.matches('.fs-propose-design-filter, .fs-combo-input')) return;
      if (FINAL_STEPS.includes(state.step)) return;
      const node = stepNode(state.step);
      const fields = [...node.querySelectorAll('input.fs-input:not([type="search"]), select')].filter((element) => !element.closest('[hidden], details:not([open])'));
      const following = fields[fields.indexOf(target) + 1];
      if (following) following.focus({ preventScroll: true }); else next();
      return;
    }
    /* Jauge : Début et Fin en plus des flèches natives du groupe radio. */
    if ((event.key === 'Home' || event.key === 'End') && target.matches?.('.fs-gauge-cran input')) {
      const all = [...target.closest('.fs-gauge-crans').querySelectorAll('input')];
      const pick = event.key === 'Home' ? all[0] : all[all.length - 1];
      event.preventDefault();
      pick.checked = true;
      pick.focus({ preventScroll: true });
      onEdit({ type: 'change', target: pick });
    }
  }
  function onSubmit(event) {
    event.preventDefault();
    if (admin) { if (state.step === 'verifier') adminSend(); else next(); return; }
    if (state.step !== CONDITIONS_STEP) { next(); return; }
    send();
  }

  /* ---- étape Titre ---- */
  function suggestion() {
    const tpl = template();
    const values = publishedValues();
    const suggest = typeof state.account?.suggestTitle === 'function' ? state.account.suggestTitle : state.importUi?.suggestTitle;
    let text = '';
    try { text = String(suggest?.(tpl, values) || ''); } catch { text = ''; }
    return [...text].slice(0, tpl.title?.maxLength ?? 120).join('');
  }
  function syncTitle() {
    const input = state.form.querySelector('[name="fs-title"]');
    const max = template().title?.maxLength ?? 120;
    const count = state.form.querySelector('[data-fs-title-count]');
    count.textContent = `${[...input.value].length} / ${max}`;
    count.hidden = [...input.value].length < max * 0.8;
    state.form.querySelector('[data-fs-title-reset]').hidden = !state.titleEdited;
    state.form.querySelector('[data-fs-title-badge]').hidden = state.titleEdited;
    const title = input.value.toLowerCase();
    const markers = titleMarkers(template(), publishedValues(), packOf(state.game)).filter((marker) => !title.includes(marker.toLowerCase()));
    state.form.querySelector('[data-fs-title-markers]').replaceChildren(...markers.map((marker) => h('button', { type: 'button', class: 'fs-chip fs-chip--add', 'data-fs-marker': marker },
      h('span', { class: 'fs-visually-hidden', text: t('propose.title_step.add_to_title_sr') }), marker)));
  }
  /** 6 étiquettes au plus : les autres cases deviennent inactives (aria-disabled), sans jamais disparaître. */
  function syncTags() {
    const boxes = [...state.form.querySelectorAll('[name="fs-tags"]')];
    const full = boxes.filter((box) => box.checked).length >= 6;
    boxes.forEach((box) => { box.disabled = full && !box.checked; });
  }
  /** Rangée « Suggérées pour votre compte » : les cases suggérées y passent, avec leur raison ; les autres restent dans la liste. */
  function arrangeTags() {
    const row = state.form?.querySelector('[data-fs-tags-suggested-list]');
    const list = state.form?.querySelector('[data-fs-tags-list]');
    if (!row || !list) return;
    const checked = [...state.form.querySelectorAll('[name="fs-tags"]:checked')].map((box) => box.value);
    const suggested = suggestTags(template(), publishedValues(), { slots: Object.keys(state.media[state.game] || {}).filter(present), checked });
    const reasons = new Map(suggested.map(({ tag, reason }) => [tag, reason]));
    const labels = [...state.form.querySelectorAll('[data-fs-tag]')];
    const order = template().tags;
    labels.sort((a, b) => order.indexOf(a.dataset.fsTag) - order.indexOf(b.dataset.fsTag));
    const focused = document.activeElement;
    row.replaceChildren(...suggested.map(({ tag }) => labels.find((label) => label.dataset.fsTag === tag)).filter(Boolean));
    list.replaceChildren(...labels.filter((label) => !reasons.has(label.dataset.fsTag)));
    if (focused && focused !== document.activeElement && state.form.contains(focused)) focused.focus({ preventScroll: true });
    for (const label of labels) {
      const note = label.querySelector('[data-fs-tag-note]');
      note.hidden = !reasons.has(label.dataset.fsTag);
      note.textContent = reasons.get(label.dataset.fsTag) || '';
    }
    state.form.querySelector('[data-fs-tags-none]').hidden = suggested.length > 0;
    row.hidden = !suggested.length;
  }
  async function enterTitle() {
    await loadAccount();
    if (!state.form) return;
    const input = state.form.querySelector('[name="fs-title"]');
    if (!state.titleEdited) input.value = suggestion();
    arrangeTags();
    state.tagsSeen = true;
    syncTitle();
    syncTags();
    refreshDerived();
    saveSoon();
  }

  /* ---- carte d'annonce (récapitulatif de « Vérifier » seulement : aucun aperçu pendant la saisie), preuves ---- */
  function ensureListingsCss() {
    const href = root.dataset.fsListingsCss;
    if (href && !document.querySelector('link[href*="fs-listings"]') && /^(?:\/|https:\/\/)/.test(href)) document.head.append(h('link', { rel: 'stylesheet', href, 'data-fs-propose-listings-css': true }));
    const css = root.dataset.fsShowcaseCss;
    if (css && !document.querySelector('link[href*="fs-design-showcase"]') && /^(?:\/|https:\/\/)/.test(css)) document.head.append(h('link', { rel: 'stylesheet', href: css, 'data-fs-propose-showcase-css': true }));
    const src = root.dataset.fsShowcaseJs;
    if (src && !window.FSDesignShowcase && !document.querySelector('script[src*="fs-design-showcase"]') && /^(?:\/|https:\/\/)/.test(src)) document.head.append(h('script', { src, defer: true }));
  }
  function posterFor(game) {
    const name = game === 'redgalaxy' ? 'fsRedImage' : game === 'nebuleuse' ? 'fsNebulaImage' : 'fsOrbitalImage';
    return demo.dataset?.[name] || '';
  }
  /** Carte d'annonce : même composition que la carte publiée (fs-listing-card), jamais d'achat ; pied « Prix fixé par
      l'équipe » (VEND-10), ou « Prix fixé à la mise en vente » quand le service annonce le prix souhaité (jamais le prix
      souhaité lui-même). */
  function buildCard(listing, projection) {
    const tpl = template();
    const pack = packOf(state.game);
    const server = projection.server ? SERVERS[projection.server] || projection.server : '';
    const shown = (value) => {
      const parsed = statValue(value);
      if (parsed.kind === 'yes' || parsed.kind === 'no') return h('span', { class: `fs-ld-flag fs-ld-flag--${parsed.kind}` }, h('span', { 'aria-hidden': 'true', text: parsed.kind === 'yes' ? '✓' : '✕' }), ` ${parsed.text}`);
      if (parsed.kind === 'ratio') return h('span', { class: `fs-ld-gauge${parsed.fill === 100 ? ' fs-ld-gauge--full' : ''}`, style: `--fs-ld-fill: ${parsed.fill}%; --fs-ld-steps: ${parsed.total};` }, h('span', { class: 'fs-ld-gauge-value', text: parsed.text }), h('span', { class: 'fs-ld-gauge-track', 'aria-hidden': 'true' }));
      return parsed.text.replace(/ /g, GROUP_SEPARATOR);
    };
    const stat = (label, value) => {
      const icon = packIcon(pack, label, statKey(label));
      /* Nom du glossaire du champ du modèle (même règle que les champs), sinon statName. */
      const field = fieldsOf(tpl).find((item) => statKey(item.label) === statKey(label));
      const name = (field?.i18n?.label ? templateText(field, 'label') : '') || statName(label, state.game);
      return h('li', {}, h('span', { class: 'fs-lc-stat' },
        icon ? h('img', { class: 'fs-gp-icon fs-lc-stat-icon fs-ui-icon', src: icon.url, alt: '', width: 32, height: 32, loading: 'lazy', decoding: 'async' }) : h('span', { class: 'fs-lc-stat-glyph', 'aria-hidden': 'true' }),
        h('span', { class: 'fs-lc-stat-label', text: name }), h('span', { class: 'fs-visually-hidden', text: t('propose.card.stat_sep') }), h('span', { class: 'fs-lc-stat-value' }, shown(value))));
    };
    const stats = [
      /* Libellé anglais du modèle : statName le nomme « Niveau » en français, et le traduit ou le garde ailleurs. */
      projection.level !== undefined ? stat('Level', String(projection.level)) : null,
      ...projection.highlights.filter((item) => !/^(niveau|level)\b/i.test(item)).slice(0, projection.level !== undefined ? 2 : 3)
        .map((item) => { const [label, ...rest] = item.split(' · '); return stat(label, rest.join(' · ')); }),
    ].filter(Boolean);
    const designs = chosenDesigns(pack, fieldsOf(tpl).filter((field) => field.type === 'multichoice').flatMap((field) => listing.values[field.key] || []));
    const top = designs[0] || null;
    const ship = headShip();
    const poster = posterFor(state.game);
    const items = designs.length ? designs : ship ? [ship] : [];
    const hangar = h('div', { class: `fs-card-media fs-offer-art fs-lc-hangar fs-propose-hangar${ship ? ' has-ship' : ''}`, 'data-fs-sc-scope': true },
      items.length ? h('div', { class: 'fs-sc fs-sc--card', 'data-fs-showcase': true, 'data-fs-sc-count': String(items.length),
        ...(items.length > 1 ? { role: 'group', 'aria-roledescription': t('propose.card.carousel'), 'aria-label': t('propose.card.carousel_aria', { count: items.length }) } : {}) },
      h('ul', { class: 'fs-sc-track', 'data-fs-sc-track': true }, items.map((item, index) => h('li', { class: 'fs-sc-slide', 'data-fs-sc-slide': true, 'data-active': index === 0,
        ...(designs.length ? { 'data-tier': item.tier, 'data-fs-sc-label': item.label } : {}), ...(items.length > 1 ? { 'aria-roledescription': t('propose.card.slide'), 'aria-label': t('propose.card.slide_aria', { index: index + 1, total: items.length, label: item.label }) } : {}) },
      h('div', { class: 'fs-sc-stage' }, h('span', { class: 'fs-sc-pedestal', 'aria-hidden': 'true' }),
        h('img', { class: `fs-gp-ship fs-lc-ship fs-propose-ship fs-sc-ship${designs.length ? ' fs-lc-design' : ''}`, src: item.url, width: item.width, height: item.height, alt: '', loading: 'lazy', decoding: 'async' })))))) : poster ? h('img', { class: 'fs-lc-poster', src: poster, width: 1672, height: 941, alt: '', loading: 'lazy', decoding: 'async' }) : null,
      top ? h('p', { class: 'fs-lc-design-tag', 'data-tier': top.tier, 'data-fs-sc-tag': true },
        h('span', { class: 'fs-visually-hidden', text: t('propose.card.design_sr') }), h('span', { class: 'fs-lc-design-name', 'data-fs-sc-name': true, text: top.label }),
        h('span', { class: 'fs-lc-design-tier', 'data-fs-sc-tier': true, text: DESIGN_TIER_NAMES[top.tier] || '', hidden: !DESIGN_TIER_NAMES[top.tier] }),
        designs.length > 1 ? h('span', { class: 'fs-lc-design-more' }, `+${designs.length - 1}`, h('span', { class: 'fs-visually-hidden', text: t('propose.card.more_designs', { count: designs.length - 1 }) })) : null) : null);
    const more = listing.tags.length - 3;
    return h('article', { class: 'fs-card fs-card--listing fs-listing fs-lc fs-propose-card', 'data-fs-propose-card': true, 'data-game': state.game, 'data-fs-universe': state.game },
      hangar,
      h('p', { class: 'fs-card-head fs-lc-head' },
        h('span', { class: 'fs-lc-game' }, names[state.game] || tpl.name, server ? [h('span', { class: 'fs-lc-sep', 'aria-hidden': 'true', text: '·' }), h('span', { class: 'fs-visually-hidden', text: t('propose.card.server_sr') }), server] : null),
        h('span', { class: 'fs-card-ref fs-lc-ref', text: t('propose.card.in_review') })),
      h('h4', { class: 'fs-card-title fs-lc-title fs-propose-card-title', text: listing.title || t('propose.card.title_pending', { step: indexOf('titre') + 1 }) }),
      stats.length ? h('ul', { class: 'fs-card-stats fs-lc-stats' }, stats) : null,
      listing.tags.length ? h('ul', { class: 'fs-card-tags fs-lc-tags', 'aria-label': t('propose.title_step.tags') }, listing.tags.slice(0, 3).map((tag) => h('li', { class: 'fs-badge fs-lc-tag', text: tagLabel(tag) })),
        more > 0 ? h('li', { class: 'fs-badge fs-lc-tag fs-lc-tag--more' }, `+${more}`, h('span', { class: 'fs-visually-hidden', text: t('propose.card.more_tags', { count: more }) })) : null) : null,
      h('p', { class: 'fs-card-foot fs-propose-card-foot fs-review-price-note' }, h('span', { text: copy().card })));
  }
  /** Vignettes des captures publiques (récapitulatif) : URL locales blob: ou vignette du service. */
  const publicThumbs = () => slotsOf().filter(isPublic).map((def) => [def, mediaOf(def.id)]).filter(([, entry]) => entry?.url && ['ready', 'uploading', 'sent'].includes(entry.state));
  /** Affichage dérivé de la saisie : vaisseau des en-têtes d'étape (premier design coché). */
  function refreshDerived() {
    if (!state.form || !template()) return;
    const ship = headShip();
    state.form.querySelectorAll('[data-fs-step-ship]').forEach((img) => { if (ship && img.getAttribute('src') !== ship.url) img.src = ship.url; });
  }
  /* ---- récapitulatif (étape Vérifier) ---- */
  function valueSummary(entry, values, exactValues) {
    const fields = fieldMap();
    const parts = [];
    for (const key of stepKeys(entry)) {
      const field = fields.get(key);
      const value = values[key];
      if (!field || value === undefined) continue;
      const name = fieldName(field);
      if (field.type === 'boolean') parts.push(t('propose.summary.pair', { name, value: t(value ? 'propose.summary.yes' : 'propose.summary.no') }));
      else if (field.type === 'multichoice') parts.push(listSummary(field, value, { name, text: (option) => alphaLabel(optionText(field, option)) }));
      else if (field.key === 'premium' && field.type === 'integer') parts.push(Number(value) > 0 ? `${name} · ${t('propose.summary.days', { count: Number(value) })}` : t('propose.summary.pair', { name, value: t('propose.summary.no') }));
      else if (field.type === 'integer') {
        const rounded = roundable(field) && Number(exactValues[key]) !== value;
        parts.push(`${name} ${field.ratioOf ? `${value}/${field.ratioOf}` : digits(value)}${rounded ? t('propose.summary.rounded') : ''}`);
      } else parts.push(key === 'server' ? optionText(field, value) : t('propose.summary.pair', { name, value: field.type === 'choice' ? optionText(field, value) : value }));
      if (parts.length >= 3) break;
    }
    const shots = entry.captures.filter((slot) => isPublic(slotDef(slot)) && present(slot)).length;
    if (shots) parts.unshift(t('propose.summary.shots', { count: shots }));
    return parts.join(' · ');
  }
  function renderReview() {
    const node = stepNode('verifier');
    if (!node) return;
    const tpl = template();
    const input = readInput();
    const listing = previewListing(state.lib, tpl, input);
    const exact = readInput({ exact: true }).values;
    ensureListingsCss();
    node.querySelector('[data-fs-review-card]').replaceChildren(buildCard(listing, state.lib.listingProjection(tpl, listing)));
    const thumbs = publicThumbs();
    node.querySelector('[data-fs-review-gallery]').replaceChildren(...thumbs.map(([def, entry]) => h('li', {}, h('figure', { class: 'fs-shot-thumb' }, zoomButton(h('img', { src: entry.url, alt: t('propose.review_step.shot_alt', { label: lower(templateText(def, 'label')) }), loading: 'lazy', decoding: 'async' }), templateText(def, 'label'))))));
    node.querySelector('[data-fs-review-caption]').hidden = !thumbs.length;
    const staff = slotsOf().filter((def) => !isPublic(def));
    const staffNote = node.querySelector('[data-fs-review-staff]');
    const required = requiredSlotIds();
    const ticket = [...staff, ...(degraded() ? slotsOf().filter((def) => isPublic(def) && required.includes(def.id)) : [])];
    staffNote.textContent = ticket.length ? t('propose.review_step.staff_note', { count: ticket.length, list: ticket.map((def) => lower(templateText(def, 'label'))).join(', ') }) : '';
    staffNote.hidden = !ticket.length;
    const all = validationErrors();
    const rows = allSteps().filter((entry) => !FINAL_STEPS.includes(entry.id)).map((entry) => {
      const errors = stepErrors(entry.id, all);
      const first = Object.entries(errors)[0];
      const net = entry.id === PRICE_STEP && !admin ? parseExpectedNet(priceText()) : null;
      const summary = entry.id === 'titre' ? [listing.title || input.title.trim(), listing.tags.length ? t('propose.review_step.tags', { count: listing.tags.length }) : ''].filter(Boolean).join(' · ')
        : entry.id === PRICE_STEP && admin ? state.adminPrice?.summary?.() || ''
          : net ? (net.amount ? expectedNetSummary(net.amount) : '') : valueSummary(entry, listing.values, exact);
      const kind = first ? 'error' : summary ? '' : 'skipped';
      const action = t(first ? 'propose.review_step.fix' : kind === 'skipped' ? 'propose.review_step.add' : 'propose.review_step.edit');
      const text = first ? t('propose.error_summary.line', { label: labelOf(first[0]), message: displayError(first[1], errorContext(first[0])) }) : summary || t('propose.review_step.incomplete');
      /* Le bouton dans un second dd (contenu valide d'une liste de description), nommé « Modifier : <étape> ». */
      return h('div', { class: 'fs-review-row', 'data-state': kind || null, 'data-fs-review-row': entry.id },
        h('dt', { text: entry.title }), h('dd', { text: text }),
        h('dd', { class: 'fs-review-action' }, h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-review-go': entry.id, 'data-fs-review-key': first ? first[0] : null },
          action, h('span', { class: 'fs-visually-hidden', text: t('propose.shots.for_label', { label: entry.title }) }))));
    });
    node.querySelector('[data-fs-review-list]').replaceChildren(...rows);
    renderLost(node);
    if (admin) renderAdminChanges(node);
  }
  /**
   * Captures perdues (redirection, rechargement) : listées avec un ajout direct (spec 03 § 3.3), à « Vérifier » et aux
   * conditions de vente, où le vendeur revient d'une connexion par redirection (VEND-11).
   */
  function renderLost(node) {
    const lostBox = node?.querySelector('[data-fs-review-lost]');
    if (!lostBox) return;
    const lost = slotsOf().filter((def) => isPublic(def) && mediaOf(def.id)?.state === 'lost');
    lostBox.hidden = !lost.length || degraded();
    lostBox.replaceChildren(...(lost.length ? [h('p', { text: SHOT_TEXT.lost }),
      h('div', { class: 'fs-propose-actions' }, lost.map((def) => h('button', { type: 'button', class: 'fs-btn', 'data-fs-review-go': stepOfSlot(state.game, def.id), 'data-fs-review-key': `shot-${def.id}` }, t('propose.review_step.reupload', { label: lower(templateText(def, 'label')) }))))] : []));
  }
  /** Conditions de vente : libellé de la case (vendeur ou administrateur qui publie directement), puis la connexion. */
  function renderConditions() {
    const node = stepNode(CONDITIONS_STEP);
    const label = node?.querySelector('[data-fs-commit-label]');
    if (label) label.textContent = state.me?.admin ? TERMS_COMMIT.admin : TERMS_COMMIT.seller;
    renderLost(node);
    renderAuth();
  }
  /**
   * Toute l'annonce avant les conditions (étapes du jeu, titre, prix) : vrai si elle est complète ; sinon les points à
   * revoir sur « Vérifier », un lien chacun, étapes signalées sur la piste.
   */
  function listingReady() {
    const all = validationErrors();
    const byStep = Object.fromEntries(allSteps().filter((entry) => !FINAL_STEPS.includes(entry.id)).map((entry) => [entry.id, stepErrors(entry.id, all)]));
    state.errorSteps = new Set(Object.entries(byStep).filter(([, errors]) => Object.keys(errors).length).map(([id]) => id));
    const errors = Object.assign({}, ...Object.values(byStep));
    renderRail();
    if (!Object.keys(errors).length) { showStepErrors('verifier', {}); return true; }
    if (state.step !== 'verifier') go('verifier', { dir: 'back' });
    renderReview();
    showStepErrors('verifier', errors, t('propose.error_summary.points_before_send', { count: Object.keys(errors).length }));
    return false;
  }

  /* ---- captures en mémoire ---- */
  const mediaOf = (slot) => state.media[state.game]?.[slot] || null;
  const setMedia = (slot, entry) => { (state.media[state.game] ||= {})[slot] = entry; return entry; };
  /** Libère les images d'un jeu (URL blob: révoquées) et oublie ses captures. */
  function releaseMedia(game) {
    for (const [slot, entry] of Object.entries(state.media[game] || {})) {
      entry.abort?.abort();
      if (entry.url?.startsWith('blob:')) URL.revokeObjectURL(entry.url);
      delete state.media[game][slot];
    }
  }
  /** Brouillon : captures envoyées (identifiant seulement) et captures perdues après une redirection. */
  function restoreMedia(captures) {
    const current = state.media[state.game] || {};
    for (const [slot, capture] of Object.entries(captures)) {
      if (current[slot]?.blob || current[slot]?.state === 'sent') continue;
      if (capture.state === 'uploaded') current[slot] = { state: 'sent', id: capture.ref, restored: true };
      else if (capture.state === 'lost') current[slot] = { state: 'lost' };
    }
    state.media[state.game] = current;
  }

  /** Texte traduit dont les {{ nom }} restants deviennent des nœuds (lien, référence) : [texte, nœud, texte…]. */
  const tNodes = (key, nodes = {}, params = {}) => t(key, params).split(/(\{\{\s*[a-z_][a-z0-9_]*\s*\}\})/).map((part) => {
    const name = /^\{\{\s*([a-z_][a-z0-9_]*)\s*\}\}$/.exec(part)?.[1];
    return name && Object.hasOwn(nodes, name) ? nodes[name] ?? '' : part;
  }).filter((part) => part !== '');

  function renderShot(slot) {
    const view = shotViews[slot];
    const def = slotDef(slot);
    if (!view || !def) return;
    if (!isPublic(def)) {
      view.root.dataset.state = 'ticket';
      const required = requiredSlotIds().includes(slot);
      view.main.textContent = required ? t('propose.shot.required_ticket', { text: lower(SHOT_TEXT.ticket) }) : SHOT_TEXT.ticket;
      return;
    }
    const entry = mediaOf(slot) || { state: 'empty' };
    let stateName = entry.state;
    if (degraded() && !['sent'].includes(stateName)) stateName = 'off';
    view.root.dataset.state = stateName;
    /* Mode sans captures : l'avis unique de la colonne nomme la capture (paintDegraded) ; l'emplacement se retire. */
    view.root.hidden = stateName === 'off';
    view.root.toggleAttribute('data-fresh', Boolean(entry.fresh) && !reduced());
    entry.fresh = false;
    const fine = h('span', { class: 'fs-shot-fine', text: t('propose.shot.drop_fine') });
    const coarse = h('span', { class: 'fs-shot-coarse', text: t('propose.shot.drop_coarse') });
    view.main.replaceChildren(...(stateName === 'off' ? [SHOT_TEXT.off] : stateName === 'lost' ? [SHOT_TEXT.lost] : stateName === 'error' && entry.blob ? [t('propose.shot.upload_failed')] : [fine, ' ', coarse]));
    view.alt.hidden = true;
    const buttons = view.zone.querySelector('.fs-shot-buttons');
    if (buttons) buttons.hidden = stateName === 'off';
    view.zone.querySelector('.fs-shot-formats')?.toggleAttribute('hidden', stateName === 'off');
    view.pick.querySelector('[data-shot-pick-label]').textContent = stateName === 'error' && entry.blob ? t('propose.shot.retry') : stateName === 'lost' ? t('propose.shot.redrop') : t('propose.shot.add');
    const texts = { preparing: SHOT_TEXT.preparing, ready: token() ? (degraded() ? SHOT_TEXT.off : SHOT_TEXT.readyQueued) : SHOT_TEXT.readyOffline, uploading: t('propose.shot.uploading', { progress: entry.progress || 0 }), sent: SHOT_TEXT.sent };
    view.status.textContent = texts[stateName] || '';
    view.name.textContent = entry.bytes ? t('propose.shot.file_info', { name: mediaLibName(slot, entry.type), size: sizeText(entry.bytes) }) : entry.restored ? t('propose.shot.restored') : '';
    view.progress.value = stateName === 'preparing' ? 30 : entry.progress || 0;
    if (entry.url) { if (view.thumb.getAttribute('src') !== entry.url) view.thumb.src = entry.url; view.figure.hidden = false; } else { view.thumb.removeAttribute('src'); view.figure.hidden = true; }
    view.maskButton.hidden = !entry.blob || !['ready', 'sent'].includes(stateName);
    view.replace.hidden = !['ready', 'sent'].includes(stateName);
    view.remove.hidden = !['ready', 'sent'].includes(stateName);
    const message = stateName === 'error' ? entry.error : '';
    view.error.textContent = message || '';
    view.error.hidden = !message;
    renderExtra(slot);
  }
  const mediaLibName = (slot, type) => `${state.game}-${slot}.${type === 'image/jpeg' ? 'jpg' : 'webp'}`;
  /** Encarts sous la capture : connexion anticipée, lecture des chiffres, relecture, confirmation de retrait. */
  function renderExtra(slot) {
    const view = shotViews[slot];
    const entry = mediaOf(slot);
    if (!view || view.confirming) return;
    const parts = [];
    if (entry?.state === 'ready' && !token() && !degraded() && !state.pendingLogin && account?.loginPopup) {
      const login = h('button', { type: 'button', class: 'fs-btn', 'data-fs-early-login': slot }, discordIcon(), t('propose.login.button'));
      login.addEventListener('click', () => startLogin({ origin: login }));
      parts.push(h('div', { class: 'fs-shot-extra', 'data-fs-early': slot }, h('p', { text: SHOT_TEXT.early }), login));
    }
    if (entry?.state === 'sent' && entry.id && state.analysis === true && READABLE_SLOTS[state.game]?.includes(slot) && !entry.read) {
      const read = h('button', { type: 'button', class: 'fs-btn', 'data-fs-read': slot, text: t('propose.read.offer_button') });
      read.addEventListener('click', () => readSlot(slot, read));
      parts.push(h('div', { class: 'fs-shot-extra', 'data-fs-read-offer': slot }, h('p', { text: t('propose.read.offer_text') }), read));
    }
    if (entry?.readMessage && typeof entry.readMessage === 'object') parts.push(readNotice(entry.readMessage));
    else if (entry?.readMessage) parts.push(h('div', { class: 'fs-shot-extra', role: 'status' }, h('p', { text: entry.readMessage })));
    const step = stepOfSlot(state.game, slot);
    if (state.reads[step] === slot) {
      parts.push(h('div', { class: 'fs-field fs-propose-field', 'data-fs-field': `read-${step}` },
        h('label', { class: 'fs-commit' }, h('input', { class: 'fs-checkbox', type: 'checkbox', name: `read-${step}`, id: `fs-read-${step}`, checked: Boolean(state.readChecked?.[step]) }), h('span', { text: t('propose.read.checked') })),
        errorLine(`fs-read-${step}`)));
    }
    view.extra.replaceChildren(...parts);
  }

  /* ---- ajout d'une capture : choisir, déposer, coller, fenêtre du jeu ---- */
  function bindShots(form) {
    form.addEventListener('click', (event) => {
      const button = event.target.closest?.('button');
      if (!button) return;
      if (button.hasAttribute('data-shot-zoom')) { openShotViewer(button); return; }
      const slot = button.dataset.shotPick || button.dataset.shotReplace || button.dataset.shotWindow || button.dataset.shotRemove || button.dataset.shotCancel || button.dataset.shotMask;
      if (!slot) return;
      const view = shotViews[slot];
      if (button.dataset.shotPick || button.dataset.shotReplace) {
        const entry = mediaOf(slot);
        if (button.dataset.shotPick && entry?.state === 'error' && entry.blob) { entry.state = 'ready'; entry.error = ''; renderShot(slot); pump(); return; }
        view.input.click();
      } else if (button.dataset.shotWindow) captureWindow(slot);
      else if (button.dataset.shotRemove) confirmRemove(slot);
      else if (button.dataset.shotCancel) removeShot(slot);
      else if (button.dataset.shotMask) openMask(slot);
    });
    form.addEventListener('change', (event) => {
      const slot = event.target.dataset?.shotInput;
      if (!slot) return;
      const file = event.target.files?.[0];
      event.target.value = '';
      if (file) acceptFile(slot, file);
    });
    form.addEventListener('dragover', (event) => {
      const zone = event.target.closest?.('[data-shot-drop]');
      if (!zone || ![...(event.dataTransfer?.types || [])].includes('Files')) return;
      event.preventDefault();
      const view = shotViews[zone.dataset.shotDrop];
      if (view.root.dataset.state !== 'drag') { view.before = view.root.dataset.state; view.root.dataset.state = 'drag'; view.main.textContent = t('propose.shot.drop_release'); }
    });
    form.addEventListener('dragleave', (event) => {
      const zone = event.target.closest?.('[data-shot-drop]');
      if (zone && !zone.contains(event.relatedTarget)) renderShot(zone.dataset.shotDrop);
    });
    form.addEventListener('drop', (event) => {
      const zone = event.target.closest?.('[data-shot-drop]');
      if (!zone) return;
      event.preventDefault();
      const file = event.dataTransfer?.files?.[0];
      renderShot(zone.dataset.shotDrop);
      if (file) acceptFile(zone.dataset.shotDrop, file);
    });
  }
  /* Coller (Ctrl/Cmd+V) : dans l'emplacement qui a le focus, sinon le premier emplacement libre de l'étape. */
  document.addEventListener('paste', (event) => {
    /* Bloc retiré de la page (fenêtre de l'équipe fermée) : jamais une capture envoyée pour un parcours qui n'est plus là. */
    if (detached() || state.view !== 'step' || !state.form || !(document.activeElement === document.body || root.contains(document.activeElement))) return;
    const file = [...(event.clipboardData?.files || [])].find((item) => /^image\//.test(item.type));
    if (!file) return;
    const node = stepNode(state.step);
    const focused = document.activeElement.closest?.('.fs-shot[data-visibility="public"]');
    const candidates = [...node.querySelectorAll('.fs-shot[data-visibility="public"]')];
    const target = focused || candidates.find((shot) => ['empty', 'lost', 'error'].includes(shot.dataset.state));
    event.preventDefault();
    const live = state.form.querySelector('[data-fs-step-live]');
    if (!target) { live.textContent = candidates.length ? t('propose.paste.no_free_slot') : t('propose.paste.no_slot'); return; }
    live.textContent = t('propose.paste.pasted', { label: templateText(slotDef(target.dataset.slot), 'label') });
    acceptFile(target.dataset.slot, file);
  });

  async function acceptFile(slot, file) {
    const def = slotDef(slot);
    if (!def || !isPublic(def) || degraded()) return;
    const previous = mediaOf(slot);
    const fail = (message) => { setMedia(slot, { state: 'error', error: message }); renderShot(slot); refreshDerived(); };
    if (!/^image\/(png|jpeg|webp)$/.test(file.type)) { fail(SHOT_TEXT.format); return; }
    if (file.size > 25 * 1024 * 1024) { fail(t('propose.shot.too_heavy', { size: sizeText(file.size) })); return; }
    const others = slotsOf().filter((item) => isPublic(item) && item.id !== slot && present(item.id)).length;
    if (others >= MAX_SHOTS) { fail(SHOT_TEXT.limit); return; }
    previous?.abort?.abort();
    const ticket = Symbol(slot);
    setMedia(slot, { state: 'preparing', ticket });
    renderShot(slot);
    let prepared;
    try { prepared = await (await loadMedia()).prepareImage(file); } catch { if (mediaOf(slot)?.ticket === ticket) fail(SHOT_TEXT.unreadable); return; }
    if (mediaOf(slot)?.ticket !== ticket) return;
    if (previous?.url?.startsWith('blob:')) URL.revokeObjectURL(previous.url);
    setMedia(slot, { state: 'ready', blob: prepared.blob, type: prepared.type, bytes: prepared.blob.size, url: URL.createObjectURL(prepared.blob), fresh: true });
    renderShot(slot);
    announceStep(t('propose.shot.ready', { label: lower(templateText(def, 'label')) }));
    afterShotChange(slot);
    pump();
  }
  /** Annonce lecteur d'écran (région role=status de l'étape). */
  function announceStep(text) {
    const live = state.form?.querySelector('[data-fs-step-live]');
    if (!live) return;
    live.textContent = '';
    requestAnimationFrame(() => { live.textContent = text; });
  }
  function afterShotChange(slot) {
    const step = stepOfSlot(state.game, slot);
    if (stepNode(step)?.querySelector(`[data-fs-field="shot-${CSS.escape(slot)}"].is-invalid`)) setError(`shot-${slot}`, '');
    clearSummary(step);
    saveSoon();
    updateFoot();
    refreshDerived();
    if (state.step === 'verifier') renderReview();
  }
  function confirmRemove(slot) {
    const view = shotViews[slot];
    view.confirming = true;
    const yes = h('button', { type: 'button', class: 'fs-btn', 'data-fs-remove-yes': slot, text: t('propose.shot.remove') });
    const no = h('button', { type: 'button', class: 'fs-btn fs-btn--link', text: t('propose.shot.keep') });
    view.extra.replaceChildren(h('div', { class: 'fs-shot-extra', role: 'alert' }, h('p', { text: t('propose.shot.remove_confirm') }), yes, no));
    yes.addEventListener('click', () => { view.confirming = false; removeShot(slot); view.pick?.focus({ preventScroll: true }); });
    no.addEventListener('click', () => { view.confirming = false; renderExtra(slot); view.remove.focus({ preventScroll: true }); });
    yes.focus({ preventScroll: true });
  }
  function removeShot(slot) {
    const entry = mediaOf(slot);
    entry?.abort?.abort();
    if (entry?.url?.startsWith('blob:')) URL.revokeObjectURL(entry.url);
    delete state.media[state.game][slot];
    shotViews[slot].tool.replaceChildren();
    renderShot(slot);
    afterShotChange(slot);
  }
  async function captureWindow(slot) {
    const importUi = await loadImportUi();
    if (!importUi?.grabGameWindow) return;
    const result = await importUi.grabGameWindow({ env: window });
    if (!result.ok) { setMedia(slot, { ...(mediaOf(slot) || {}), state: mediaOf(slot)?.blob ? mediaOf(slot).state : 'error', error: result.message }); if (!mediaOf(slot).blob) renderShot(slot); else { shotViews[slot].status.textContent = result.message; } return; }
    acceptFile(slot, new File([result.blob], `${state.game}-${slot}.jpg`, { type: result.blob.type || 'image/jpeg' }));
  }
  /** « Masquer une zone » : outil en ligne ; « Appliquer » aplatit les zones dans l'image (une capture déjà envoyée repart). */
  async function openMask(slot) {
    const entry = mediaOf(slot);
    const view = shotViews[slot];
    if (!entry?.blob) return;
    const def = slotDef(slot);
    let lib;
    try { lib = await loadMedia(); } catch { return; }
    entry.hold = true;
    const tool = lib.mountMaskTool({ container: view.tool, src: entry.url, label: lower(templateText(def, 'label')), instruction: def.mask ? lower(templateText(def, 'mask')) : '',
      onCancel: () => { entry.hold = false; tool.destroy(); view.maskButton.focus({ preventScroll: true }); pump(); },
      onApply: async (rects) => {
        tool.destroy();
        entry.hold = false;
        if (!rects.length) { view.maskButton.focus({ preventScroll: true }); pump(); return; }
        setMedia(slot, { ...entry, state: 'preparing' });
        renderShot(slot);
        try {
          const masked = await lib.applyMasks(entry.blob, rects);
          if (entry.url?.startsWith('blob:')) URL.revokeObjectURL(entry.url);
          setMedia(slot, { state: 'ready', blob: masked.blob, type: masked.type, bytes: masked.blob.size, url: URL.createObjectURL(masked.blob), fresh: true, masked: true });
        } catch { setMedia(slot, { ...entry, state: 'error', error: SHOT_TEXT.unreadable }); }
        renderShot(slot);
        shotViews[slot].name.textContent = `${t('propose.mask.count', { count: rects.length })} · ${shotViews[slot].name.textContent}`;
        announceStep(`${t('propose.mask.count', { count: rects.length })}.`);
        afterShotChange(slot);
        view.maskButton.focus({ preventScroll: true });
        pump();
      } });
    tool.focus({ preventScroll: true });
  }

  /* ---- envoi des captures : une à la fois, dès qu'une session existe ---- */
  let pumping = null;
  function pump() {
    if (pumping || !token() || degraded() || detached()) return pumping;
    /* La file se libère à la fin, même quand il n'y avait rien à envoyer (fin synchrone de la boucle). */
    const run = (async () => {
      for (;;) {
        const next = Object.entries(state.media[state.game] || {}).find(([, entry]) => entry.state === 'ready' && entry.blob && !entry.id && !entry.hold);
        if (!next || !token() || degraded() || detached()) break;
        const outcome = await uploadOne(next[0], next[1]);
        if (outcome === 'stop') break;
      }
    })();
    pumping = run;
    run.finally(() => { if (pumping === run) pumping = null; });
    return run;
  }
  async function uploadOne(slot, entry) {
    const lib = await loadMedia();
    entry.state = 'uploading';
    entry.progress = 0;
    entry.abort = new AbortController();
    renderShot(slot);
    const response = await lib.uploadMedia({ url: `${service}/submissions/media`, token: token(), game: state.game, slot, blob: entry.blob, signal: entry.abort.signal,
      onProgress: (value) => { entry.progress = value; if (mediaOf(slot) === entry && shotViews[slot]) { shotViews[slot].status.textContent = t('propose.shot.uploading', { progress: value }); shotViews[slot].progress.value = value; } } });
    const outcome = lib.mediaOutcome(response.status, response.body, { retryAfter: response.retryAfter });
    if (mediaOf(slot) !== entry) return 'next';
    entry.abort = null;
    if (outcome.kind === 'ok') { Object.assign(entry, { state: 'sent', id: outcome.id, expiresAt: outcome.expiresAt, progress: 100 }); renderShot(slot); afterShotChange(slot); return 'next'; }
    if (outcome.kind === 'cancelled') { removeShot(slot); return 'next'; }
    if (outcome.kind === 'busy') { entry.state = 'ready'; renderShot(slot); await new Promise((resolve) => setTimeout(resolve, outcome.retryAfter * 1000)); return 'next'; }
    if (outcome.kind === 'auth') { entry.state = 'ready'; renderShot(slot); dropSession(); account?.logout?.(); showAuthError(outcome.message); refreshAll(); return 'stop'; }
    if (outcome.kind === 'disabled') { entry.state = 'ready'; state.mediaInfo.enabled = false; refreshAll(); return 'stop'; }
    Object.assign(entry, { state: 'error', error: outcome.message });
    renderShot(slot);
    return outcome.kind === 'limit' || outcome.kind === 'forbidden' ? 'stop' : 'next';
  }
  /** Reprise : état des captures envoyées avant un rechargement (POST /submissions/media/status). */
  async function describeRestored() {
    const restored = Object.entries(state.media[state.game] || {}).filter(([, entry]) => entry.restored && entry.id && !entry.described);
    if (!restored.length || !token()) return;
    const lib = await loadMedia().catch(() => null);
    const response = await lib?.describeMedia({ url: `${service}/submissions/media/status`, token: token(), ids: restored.map(([, entry]) => entry.id) });
    if (!response || response.status !== 200 || !Array.isArray(response.body?.media)) return;
    const byId = new Map(response.body.media.filter((item) => item && typeof item.id === 'string').map((item) => [item.id, item]));
    for (const [slot, entry] of restored) {
      const info = byId.get(entry.id);
      entry.described = true;
      if (!info || info.state === 'expired' || info.state === 'used' || (info.game && info.game !== state.game)) { setMedia(slot, { state: 'lost' }); continue; }
      const preview = typeof info.previewUrl === 'string' && (safeUrl(info.previewUrl) || info.previewUrl.startsWith(`${service}/`)) ? info.previewUrl : '';
      if (preview) entry.url = preview;
    }
    Object.keys(shotViews).forEach(renderShot);
    saveSoon();
    refreshDerived();
  }

  /* ---- lecture d'une capture jointe (analyse active seulement) ---- */
  async function readSlot(slot, button) {
    const entry = mediaOf(slot);
    const importUi = await loadImportUi();
    if (!entry?.id || !importUi?.readCapture || !token()) return;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    shotViews[slot].status.textContent = t('propose.read.progress');
    let outcome;
    for (let attempt = 0; attempt < 4; attempt += 1) {
      const response = await importUi.readCapture({ url: `${service}/imports/screenshot`, token: token(), game: state.game, id: entry.id });
      outcome = importUi.readOutcome(response.status, response.body, { retryAfter: response.retryAfter });
      if (outcome.kind !== 'processing') break;
      await new Promise((resolve) => setTimeout(resolve, outcome.retryAfter * 1000));
    }
    button.disabled = false;
    button.removeAttribute('aria-busy');
    renderShot(slot);
    if (outcome.kind === 'unavailable' || outcome.kind === 'limit') { state.analysis = false; entry.readMessage = outcome.message; renderExtra(slot); return; }
    if (outcome.kind === 'auth') { dropSession(); account?.logout?.(); showAuthError(outcome.message); refreshAll(); return; }
    if (outcome.kind !== 'ok') { entry.readMessage = outcome.message || t('propose.read.nothing'); renderExtra(slot); return; }
    let item;
    try { item = await guardImport(outcome.data); } catch (error) { entry.readMessage = t('propose.read.refused', { reason: String(error?.message || t('propose.read.unknown_format')).slice(0, 160) }); renderExtra(slot); return; }
    applyRead(slot, item);
  }
  /** Valeurs lues : seulement les champs vides ; un conflit s'affiche « Lu : … [Utiliser] », sans rien écraser. */
  function applyRead(slot, item) {
    const entry = mediaOf(slot);
    const fields = fieldMap();
    const current = readInput({ exact: true }).values;
    let filledCount = 0;
    const touched = [];
    for (const [key, value] of Object.entries(item.values || {})) {
      const field = fields.get(key);
      if (!field || field.type === 'multichoice') continue;
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
      if (!block) continue;
      if (current[key] === undefined) { setControl(field, value); markRead(key); filledCount += 1; touched.push(key); continue; }
      if (sameValue(field, current[key], value)) continue;
      const conflict = block.querySelector('[data-fs-read-conflict]');
      const use = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-read-use': key }, t('propose.read.use'), h('span', { class: 'fs-visually-hidden', text: t('propose.read.use_field', { name: fieldName(field) }) }));
      use.addEventListener('click', () => { setControl(field, value); markRead(key); conflict.hidden = true; onEdit({ type: 'change', target: block.querySelector('input, select') || block }); });
      conflict.replaceChildren(t('propose.read.read_prefix'), h('b', { text: field.type === 'boolean' ? (value ? t('propose.common.yes') : t('propose.common.no')) : field.type === 'integer' ? digits(value) : String(value) }), ' ', use);
      conflict.hidden = false;
      filledCount += 1;
      touched.push(key);
    }
    entry.read = true;
    const step = stepOfSlot(state.game, slot);
    if (filledCount) {
      /* Message qui dit où vont les valeurs (spec 05, GR-13) : celles de l'étape, surlignées, et un lien par autre étape. */
      const elsewhere = new Map();
      for (const key of touched) { const where = stepOfKey(state.game, key); if (where && where !== step) elsewhere.set(where, (elsewhere.get(where) || 0) + 1); }
      entry.readMessage = { count: filledCount, label: templateText(slotDef(slot), 'label') || '', here: touched.filter((key) => stepOfKey(state.game, key) === step).length,
        elsewhere: [...elsewhere].map(([id, count]) => ({ id, count })) };
      state.reads[step] = slot;
    } else entry.readMessage = t('propose.read.nothing');
    renderExtra(slot);
    refreshSummary(state.step);
    syncConditional();
    saveSoon();
    refreshDerived();
    updateFoot();
  }
  /**
   * Avis de lecture (role=status, spec 05 § 1.10) : « 4 valeurs lues sur « Vos drones ». 2 dans cette étape, surlignées ;
   * 2 dans [Armement]. » Chaque autre étape est un bouton qui y mène.
   */
  function readNotice({ count, label, here, elsewhere }) {
    const others = elsewhere.flatMap(({ id, count: n }, index) => [index ? (index === elsewhere.length - 1 ? t('propose.read.and') : ', ') : '',
      ...tNodes('propose.read.elsewhere', { step: h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-btn--inline', 'data-fs-read-go': id, text: stepById(id)?.title || id }) }, { count: n })]);
    const where = !elsewhere.length ? [' ', here > 1 ? t('propose.read.all_here') : t('propose.read.one_here')]
      : [' ', here ? t('propose.read.here', { count: here }) : '', ...others, '.'];
    return h('div', { class: 'fs-shot-extra fs-alert fs-alert--read', role: 'status', 'data-fs-read-notice': true },
      h('p', {}, h('strong', { text: t('propose.read.notice', { count, label: pick(label) }) }), where));
  }
  const sameValue = (field, raw, value) => (field.type === 'integer' ? parseNumber(raw) === value : field.type === 'boolean' ? raw === value : String(raw).trim().toLowerCase() === String(value).trim().toLowerCase());
  function setControl(field, value) {
    const name = `f-${field.key}`;
    if (field.type === 'boolean' || (field.type === 'integer' && field.ratioOf) || (field.type === 'choice' && state.form.querySelector(`input[type="radio"][name="${name}"]`))) {
      const wanted = field.type === 'boolean' ? String(value) : String(value);
      state.form.querySelectorAll(`input[name="${name}"]`).forEach((input) => { input.checked = input.value === wanted || (input.type === 'checkbox' && value === true); });
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(field.key)}"]`);
      if (block?.matches('.fs-gauge')) syncGauge(block);
      return;
    }
    const control = state.form.querySelector(`[name="${name}"]`);
    if (!control) return;
    control.value = field.type === 'integer' ? groupDigits(value) : String(value);
    const block = control.closest('[data-fs-field]');
    if (block) syncRound(block);
  }
  /** `from` : 'tool' pour une valeur lue par un outil de compte (AccInsight, T-Ware), sinon lue sur une capture. */
  function markRead(key, from = 'screenshot') {
    const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
    if (!block) return;
    block.classList.add('is-read');
    const badge = block.querySelector('[data-fs-read-badge]');
    badge?.removeAttribute('hidden');
    const more = badge?.querySelector('.fs-visually-hidden');
    if (more) more.textContent = t(from === 'tool' ? 'propose.fields.read_badge_more_tool' : 'propose.fields.read_badge_more');
    state.readKeys.add(key);
  }
  function unmarkRead(key) {
    if (!state.readKeys.has(key)) return;
    const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
    block?.classList.remove('is-read');
    block?.querySelector('[data-fs-read-badge]')?.setAttribute('hidden', '');
    state.readKeys.delete(key);
    state.imported.delete(key);
  }

  /* ---- connexion Discord : à l'envoi, dans une fenêtre séparée (arbitrage 6) ---- */
  /** Bloc d'envoi : non connecté, connexion en cours, connecté (pseudo, déconnexion), avertissement avant redirection. */
  function renderAuth() {
    const node = stepNode(CONDITIONS_STEP);
    if (!node) return;
    const box = node.querySelector('[data-fs-review-auth]');
    const send = node.querySelector('[data-fs-propose-send]');
    if (box.querySelector('[data-fs-redirect-warning]')) return;
    const admin = state.me?.admin === true;
    if (state.sending) { send.replaceChildren(state.sending); return; }
    if (!token()) {
      box.replaceChildren(h('p', { text: state.pendingLogin ? t('propose.auth.pending') : state.join ? t('propose.auth.last_step_join') : t('propose.auth.last_step') }));
      /* « Envoyer l'annonce » (VEND-11) : la connexion Discord s'ouvre au clic, dans une nouvelle fenêtre. */
      send.replaceChildren(discordIcon(), t('propose.send.submit'), h('span', { class: 'fs-visually-hidden', text: t('propose.send.new_window') }), h('span', { 'aria-hidden': 'true', text: ' ↗' }));
    } else {
      const logoutButton = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-propose-logout': true, text: t('propose.auth.logout') });
      /* Modification (VEND-16) : toujours relue par l'équipe, même pour un compte administrateur. */
      const amending = state.correction?.kind === 'edit' && state.correction.game === state.game && !state.correction.pending;
      box.replaceChildren(h('p', {}, ...(state.me?.name ? tNodes('propose.auth.connected_as', { name: h('strong', { text: state.me.name }) }) : [t('propose.auth.connected')]), state.justLogged ? ` ${t('propose.auth.ready')}` : '',
        amending ? ` ${t('propose.auth.amend_review')}` : admin ? ` ${t('propose.auth.admin')}` : ''), logoutButton);
      send.replaceChildren(amending ? t('propose.send.amend') : admin ? t('propose.send.publish') : state.correction?.game === state.game && !state.correction.pending ? t('propose.send.resend') : t('propose.send.submit'));
    }
    send.removeAttribute('aria-busy');
    send.removeAttribute('aria-disabled');
  }
  /** Lance la connexion (fenêtre Discord) ; fenêtre bloquée → redirection, après avertissement si des captures attendent. */
  function startLogin({ origin = null } = {}) {
    clearTimeout(saveTimer);
    saveDrafts();
    showAuthError('');
    if (!account) {
      /* Ancienne page sans compte du site : redirection avec le nonce de l'onglet. */
      const value = newNonce();
      store.set(NONCE_KEY, value);
      redirect(loginUrl(service, state.game, value, rootLang(document.documentElement.dataset.fsRoot)), origin);
      return;
    }
    if (typeof account.loginPopup !== 'function') { const href = account.prepareLogin({ kind: 'propose', game: state.game }); if (href) redirect(href, origin); return; }
    const attempt = account.loginPopup({ kind: 'propose', game: state.game });
    if (attempt.blocked) { redirect(attempt.url, origin); return; }
    state.pendingLogin = true;
    refreshAll();
    attempt.promise.then((outcome) => {
      state.pendingLogin = false;
      if (outcome.ok) { loggedIn({ fresh: true }); return; }
      state.afterLogin = null;
      if (outcome.error === 'closed') showAuthError(t('propose.auth.popup_closed'));
      else if (outcome.error === 'storage') showAuthError(t('propose.auth.storage'));
      else showAuthError(outcome.error === 'exchange_failed' ? t('propose.common.discord_failed') : outcome.error === 'exchange_refused' || outcome.error === 'expired' ? t('propose.common.login_expired') : authErrorMessage(outcome.error));
      refreshAll();
      focusOn(ui.authError);
    });
  }
  /** Redirection vers Discord : les captures pas encore envoyées seraient perdues (jamais gardées) → avertissement d'abord. */
  function redirect(url, origin) {
    const pending = unsent();
    const leave = () => {
      for (const entry of pending) { if (entry.url?.startsWith('blob:')) URL.revokeObjectURL(entry.url); entry.state = 'lost'; entry.blob = null; entry.url = null; }
      saveDrafts();
      window.location.assign(url);
    };
    if (!pending.length) { leave(); return; }
    const go2 = h('button', { type: 'button', class: 'fs-btn fs-btn--primary', 'data-fs-redirect-go': true, text: t('propose.redirect.continue') });
    const cancel = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-redirect-cancel': true, text: t('propose.redirect.cancel') });
    const warning = h('div', { class: 'fs-alert fs-propose-banner', 'data-tone': 'warning', role: 'alert', 'data-fs-redirect-warning': true },
      h('p', { text: t('propose.redirect.warning', { count: pending.length }) }),
      h('div', { class: 'fs-propose-actions' }, go2, cancel));
    const host = origin?.closest('.fs-shot-extra') || stepNode(CONDITIONS_STEP)?.querySelector('[data-fs-review-auth]') || ui.banners;
    if (origin?.closest('.fs-shot-extra')) host.after(warning); else host.replaceChildren(warning);
    go2.addEventListener('click', leave);
    cancel.addEventListener('click', () => { warning.remove(); renderAuth(); focusOn(origin && origin.isConnected ? origin : stepNode(state.step)?.querySelector('.fs-step-title')); });
    go2.focus({ preventScroll: true });
  }
  /**
   * Compte de la session ≠ compte du contexte de modification ou de correction (mode actif ou gardé, chargement en cours) :
   * le mode est abandonné avec son brouillon lié, rempli depuis l'annonce de l'autre compte ; un chargement en cours est
   * annulé. Un brouillon ordinaire reste celui de l'onglet, comme avant ; même compte, ou aucun compte connu : rien ne
   * change. Rend faux si un contexte a été retiré (l'appelant s'arrête alors).
   */
  function enforceAccount() {
    const user = currentUser();
    const active = state.correction;
    const foreign = [active && !active.pending ? active : null, savedMode].map((mode) => foreignContext(mode, state.drafts, user)).filter((game) => game !== null);
    const pending = Boolean(active?.pending && active.user && user && active.user !== user);
    if (!foreign.length && !pending) return true;
    forgetMode();
    for (const game of new Set(foreign.filter(Boolean))) {
      delete state.drafts[game];
      delete savedDrafts.drafts[game];
      state.restored.delete(game);
      releaseMedia(game);
      if (state.game === game && state.form) { state.form = null; buildForm(); showWelcome({ push: false, focus: false }); }
    }
    const kept = state.game || savedDrafts.game;
    if (state.drafts[kept]) store.set(DRAFT_KEY, serializeDraftStore(kept, state.drafts)); else store.remove(DRAFT_KEY);
    showNote(t('propose.account.foreign'));
    return false;
  }
  /** Session obtenue (fenêtre, retour de redirection, en-tête ou autre onglet) : /me, services, envoi des captures. */
  async function loggedIn({ fresh = false } = {}) {
    const next = account ? account.session() : state.session;
    if (!next) return;
    const same = state.loggedToken === next.token;
    state.session = next;
    state.loggedToken = next.token;
    enforceAccount();
    if (fresh) state.justLogged = true;
    armExpiry();
    showAuthError('');
    if (!same) { await Promise.all([verify(), probeServices()]); enforceAccount(); }
    const priced = syncPriceStep();
    syncTerms();
    if (!state.panel) mountTware();
    if (state.correction?.pending) { await loadCorrection(); pump(); return; }
    refreshAll();
    pump();
    /* Connexion demandée par « Commencer » ou « Reprendre » : l'étape voulue s'ouvre. */
    if (state.afterLogin && stepById(state.afterLogin) && state.view !== 'step') { const id = state.afterLogin; state.afterLogin = null; go(id, { dir: 'forward' }); return; }
    if (!fresh || state.step !== CONDITIONS_STEP || state.view !== 'step') return;
    /* Connexion qui révèle le prix souhaité au moment d'envoyer : l'étape s'insère avant « Vérifier » et s'ouvre,
       saisie gardée ; « Retour au récapitulatif » ramène ensuite à « Vérifier », puis aux conditions. */
    if (priced && parseExpectedNet(priceText()).error) { go(PRICE_STEP, { dir: 'back', editing: true }); return; }
    focusOn(stepNode(CONDITIONS_STEP)?.querySelector('[data-fs-propose-send]'));
  }
  /**
   * Étape « Votre prix » ajoutée (ou retirée) selon features.prices, sans reconstruire le formulaire ni perdre la saisie.
   * Vrai si l'étape vient d'être ajoutée.
   */
  function syncPriceStep() {
    if (!state.form) return false;
    const node = stepNode(PRICE_STEP);
    if (Boolean(node) === state.prices) return false;
    const current = state.step === PRICE_STEP;
    if (node) { state.price = priceText(); node.remove(); }
    else {
      const list = steps();
      const index = list.findIndex((entry) => entry.id === PRICE_STEP);
      stepNode('verifier')?.before(buildStep(list[index], { values: {} }, index, list.length));
    }
    const nodes = [...state.form.querySelectorAll('[data-fs-step]')];
    nodes.forEach((item, index) => { item.dataset.index = String(index); item.dataset.count = String(nodes.length); });
    paintKickers();
    if (current) { go('verifier', { push: false, replace: true, clicked: false }); return false; }
    if (state.view === 'step') { renderRail(); updateFoot(); if (state.step === 'verifier') renderReview(); }
    return !node;
  }
  async function verify() {
    try {
      if (account?.me) {
        const rights = await account.me();
        if (!state.session) return;
        state.me = rights ? { name: rights.name, admin: rights.publisher === true } : { name: '', admin: false };
        /* Prix souhaité et ticket vendeur : seulement si le service les annonce ; /me illisible → rien ne change. */
        /* Modification par l'équipe : l'étape du prix suit le bloc fourni par la fiche (net et commission), jamais le prix souhaité. */
        if (rights && !admin) { state.prices = rights.prices === true; state.sellerTickets = rights.sellerTickets === true; syncTerms(); }
        return;
      }
      const { status, body } = await call('/me');
      if (status === 401) { dropSession(); showAuthError(t('propose.auth.session_expired')); return; }
      if (status !== 200 || !body || typeof body.name !== 'string') throw new Error(`statut ${status}`);
      state.me = { name: body.name.slice(0, 80), admin: body.publisher === true || body.admin === true };
      state.prices = body.features?.prices === true;
      state.sellerTickets = body.features?.sellerTickets === true;
      /* Texte des conditions réécrit tout de suite, sans attendre probeServices : la version envoyée est celle affichée. */
      syncTerms();
    } catch { state.me = { name: '', admin: false }; }
  }
  /** Disponibilité des captures (GET /submissions/media) et de l'analyse (GET /imports/screenshot), puis reprise. */
  async function probeServices() {
    const auth = token();
    if (!auth) return;
    const importUi = await loadImportUi();
    const [media, analysis] = await Promise.all([
      mediaAvailable(auth),
      importUi?.checkAvailability ? importUi.checkAvailability({ url: `${service}/imports/screenshot`, token: auth }) : Promise.resolve({ available: null }),
    ]);
    /* Reprise d'une annonce Discord : captures jamais reprises, quel que soit l'état du service. */
    state.mediaInfo = { enabled: admin?.captures === false ? false : media.enabled, remaining: media.remaining ?? null };
    state.analysis = analysis.available === true;
    if (state.mediaInfo.enabled === false) {
      for (const entry of Object.values(state.media[state.game] || {})) if (entry.url?.startsWith('blob:') && !entry.id) { URL.revokeObjectURL(entry.url); entry.url = null; entry.blob = null; }
    }
    await describeRestored();
  }
  /**
   * GET /submissions/media : { enabled: true | false | null } (null : inconnu, rien n'est grisé). Sans jeton, le service
   * ne répond que { enabled }. Ici plutôt que dans fs-propose-media.js, chargé seulement au premier ajout d'une capture.
   */
  async function mediaAvailable(auth) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(`${service}/submissions/media`, { method: 'GET', mode: 'cors', credentials: 'omit', signal: controller.signal, headers: auth ? { Authorization: `Bearer ${auth}` } : {} });
      if (response.status === 503) return { enabled: false };
      const body = await response.json().catch(() => null);
      return response.status === 200 && typeof body?.enabled === 'boolean' ? { enabled: body.enabled, remaining: Number.isInteger(body.remaining) ? body.remaining : null } : { enabled: null };
    } catch { return { enabled: null }; } finally { clearTimeout(timer); }
  }
  /** Captures disponibles ? Lu sans session dès l'ouverture : le mode dégradé s'affiche avant tout effort (contrat 05 § 2). */
  async function probeMedia() {
    if (token() || state.mediaInfo.enabled !== null) return;
    const media = await mediaAvailable(null);
    if (token() || media.enabled === null) return;
    state.mediaInfo = { enabled: media.enabled, remaining: null };
    refreshAll();
  }
  /**
   * Mode sans captures (service éteint, spec 05 GR-18) : un seul avis en tête de la colonne, qui nomme les captures à
   * envoyer dans le ticket ; ni avis sur les métadonnées, ni « puis ajoutez la capture » au chapeau.
   */
  function paintDegraded() {
    if (!state.form) return;
    const off = degraded();
    state.form.querySelectorAll('[data-fs-shots-off]').forEach((notice) => { notice.hidden = !off; });
    state.form.querySelectorAll('.fs-bench-side .fs-shot-privacy').forEach((line) => { line.hidden = off; });
    for (const entry of steps()) {
      const lead = stepNode(entry.id)?.querySelector('[data-fs-step-lead]');
      /* Chapeau sans « puis ajoutez la capture » : texte traduit dédié (lead_off), sinon le même retrait qu'avant. */
      const offKey = `propose.lead_off.${state.game}.${entry.id}`;
      if (lead) lead.textContent = frenchSpacing(off ? (has(offKey) ? t(offKey) : entry.lead.replace(/,? puis ajoutez la capture[^.]*/, '')) : entry.lead);
    }
  }
  /** Tout ce qui dépend de la session, des services ou des captures. */
  function refreshAll() {
    if (!state.form) return;
    Object.keys(shotViews).forEach(renderShot);
    paintDegraded();
    if (state.welcome) state.welcome.querySelector('[data-fs-welcome-tip]').hidden = state.analysis !== true || !slotsOf().some(isPublic);
    paintDiscordLine();
    if (state.step === 'verifier') renderReview();
    renderConditions();
    updateFoot();
    refreshDerived();
  }
  async function call(path, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${service}${path}`, { ...options, mode: 'cors', credentials: 'omit', signal: controller.signal, headers: { Authorization: `Bearer ${token()}`, ...(options.headers || {}) } });
      let body = null;
      try { body = await response.json(); } catch { /* corps vide ou non JSON */ }
      return { status: response.status, body };
    } finally { clearTimeout(timer); }
  }
  function logout() {
    account?.logout();
    dropSession();
    /* Saisie effacée : la modification ou la correction en cours est abandonnée avec elle (jamais reprise par un autre compte). */
    forgetMode();
    state.loggedToken = '';
    store.remove(DRAFT_KEY);
    store.remove(CLOSED_DRAFT_KEY);
    for (const game of Object.keys(state.media)) releaseMedia(game);
    state.drafts = {};
    state.restored.clear();
    state.form = null;
    state.prices = false;
    state.price = '';
    state.sellerTickets = false;
    buildForm();
    showWelcome({ push: false });
    showNote(t('propose.auth.logged_out'));
    applyChooser();
  }
  /* Ancienne page sans compte du site : échange du code de retour ici. */
  async function exchange(code, value) {
    let outcome = null;
    try {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      const response = await fetch(`${service}/auth/exchange`, { method: 'POST', mode: 'cors', credentials: 'omit', signal: controller.signal,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code, nonce: value }) }).finally(() => clearTimeout(timer));
      let body = null;
      try { body = await response.json(); } catch { /* corps vide */ }
      if (response.status === 200 && body && typeof body.token === 'string' && TOKEN.test(body.token)) {
        state.session = { token: body.token, exp: sessionExpiry(body.exp, body.token) };
        store.set(SESSION_KEY, JSON.stringify(state.session));
      } else outcome = response.status === 400 ? t('propose.common.login_expired') : t('propose.common.discord_failed');
    } catch { outcome = t('propose.auth.service_down'); }
    showAuthError(outcome || '');
    announce(state.session ? { ok: true, error: null } : { ok: false, error: outcome ? 'exchange_failed' : 'expired' });
    if (state.session) await loggedIn({ fresh: true });
  }

  /* ---- envoi de l'annonce ---- */
  async function send() {
    if (state.busy) return;
    const tpl = template();
    const node = stepNode(CONDITIONS_STEP);
    const status = node.querySelector('[data-fs-propose-send-status]');
    status.textContent = '';
    if (!listingReady()) return;
    /* Case des conditions non cochée (VEND-11, CA1) : message sous la case, focus sur elle ; ni connexion ni envoi. */
    const box = node.querySelector('[name="fs-commit"]');
    const commit = stepErrors(CONDITIONS_STEP).commit;
    setError('commit', commit || '');
    if (commit) { focusOn(box); return; }
    if (!token()) { startLogin({ origin: node.querySelector('[data-fs-propose-send]') }); return; }
    /* Version des conditions acceptées au clic : revérifiée avant l'envoi (elle peut changer pendant les attentes). */
    const acceptedTerms = node.querySelector('[data-fs-terms]')?.dataset.fsTerms;
    const sendButton = node.querySelector('[data-fs-propose-send]');
    state.busy = true;
    state.form.setAttribute('aria-busy', 'true');
    sendButton.setAttribute('aria-busy', 'true');
    sendButton.setAttribute('aria-disabled', 'true');
    try {
      /* Captures d'abord (une à la fois), puis l'annonce. */
      await pump();
      const queue = Object.entries(state.media[state.game] || {}).filter(([, entry]) => entry.state === 'ready' && entry.blob && !entry.id);
      for (const [index, [slot, entry]] of queue.entries()) {
        sendButton.replaceChildren(t('propose.send.uploading_shots', { index: index + 1, total: queue.length }));
        await uploadOne(slot, entry);
      }
      if (!token()) { state.busy = false; return; }
      const failed = Object.entries(state.media[state.game] || {}).filter(([slot, entry]) => isPublic(slotDef(slot)) && entry.state === 'error');
      if (failed.length && !degraded()) {
        status.textContent = t('propose.send.failed_shots', { count: failed.length });
        goToField(`shot-${failed[0][0]}`);
        return;
      }
      sendButton.replaceChildren(t('propose.send.sending'));
      const listing = checkSubmission(state.lib, tpl, readInput());
      const media = degraded() ? [] : Object.entries(state.media[state.game] || {}).filter(([slot, entry]) => isPublic(slotDef(slot)) && entry.state === 'sent' && entry.id).map(([slot, entry]) => ({ slot, id: entry.id }));
      if (typeof state.lib.validateMedia === 'function') state.lib.validateMedia(tpl, media);
      /* Valeurs dont le vendeur garde l'arrondi proposé (contrat 09 § 9.3) : signalées à l'équipe, jamais en silence. */
      const exact = readInput({ exact: true }).values;
      const rounded = fieldsOf(tpl).filter((field) => roundable(field) && listing.values[field.key] !== undefined && String(listing.values[field.key]) !== String(exact[field.key])).map((field) => field.key);
      const current = state.correction && !state.correction.pending && state.correction.game === state.game ? state.correction : null;
      const replaces = current?.kind === 'fix' ? current.ref : '';
      /* Modification d'une annonce en vente (VEND-16) : toujours en relecture, l'annonce reste en ligne jusque-là. */
      const amends = current?.kind === 'edit' ? current.ref : '';
      /* Prix souhaité (VEND-09) : seulement si le service l'annonce, déjà validé par l'étape ; jamais dans values. */
      const expectedNet = state.prices ? parseExpectedNet(priceText()) : null;
      /* Conditions acceptées (VEND-11) : la version du texte affiché, lue sur la liste ; l'administrateur qui publie
         directement n'accepte pas à la place du vendeur. */
      const shownTerms = stepNode(CONDITIONS_STEP)?.querySelector('[data-fs-terms]')?.dataset.fsTerms;
      /* Conditions changées pendant l'envoi des captures (/me relu) : syncTerms a décoché la case ; rien ne part sans
         une nouvelle acceptation du texte affiché. */
      if (!state.me?.admin && (shownTerms !== acceptedTerms || !box?.checked)) {
        setError('commit', siteError(t('propose.send.terms_changed')));
        focusOn(box);
        return;
      }
      const payload = submissionPayload(listing, { media, rounded, replaces, amends, expectedNet, terms: state.me?.admin ? '' : termsToSend(shownTerms),
        accountCheck: state.accountCheck?.game === listing.game ? state.accountCheck.attestation : '' });
      const body = JSON.stringify(payload);
      if (new TextEncoder().encode(body).length > MAX_BODY) { status.textContent = t('propose.send.too_large'); return; }
      const post = (text) => call('/submissions', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: text }).catch(() => ({ status: 0, body: null }));
      /* Service pas encore à jour (le thème est publié quelques minutes avant lui) : renvoi unique sans terms (postSubmission). */
      const response = await postSubmission(post, payload);
      const outcome = response.status === 0 ? { kind: 'error', message: t('propose.send.no_response') } : submissionOutcome(response.status, response.body);
      if (outcome.kind === 'published' || outcome.kind === 'received') { showSuccess(outcome, listing, response.body); return; }
      saveDrafts();
      if (outcome.kind === 'invalid') {
        const mediaErrors = Array.isArray(response.body?.mediaErrors) ? response.body.mediaErrors : [];
        const lib = state.mediaLib;
        for (const { index, code } of mediaErrors) {
          const item = media[index];
          const entry = item && mediaOf(item.slot);
          if (!entry) continue;
          entry.id = null;
          if (code === 'disabled') state.mediaInfo.enabled = false;
          else if (entry.blob) Object.assign(entry, { state: 'error', error: lib?.mediaErrorText(code) || t('propose.shot.expired') });
          else setMedia(item.slot, { state: 'lost' });
        }
        refreshAll();
        const placed = Object.fromEntries(Object.entries(outcome.errors).map(([key, value]) => (key === 'media' && mediaErrors[0] && media[mediaErrors[0].index] ? [`shot-${media[mediaErrors[0].index].slot}`, value] : [key, value])));
        /* 422 errors.expectedNet : le service demande le prix souhaité ; l'étape apparaît, avec le message du formulaire. */
        if (placed.expectedNet !== undefined) {
          placed.expectedNet = EXPECTED_NET_ERROR;
          if (!state.prices) { state.prices = true; syncPriceStep(); }
        }
        /* Modification refusée (annonce vendue, retirée, déjà en relecture) : rien à corriger dans le formulaire. */
        if (placed.amends !== undefined) {
          /* Motif rédigé en français par le service : repris tel quel en français seulement, message générique ailleurs. */
          status.textContent = locale === 'fr' ? t('propose.send.amend_failed_reason', { reason: String(placed.amends).slice(0, 160) }) : t('propose.send.amend_failed');
          delete placed.amends;
          if (!Object.keys(placed).length) return;
        }
        /* Conditions refusées par le service : page plus ancienne que le service, rôle changé, ou service pas encore à jour
           pendant un déploiement (il ne connaît pas encore la version de cette page). Dans tous les cas, le brouillon garde
           saisie et captures : attendre une minute, recharger, renvoyer. */
        if (placed.terms !== undefined) {
          setError('commit', siteError(t('propose.send.terms_retry')));
          focusOn(box);
          delete placed.terms;
          if (!Object.keys(placed).length) return;
        }
        state.errorSteps = new Set(Object.keys(placed).map((key) => (key.startsWith('shot-') ? stepOfSlot(state.game, key.slice(5)) : stepOfKey(state.game, key))).filter(Boolean));
        renderRail();
        go('verifier', { dir: 'back' });
        showStepErrors('verifier', placed, outcome.message);
        return;
      }
      if (outcome.kind === 'auth') {
        dropSession();
        account?.logout?.();
        showAuthError(outcome.message);
        refreshAll();
        focusOn(ui.authError);
        return;
      }
      status.textContent = outcome.kind === 'limit' ? t('propose.send.limit') : outcome.message;
    } catch (error) {
      if (error?.errors) { go('verifier', { dir: 'back' }); showStepErrors('verifier', error.errors); }
      else status.textContent = t('propose.send.failed');
    } finally {
      state.busy = false;
      state.sending = '';
      state.form?.removeAttribute('aria-busy');
      if (state.form) renderAuth();
    }
  }

  /** Succès : le vaisseau décolle, la frise de la suite (sans délai chiffré, arbitrage 7), le brouillon est effacé. */
  function showSuccess(outcome, listing, body) {
    /* Envoi réussi : l'attestation AccInsight est consommée, jamais jointe à une annonce suivante. */
    state.accountCheck = null;
    const game = state.game;
    const pack = packOf(game);
    const published = outcome.kind === 'published';
    const ship = headShip();
    /* Captures à envoyer dans le ticket Selling (comme « Vérifier ») : « équipe seulement », plus les obligatoires si le
       service des captures est éteint ; obligatoires d'abord, les autres « si vous les avez ». */
    const required = requiredSlotIds();
    /* Jeu sans capture (WarUniverse, VEND-05) : ni relecture des captures, ni captures publiques en vitrine. */
    const captures = slotsOf().some(isPublic);
    const ticketShots = slotsOf().filter((def) => !isPublic(def) || (degraded() && required.includes(def.id)));
    const shotsText = ticketShotsText(ticketShots.filter((def) => required.includes(def.id)).map((def) => lower(templateText(def, 'label'))), ticketShots.filter((def) => !required.includes(def.id)).map((def) => lower(templateText(def, 'label'))));
    /* Renvoi (« Corriger et renvoyer ») : le ticket Selling est peut-être déjà ouvert, avec l'ancienne référence. */
    const resubmitted = Boolean(state.correction && !state.correction.pending && state.correction.game === game);
    /* Modification d'une annonce en vente (VEND-16), ou correction d'une modification refusée : réponse `amendment`. */
    const amended = body?.amendment === true || (resubmitted && state.correction.kind === 'edit');
    delete state.drafts[game];
    state.restored.delete(game);
    releaseMedia(game);
    state.form = null;
    forgetMode();
    saveDrafts();
    const reference = typeof body?.reference === 'string' && /^[A-Z0-9-]{3,20}$/.test(body.reference) ? body.reference : '';
    if (amended) { showAmended(listing, reference, pack, ship); return; }
    const invite = inviteUrl(root.dataset.fsDiscordInvite);
    /* Ticket vendeur ouvert par le bot (MOD-02, SELLER_TICKETS=1), d'après la réponse (doneTicketView) : lien du salon ;
       sans lien mais ticketPending (ouverture pas finie en 3 s ou en échec, le worker réessaie) : « en cours d'ouverture »,
       lien à retrouver dans « Mes annonces » ; sinon le suivi dans « Mes annonces », sans ticket à ouvrir. */
    const ticket = published ? '' : sellingUrl(body?.ticket?.url);
    const pending = !published && doneTicketView(ticket, body) === 'pending';
    const refNode = reference ? h('span', { class: 'fs-done-ref', 'data-fs-done-ref': true, text: reference }) : null;
    /* Référence à recopier dans le ticket : bouton « Copier » (presse-papiers), sinon texte sélectionné pour Ctrl+C. */
    /* Jalon « Prix » : {shots} (ou {{ shots }}) remplacé par les captures à envoyer dans le ticket. */
    const doneText = () => copy().done.replace(/\{\{\s*shots\s*\}\}|\{shots\}/, shotsText);
    /* Sans ticket vendeur : prix réglé quand l'équipe écrit au vendeur (aucun ticket à ouvrir soi-même). */
    const followText = () => copy().follow.replace(/\{\{\s*shots\s*\}\}|\{shots\}/, shotsText);
    const copyRow = (value) => {
      const note = h('span', { class: 'fs-done-copy-note', role: 'status' });
      const button = h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-done-copy', 'data-fs-done-copy': true }, t('propose.done.copy'));
      button.addEventListener('click', async () => {
        /* Presse-papiers refusé, absent ou sans réponse (autorisation en attente) en 2 s : repli sur la sélection. */
        try {
          await Promise.race([navigator.clipboard.writeText(value), new Promise((resolve, reject) => { setTimeout(() => reject(new Error('timeout')), 2000); })]);
          note.textContent = t('propose.done.copied');
          return;
        } catch { /* presse-papiers indisponible */ }
        try { const range = document.createRange(); range.selectNodeContents(refNode); const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); } catch { /* sélection impossible */ }
        note.textContent = t('propose.done.selected');
      });
      return h('p', { class: 'fs-done-copy-row' }, button, note);
    };
    const discordLink = (href, text, kind) => h('a', { class: 'fs-link', href, target: '_blank', rel: 'noopener noreferrer', 'data-fs-done-discord': kind }, text, h('span', { class: 'fs-visually-hidden', text: t('propose.common.new_tab') }));
    const title = h('h3', { class: 'fs-step-title', id: 'fs-propose-done-title', tabindex: '-1', text: published ? t('propose.done.title_published') : t('propose.done.title_sent') });
    const again = h('button', { type: 'button', class: 'fs-btn fs-btn--lg', 'data-fs-propose-again': true, text: t('propose.done.again') });
    /* Suivi sur le site, même onglet : le dialogue « Mes annonces » de l'en-tête (fs-account.js) s'ouvre sans quitter la
       page ; sans lui, le lien /#my-listings (fs-account.js l'ouvre aussi au chargement ou au changement de fragment). */
    const listingsLink = (text, className = 'fs-link') => {
      const link = h('a', { class: className, href: LISTINGS_HREF, 'data-fs-done-listings': true }, text);
      link.addEventListener('click', (event) => {
        const entry = document.querySelector('[data-fs-account-open="submissions"]');
        if (!entry || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        entry.click();
      });
      return link;
    };
    const primary = published ? null : ticket ? { href: ticket, text: t('propose.done.open_ticket'), kind: 'ticket' } : { href: LISTINGS_HREF, text: t('propose.done.track'), kind: 'listings' };
    const done = h('section', { class: 'fs-step fs-propose-success', 'aria-labelledby': 'fs-propose-done-title', 'data-fs-propose-done': outcome.kind },
      h('figure', { class: 'fs-launch', style: artStyle(pack), 'aria-hidden': 'true' }, ship ? h('img', { class: 'fs-launch-ship', src: ship.url, alt: '', width: ship.width, height: ship.height, style: `--ship-w: ${Math.round(ship.width / 1.5)}px` }) : null),
      h('div', { class: 'fs-done-body' },
        h('p', { class: 'fs-label' }, tNodes(published ? 'propose.done.label_published' : 'propose.done.label_review', { ref: reference ? h('span', { class: 'fs-done-ref', text: reference }) : null })),
        title,
        h('p', { class: 'fs-step-lead', text: published ? t('propose.done.lead_published') : ticket ? t('propose.done.lead_ticket') : pending ? TICKET_PENDING_LEAD : t('propose.done.lead_review', { game: names[game] || game }) }),
        /* Une seule action principale (spec 05, GR-14) : le ticket ouvert par le bot (nouvel onglet), sinon le suivi dans
           « Mes annonces » sur le site ; aucune pour une annonce publiée. */
        primary ? h('div', { class: 'fs-propose-actions fs-done-actions' }, primary.kind === 'ticket'
          ? h('a', { class: 'fs-btn fs-btn--primary fs-btn--lg fs-done-primary', href: primary.href, target: '_blank', rel: 'noopener noreferrer', 'data-fs-done-discord': primary.kind }, primary.text, h('span', { class: 'fs-visually-hidden', text: t('propose.common.new_tab') }))
          : listingsLink(primary.text, 'fs-btn fs-btn--primary fs-btn--lg fs-done-primary')) : null,
        h('p', { class: 'fs-propose-done-recap' }, h('strong', { text: t('propose.done.recap', { title: listing.title }) })),
        published ? null : ticket || pending ? h('ol', { class: 'fs-done-steps', [pending ? 'data-fs-done-ticket-pending' : 'data-fs-done-ticket-open']: true },
          /* Le salon est déjà là (ou s'ouvre) : identifiants et prix s'y règlent, la relecture suit (MOD-02). */
          h('li', { 'data-state': 'current' }, h('strong', { text: pending ? t('propose.done.ticket_pending_title') : t('propose.done.ticket_open_title') }), h('div', {},
            h('p', { text: pending ? t('propose.done.ticket_pending_text') : t('propose.done.ticket_open_text') }),
            reference ? copyRow(reference) : null)),
          h('li', {}, h('strong', { text: t('propose.done.credentials_title') }), `${t('propose.done.credentials_text')} ${doneText()}`),
          h('li', {}, h('strong', { text: t('propose.done.review_title') }), tNodes('propose.done.review_24h', { link: listingsLink(t('propose.done.my_listings_link')) })),
          h('li', { 'data-fs-done-showcase': true }, h('strong', { text: t('propose.done.showcase_title') }), showcaseText(game, { captures })))
        : h('ol', { class: 'fs-done-steps' },
          h('li', { 'data-state': 'current' }, h('strong', { text: t('propose.done.review_title') }), captures ? t('propose.done.review_manual_shots') : t('propose.done.review_manual')),
          /* Interrupteur coupé : aucun ticket ne s'ouvre tout seul et le site ne demande plus d'en ouvrir un (P-21) : suivi
             dans « Mes annonces », l'équipe écrit au vendeur. L'invitation reste pour les non-membres (lien https ouvert
             dans l'application Discord par fs-discord-link.js). */
          h('li', { 'data-fs-done-follow': true }, h('strong', { text: t('propose.done.follow_title') }), h('div', {},
            h('p', {},
              tNodes('propose.done.follow_text', { link: listingsLink(t('propose.done.my_listings_link')) }),
              resubmitted ? t('propose.done.follow_replaces') : null,
              reference ? tNodes('propose.done.follow_discord_ref', { ref: refNode }) : t('propose.done.follow_discord'),
              invite ? tNodes('propose.done.not_member', { link: discordLink(invite, t('propose.done.join_server'), 'invite') }) : null),
            reference ? copyRow(reference) : null)),
          h('li', {}, h('strong', { text: t('propose.done.price_title') }), followText()),
          h('li', { 'data-fs-done-showcase': true }, h('strong', { text: t('propose.done.showcase_title') }), showcaseText(game, { captures }))),
        h('div', { class: 'fs-propose-actions' }, again)));
    again.addEventListener('click', () => { buildForm(); showWelcome(); });
    state.done = done;
    ui.slot.replaceChildren(done);
    state.welcome = null;
    showView('done');
    ui.banners.replaceChildren();
    applyChooser();
    scrollTop(done, true);
    title.focus({ preventScroll: true });
  }

  /**
   * Succès d'une modification (VEND-16) : rien ne change en vitrine avant la validation de l'équipe ; ni ticket à ouvrir
   * (le vendeur a déjà celui de son annonce), ni référence nouvelle (celle de l'annonce en vente).
   */
  function showAmended(listing, reference, pack, ship) {
    const title = h('h3', { class: 'fs-step-title', id: 'fs-propose-done-title', tabindex: '-1', text: t('propose.amended.title') });
    const again = h('button', { type: 'button', class: 'fs-btn fs-btn--lg', 'data-fs-propose-again': true, text: t('propose.done.again') });
    const done = h('section', { class: 'fs-step fs-propose-success', 'aria-labelledby': 'fs-propose-done-title', 'data-fs-propose-done': 'amended' },
      h('figure', { class: 'fs-launch', style: artStyle(pack), 'aria-hidden': 'true' }, ship ? h('img', { class: 'fs-launch-ship', src: ship.url, alt: '', width: ship.width, height: ship.height, style: `--ship-w: ${Math.round(ship.width / 1.5)}px` }) : null),
      h('div', { class: 'fs-done-body' },
        /* Libellé court (une ligne à 360 px) : la référence est celle de l'annonce en vente. */
        h('p', { class: 'fs-label' }, t('propose.amended.label'), reference ? [' · ', h('span', { class: 'fs-done-ref', 'data-fs-done-ref': true, text: reference })] : null),
        title,
        h('p', { class: 'fs-step-lead', text: t('propose.amended.lead') }),
        h('p', { class: 'fs-propose-done-recap' }, h('strong', { text: t('propose.done.recap', { title: listing.title }) })),
        h('ol', { class: 'fs-done-steps', 'data-fs-done-amended': true },
          h('li', { 'data-state': 'current' }, h('strong', { text: t('propose.done.review_title') }), t('propose.amended.review_text')),
          h('li', {}, h('strong', { text: t('propose.done.showcase_title') }), t('propose.amended.showcase_text')),
          h('li', {}, h('strong', { text: t('propose.amended.follow_title') }), t('propose.amended.follow_text'))),
        h('div', { class: 'fs-propose-actions' }, again)));
    again.addEventListener('click', () => { buildForm(); showWelcome(); });
    state.done = done;
    ui.slot.replaceChildren(done);
    state.welcome = null;
    showView('done');
    ui.banners.replaceChildren();
    applyChooser();
    scrollTop(done, true);
    title.focus({ preventScroll: true });
  }

  /* ---- « Corriger et renvoyer » : parcours prérempli depuis une annonce refusée (spec 08 § 5.1, contrat 09 § 9.2) ---- */
  /** Bandeau du haut du bloc (persistant pendant la correction). */
  function correctionBanner(text, actions = []) {
    root.querySelector('[data-fs-propose-banner="correction"]')?.remove();
    const banner = h('div', { class: 'fs-alert fs-propose-banner fs-propose-correction', role: 'status', 'data-fs-propose-banner': 'correction' },
      h('p', {}, ...[].concat(text)), actions.length ? h('div', { class: 'fs-propose-actions' }, actions) : null);
    ui.banners.prepend(banner);
    return banner;
  }
  /** Lien ouvert sans session : la connexion se fait dans une fenêtre, sur un clic du vendeur (jamais d'office). */
  function askCorrectionLogin() {
    const login = h('button', { type: 'button', class: 'fs-btn fs-btn--primary', 'data-fs-correct-login': true }, discordIcon(), t('propose.login.button'));
    login.addEventListener('click', () => startLogin({ origin: login }));
    correctionBanner([h('strong', { text: state.correction?.kind === 'edit' ? t('propose.correction.edit_kicker') : t('propose.correction.fix_kicker') }), t('propose.correction.login_text')], [login]);
  }
  /** Retire « corriger » ou « modifier » de l'adresse une fois lu (le fragment #sell reste). */
  function dropCorrectionParam() {
    dropKeys();
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('resubmit') && !url.searchParams.has('edit')) return;
      url.searchParams.delete('resubmit');
      url.searchParams.delete('edit');
      history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch { /* adresse inchangée */ }
  }
  async function loadCorrection() {
    const ref = state.correction?.ref;
    if (!ref) return;
    if (!token()) { askCorrectionLogin(); return; }
    /* « Modifier » (VEND-16) : contenu en ligne de l'annonce publiée, net en vigueur et clés verrouillées (serveur). */
    const edit = state.correction.kind === 'edit';
    /* Compte qui demande le préremplissage : revérifié après chaque attente et sur « Remplacer » (autre compte : annulé). */
    const owner = currentUser();
    state.correction.user = owner;
    const stillOwner = () => state.correction?.ref === ref && enforceAccount() && currentUser() === owner;
    let response;
    try { response = await call(`/submissions/${encodeURIComponent(ref)}/${edit ? 'edit' : 'draft'}`); } catch { response = { status: 0, body: null }; }
    if (!stillOwner()) return;
    if (response.status === 401) { dropSession(); askCorrectionLogin(); return; }
    const body = response.body;
    if (response.status !== 200 || !body || !games.includes(body.game)) {
      restoreMode();
      dropCorrectionParam();
      const message = edit ? editLoadMessage(response.status, body) : response.status === 0 ? t('propose.correction.no_response') : t('propose.correction.unavailable');
      correctionBanner(message);
      refreshAll();
      return;
    }
    dropCorrectionParam();
    await Promise.all([loadTemplates().catch(() => null), loadImportUi()]);
    if (!stillOwner()) return;
    /* Un seul brouillon : celui d'un autre jeu serait effacé aussi. */
    const [localGame] = Object.entries(state.drafts).find(([, draft]) => !isEmptyDraft(draft)) || [];
    const reference = typeof body.reference === 'string' && /^SITE-[0-9A-F]{8}$/.test(body.reference) ? body.reference : '';
    const apply = () => (!stillOwner() ? null : edit ? applyPrefill(body.game, body, { amends: ref, user: owner, reference, locked: Array.isArray(body.locked) ? body.locked.filter((key) => typeof key === 'string') : [], price: netField(body.expectedNet) })
      : applyPrefill(body.game, body, { replaces: ref, reason: body.reason, targets: body.targets, user: owner }));
    if (localGame) {
      const replace = h('button', { type: 'button', class: 'fs-btn fs-btn--primary', 'data-fs-correct-replace': true, text: t('propose.correction.replace') });
      const keep = h('button', { type: 'button', class: 'fs-btn fs-btn--link', 'data-fs-correct-keep': true, text: t('propose.correction.keep') });
      correctionBanner(t(edit ? 'propose.correction.replace_edit' : 'propose.correction.replace_fix', { game: names[localGame] || localGame }), [replace, keep]);
      replace.addEventListener('click', apply);
      keep.addEventListener('click', () => { if (!enforceAccount()) return; restoreMode(); root.querySelector('[data-fs-propose-banner="correction"]')?.remove(); markCorrection(); refreshAll(); });
      replace.focus({ preventScroll: true });
      return;
    }
    apply();
  }
  /**
   * Point d'entrée du préremplissage : brouillon du jeu remplacé par ces valeurs (captures reprises par identifiant),
   * parcours ouvert à l'étape visée, ou avant elle à la première étape incomplète (annonce envoyée avant que tout soit
   * obligatoire, VEND-04). Avec replaces, l'envoi renvoie l'annonce corrigée (POST /submissions { replaces }) ; avec amends,
   * il envoie la modification de l'annonce en vente (POST /submissions { amends }), prix souhaité en vigueur prérempli.
   */
  function applyPrefill(game, data, { replaces = '', reason = null, targets = [], amends = '', reference = '', locked = [], price = '', user = currentUser(), staff = false } = {}) {
    const template = state.lib?.TEMPLATES[game];
    if (!template) return;
    /* Modification par l'équipe : le parcours repart de la première étape, toutes les étapes déjà atteignables. */
    const step = staff ? FIRST_STEP : correctionStep(template, targets);
    releaseMedia(game);
    /* Brouillon neuf, identifiant neuf : le mode gardé (rechargement) ne vaut que pour lui et pour ce compte. */
    const draft = [...crypto.getRandomValues(new Uint8Array(12))].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    state.drafts[game] = prefilledDraft(game, data, { step, price: amends ? price : '', id: draft });
    state.restored.delete(game);
    state.correction = replaces ? { ref: replaces, pending: false, kind: 'fix', game, reason, targets: Array.isArray(targets) ? targets : [], draft, user }
      : amends ? { ref: amends, pending: false, kind: 'edit', game, reference, locked, targets: [], draft, user }
        : staff ? { ref: '', pending: false, kind: 'admin', game, reference, locked, targets: [], draft, user } : null;
    keepMode();
    if (state.game !== game) selectGame(game, { confirmed: true, view: 'silent' });
    state.form = null;
    buildForm();
    /* Captures déjà jointes à l'annonce en vente (« Modifier », équipe) : vignette donnée par le service, statut pas redemandé
       (POST /submissions/media/status les dirait « déjà utilisées », donc perdues). Sans vignette, comme avant. */
    if (amends || staff) {
      for (const item of Array.isArray(data.media) ? data.media : []) {
        const entry = mediaOf(item?.slot);
        const preview = typeof item?.previewUrl === 'string' && safeUrl(item.previewUrl) ? item.previewUrl : '';
        if (!entry || entry.id !== item.id || !preview) continue;
        Object.assign(entry, { described: true, url: preview });
      }
      Object.keys(shotViews).forEach(renderShot);
    }
    markCorrection();
    const all = validationErrors();
    const incomplete = steps().find((entry) => !FINAL_STEPS.includes(entry.id) && Object.keys(stepErrors(entry.id, all)).length)?.id;
    saveDrafts();
    go(incomplete && indexOf(incomplete) < indexOf(step) ? incomplete : step, { dir: 'forward', replace: true });
    describeRestored();
  }
  /** Bandeau « Correction demandée » et éléments visés surlignés (« À corriger »), étapes signalées sur la piste. */
  function markCorrection() {
    const correction = state.correction;
    if (!correction || correction.pending || correction.game !== state.game) return;
    if (correction.kind === 'admin') {
      /* Variante : modification directe, proposition relue, ou reprise d'une annonce venue de Discord (takeoverNew, takeover). */
      const variant = ['takeoverNew', 'takeover'].includes(admin?.variant) ? admin.variant : admin?.mode === 'review' ? 'review' : 'direct';
      correctionBanner([h('strong', { text: admin.text[`${variant}Title`] }), correction.reference ? ` · ${correction.reference}` : '', `. ${admin.text[`${variant}Text`]}`,
        typeof admin.note === 'string' && admin.note ? ` ${admin.note}` : '']);
      lockFields();
      return;
    }
    if (correction.kind === 'edit') {
      correctionBanner([h('strong', { text: t('propose.correction.edit_title') }), ` · ${correction.reference ? t('propose.correction.edit_text_ref', { ref: correction.reference }) : t('propose.correction.edit_text')}`]);
      lockFields();
      return;
    }
    const reason = correction.reason && typeof correction.reason === 'object' ? correction.reason : {};
    const label = typeof reason.label === 'string' ? reason.label : '';
    const text = typeof reason.text === 'string' ? reason.text : '';
    /* Motif, texte et conseil : rédigés par l'équipe (espace équipe en français), affichés tels que reçus. */
    correctionBanner([h('strong', { text: t('propose.correction.requested') }), label ? ` · ${label}.` : '.', text ? ` ${text}` : '',
      typeof reason.advice === 'string' && reason.advice ? ` ${reason.advice}` : '']);
    const template = state.lib.TEMPLATES[state.game];
    for (const target of correction.targets) {
      const keys = target === 'title' || target === 'tags' ? [target]
        : target.startsWith('slot:') ? [`shot-${target.slice(5)}`]
          : (template.sections.find((entry) => entry.id === target.slice(8))?.fields || []).map((field) => field.key);
      for (const key of keys) {
        const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
        if (!block || block.hasAttribute('data-fs-target')) continue;
        block.setAttribute('data-fs-target', '');
        (block.querySelector('.fs-shot-title, .fs-propose-label, legend, label') || block).append(h('span', { class: 'fs-badge fs-target-badge', text: t('propose.correction.badge') }));
        const step = key === 'title' || key === 'tags' ? 'titre' : key.startsWith('shot-') ? stepOfSlot(state.game, key.slice(5)) : stepOfKey(state.game, key);
        if (step) state.errorSteps.add(step);
      }
    }
    renderRail();
  }

  /**
   * Clés verrouillées d'une modification (`locked`, VEND-16 : le serveur, dont dépend le forum Discord) : affichées, jamais
   * modifiables. Le contrôle reste dans le formulaire (sa valeur part avec l'envoi) mais devient inerte ; une note le dit.
   */
  function lockFields() {
    const correction = state.correction;
    if (!['edit', 'admin'].includes(correction?.kind) || !state.form) return;
    for (const key of correction.locked) {
      const block = state.form.querySelector(`[data-fs-field="${CSS.escape(key)}"]`);
      if (!block || block.hasAttribute('data-fs-locked')) continue;
      block.setAttribute('data-fs-locked', '');
      for (const part of block.children) if (!part.classList.contains('fs-field-head')) part.inert = true;
      block.append(h('p', { class: 'fs-field-hint fs-propose-locked', 'data-fs-locked-note': true, text: t('propose.correction.locked') }));
    }
  }

  /* ---- modification par l'équipe depuis la fiche (admin) ---- */
  /** Bloc de l'étape du prix : fourni par la fiche (net vendeur, commission, aperçu du service), sinon une phrase. */
  function adminPriceBlock() {
    return state.adminPrice?.node || h('p', { class: 'fs-propose-fine', text: admin.text.priceUnavailable });
  }
  /** « Vérifier » : ce qui change, le motif obligatoire et la ligne d'état de l'enregistrement. */
  function adminSaveBlocks() {
    const id = 'fs-propose-f-adminReason';
    const reason = h('textarea', { class: 'fs-input fs-textarea fs-admin-reason', id, name: 'fs-admin-reason', rows: '3', maxlength: '300', autocomplete: 'off',
      placeholder: admin.text.reasonPlaceholder, 'aria-required': 'true', 'aria-describedby': `${id}-hint` });
    return h('section', { class: 'fs-admin-save', 'aria-labelledby': 'fs-admin-save-title', 'data-fs-admin-save-block': true },
      h('h4', { class: 'fs-step-group-title', id: 'fs-admin-save-title', text: admin.text.changesTitle }),
      h('ul', { class: 'fs-admin-changes', 'data-fs-admin-changes': true }),
      h('div', { class: 'fs-form-grid' }, h('div', { class: 'fs-field fs-propose-field fs-w-pleine fs-size-l', 'data-fs-field': 'adminReason' },
        h('p', { class: 'fs-field-head' }, h('label', { class: 'fs-field-label fs-propose-label', for: id },
          h('span', { class: 'fs-propose-label-text' }, h('span', { class: 'fs-propose-label-name', text: admin.text.reasonLabel }), requiredMark()))),
        fieldCtl(reason),
        fieldMsg(errorLine(id), hintLine(id, admin.text[admin.mode === 'review' ? 'reasonHintReview' : 'reasonHintDirect'])))),
      h('p', { class: 'fs-propose-status', role: 'status', 'data-fs-admin-status': true }));
  }
  /** Contenu comparable (titre, étiquettes, valeurs publiées, captures publiques par emplacement) : rien n'est envoyé. */
  function adminSnapshot() {
    const listing = previewListing(state.lib, template(), readInput());
    const media = Object.entries(state.media[state.game] || {}).filter(([slot, entry]) => isPublic(slotDef(slot)) && !['empty', 'lost'].includes(entry.state))
      .map(([slot, entry]) => `${slot}:${entry.id || 'new'}`).sort();
    return { title: listing.title, tags: [...listing.tags].sort(), values: listing.values, media };
  }
  /** Éléments changés depuis l'ouverture (noms des champs, jamais leurs valeurs), prix compris. */
  function adminChanges() {
    const before = state.adminBaseline;
    if (!before || !state.form) return [];
    const after = adminSnapshot();
    const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
    const keys = [...new Set([...Object.keys(before.values), ...Object.keys(after.values)])];
    const price = state.adminPrice?.change?.();
    return [...(before.title !== after.title ? [labelOf('title')] : []), ...(same(before.tags, after.tags) ? [] : [labelOf('tags')]),
      ...keys.filter((key) => !same(before.values[key], after.values[key])).map(labelOf),
      ...(same(before.media, after.media) ? [] : [t('propose.fields.media')]),
      ...(price && price.kind !== 'none' ? [price.label] : [])];
  }
  const adminContentChanged = () => {
    const before = state.adminBaseline;
    if (!before) return true;
    const after = adminSnapshot();
    return JSON.stringify(before) !== JSON.stringify(after);
  };
  /* Première reprise d'une annonce venue de Discord : le formulaire s'enregistre même si le préremplissage est gardé tel quel. */
  const adminTakeoverNew = () => admin?.variant === 'takeoverNew';
  const adminContentToSend = () => adminTakeoverNew() || adminContentChanged();
  function renderAdminChanges(node) {
    const list = node.querySelector('[data-fs-admin-changes]');
    if (!list) return;
    const changes = [...(adminTakeoverNew() ? [admin.text.takeoverChange] : []), ...adminChanges()];
    list.replaceChildren(...(changes.length ? changes.map((label) => h('li', { text: label })) : [h('li', { class: 'fs-admin-changes-none', text: admin.text.noChange })]));
  }
  let adminIntent = null;
  /** Même demande (contenu et motif inchangés) après une réponse incertaine : même identifiant, aucun doublon côté service. */
  function adminRequestId(fingerprint) {
    if (adminIntent?.fingerprint === fingerprint) return adminIntent.id;
    adminIntent = { fingerprint, id: `edit-${[...crypto.getRandomValues(new Uint8Array(12))].map((byte) => byte.toString(16).padStart(2, '0')).join('')}` };
    return adminIntent.id;
  }
  /**
   * Enregistrement : annonce complète, motif, captures envoyées une à une, puis le contenu (POST …/edit) s'il a changé et le
   * prix (bloc de la fiche, POST …/price) s'il a changé. Erreurs par champ ramenées à leur étape ; succès : onSaved.
   */
  async function adminSend() {
    if (state.busy) return;
    const node = stepNode('verifier');
    const status = node.querySelector('[data-fs-admin-status]');
    const button = node.querySelector('[data-fs-admin-save]');
    const label = button.querySelector('[data-fs-admin-save-label]');
    const idle = label.textContent;
    status.textContent = '';
    if (!listingReady()) return;
    const reasonBox = node.querySelector('[name="fs-admin-reason"]');
    const reason = reasonBox.value.trim();
    const reasonProblem = admin.reasonError(reason);
    setError('adminReason', reasonProblem);
    if (reasonProblem) { focusOn(reasonBox); return; }
    const priceErrors = state.adminPrice?.errors?.() ?? {};
    if (Object.keys(priceErrors).length) { go(PRICE_STEP, { dir: 'back', editing: true }); showStepErrors(PRICE_STEP, priceErrors, '', { focusField: true }); return; }
    if (!token()) { status.textContent = admin.text.noSession; return; }
    const priceChange = state.adminPrice?.change?.() ?? null;
    const priced = Boolean(priceChange && priceChange.kind !== 'none');
    if (!adminContentToSend() && !priced) { status.textContent = admin.text.unchanged; return; }
    state.busy = true;
    admin.onBusy?.(true);
    state.form.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    let content = null;
    try {
      await pump();
      const queue = Object.entries(state.media[state.game] || {}).filter(([, entry]) => entry.state === 'ready' && entry.blob && !entry.id);
      for (const [index, [slot, entry]] of queue.entries()) {
        /* Fenêtre fermée pendant l'attente (déconnexion, autre compte) : plus rien n'est envoyé, ni capture ni modification. */
        if (detached()) return;
        label.textContent = admin.text.uploading(index + 1, queue.length);
        await uploadOne(slot, entry);
      }
      if (detached()) return;
      const failed = Object.entries(state.media[state.game] || {}).filter(([slot, entry]) => isPublic(slotDef(slot)) && entry.state === 'error');
      if (failed.length && !degraded()) { status.textContent = admin.text.failedShots(failed.length); goToField(`shot-${failed[0][0]}`); return; }
      if (adminContentToSend()) {
        label.textContent = admin.text[admin.mode === 'review' ? 'proposing' : 'saving'];
        const tpl = template();
        const listing = checkSubmission(state.lib, tpl, readInput());
        const media = degraded() ? [] : Object.entries(state.media[state.game] || {}).filter(([slot, entry]) => isPublic(slotDef(slot)) && entry.state === 'sent' && entry.id).map(([slot, entry]) => ({ slot, id: entry.id }));
        if (typeof state.lib.validateMedia === 'function') state.lib.validateMedia(tpl, media);
        const exact = readInput({ exact: true }).values;
        const rounded = fieldsOf(tpl).filter((field) => roundable(field) && listing.values[field.key] !== undefined && String(listing.values[field.key]) !== String(exact[field.key])).map((field) => field.key);
        /* Captures éteintes : `media` omis, celles de l'annonce restent (jamais une liste vide qui les retirerait). */
        const payload = { version: state.adminVersion, ...state.adminVersions, title: listing.title, tags: listing.tags, values: listing.values, ...(degraded() ? {} : { media }), rounded, reason };
        payload.requestId = adminRequestId(JSON.stringify(payload));
        const body = JSON.stringify(payload);
        if (new TextEncoder().encode(body).length > MAX_BODY) { status.textContent = admin.text.tooLarge; return; }
        if (detached()) return;
        const response = await call(`/admin/listings/${encodeURIComponent(admin.handle)}/edit`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }).catch(() => ({ status: 0, body: null }));
        if (response.status === 0 || response.status >= 500) { status.textContent = admin.errorText(0, { error: 'operation_uncertain' }); return; }
        if (response.status !== 200 && response.status !== 202) {
          if (response.status === 422 && response.body?.errors && typeof response.body.errors === 'object') {
            const mediaErrors = Array.isArray(response.body.mediaErrors) ? response.body.mediaErrors : [];
            for (const { index, code } of mediaErrors) {
              const item = media[index];
              const entry = item && mediaOf(item.slot);
              if (!entry) continue;
              entry.id = null;
              if (code === 'disabled') state.mediaInfo.enabled = false;
              else if (entry.blob) Object.assign(entry, { state: 'error', error: state.mediaLib?.mediaErrorText(code) || t('propose.shot.expired') });
              else setMedia(item.slot, { state: 'lost' });
            }
            refreshAll();
            const placed = Object.fromEntries(Object.entries(response.body.errors).map(([key, value]) => (key === 'media' && mediaErrors[0] && media[mediaErrors[0].index] ? [`shot-${media[mediaErrors[0].index].slot}`, value] : [key, value])));
            state.errorSteps = new Set(Object.keys(placed).map((key) => (key.startsWith('shot-') ? stepOfSlot(state.game, key.slice(5)) : stepOfKey(state.game, key))).filter(Boolean));
            renderRail();
            showStepErrors('verifier', placed, admin.errorText(422, { error: 'invalid' }));
            return;
          }
          if (response.body?.error === 'reason_required') { setError('adminReason', admin.reasonError('')); focusOn(reasonBox); }
          status.textContent = admin.errorText(response.status, response.body);
          if (response.status < 500) adminIntent = null;
          return;
        }
        content = response.body ?? {};
        adminIntent = null;
      }
      let price = null;
      if (priced && !detached()) {
        label.textContent = admin.text.saving;
        price = await state.adminPrice.save({ reason });
        /* Prix refusé sans contenu enregistré : rien n'a changé, le message reste ici. */
        if (!price?.ok && !content) { status.textContent = price?.message || admin.errorText(0, null); return; }
      }
      if (content || price) admin.onSaved?.({ content, price });
    } catch (error) {
      if (error?.errors) { go('verifier', { dir: 'back' }); showStepErrors('verifier', error.errors); }
      else status.textContent = admin.errorText(0, null);
    } finally {
      state.busy = false;
      admin.onBusy?.(false);
      state.form?.removeAttribute('aria-busy');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      if (button.isConnected) label.textContent = idle;
    }
  }
  /**
   * Ouverture (fenêtre déjà visible) : `data` de GET /admin/listings/:handle/edit (annonce du site modifiable), `price` :
   * bloc du prix de la fiche ({ node, errors(), summary(), change(), save() }) ou null. Rend vrai si le parcours est prêt.
   */
  async function adminLoad(data, price = null) {
    state.session = readSession();
    if (!token()) { showStatus(admin.text.noSession); return false; }
    state.adminPrice = price;
    state.prices = Boolean(price?.node);
    /* Reprise d'une annonce Discord : mode sans captures dès la construction (aucune capture obligatoire, aucun envoi). */
    if (admin.captures === false) state.mediaInfo = { enabled: false, remaining: null };
    showStatus(t('propose.loading.form'));
    try { await Promise.all([loadTemplates(), loadImportUi()]); } catch { showStatus(t('propose.loading.failed')); return false; }
    if (!games.includes(data?.game) || !state.lib.TEMPLATES[data.game]) { showStatus(t('propose.loading.unavailable_game')); return false; }
    showStatus('');
    const reference = typeof data.reference === 'string' ? data.reference.slice(0, 40) : '';
    applyPrefill(data.game, data, { staff: true, reference, locked: Array.isArray(data.locked) ? data.locked.filter((key) => typeof key === 'string') : [], user: currentUser() });
    if (!state.form) return false;
    steps().forEach((entry) => state.visited.add(entry.id));
    renderRail();
    state.adminVersion = String(data.version ?? '');
    /* Annonce venue de Discord : versions de l'annonce (sourceVersion) et du registre de contrôle (listingVersion), renvoyées telles quelles. */
    state.adminVersions = { ...(typeof data.sourceVersion === 'string' ? { sourceVersion: data.sourceVersion } : {}), ...(Number.isSafeInteger(data.listingVersion) ? { listingVersion: data.listingVersion } : {}) };
    state.adminBaseline = adminSnapshot();
    await loggedIn();
    return true;
  }

  /* ---- raccourci de l'accueil DarkOrbit : AccInsight (décision 035) si le service l'ouvre, sinon T-Ware
     (décision 010) s'il est ouvert ---- */
  async function mountTware() {
    const slotNode = state.welcome?.querySelector('[data-fs-tware-slot]');
    if (!slotNode || !state.importUi?.TWARE_GAMES?.includes(state.game) || !token()) return;
    const open = async (path) => {
      try {
        const response = await call(path);
        return response.status === 200 && response.body?.enabled === true;
      } catch { return false; }
    };
    const source = state.importUi.ACCINSIGHT_GAMES?.includes(state.game) && await open('/imports/accinsight') ? 'accinsight' : await open('/imports/tware') ? 'tware' : null;
    if (!source || !slotNode.isConnected || state.panel) return;
    state.panel = state.importUi.mountImportPanel({
      container: slotNode, sources: [source], game: () => state.game, gameName: (game) => names[game] || game,
      templateOf: (game) => (games.includes(game) ? state.lib?.TEMPLATES[game] ?? null : null), guard: guardImport,
      screenshotUrl: `${service}/imports/screenshot`, token, probe: false,
      icon: (kind) => iconImage(packOf(state.game)?.icons[kind === 'tware' || kind === 'accinsight' ? 'rank' : 'experience'], 32),
      /* Attestation AccInsight : jointe à la soumission de ce jeu (lien DOStats et propriété pour l'équipe, résumé des bans). */
      onCheck: ({ attestation }) => { state.accountCheck = attestation ? { game: state.game, attestation } : null; },
      onImport: (item, { source } = {}) => { applyImported(item, source); go(steps()[0]?.id ?? FIRST_STEP, { dir: 'forward' }); },
      onManual: () => {}, onAuthExpired: (message) => { dropSession(); showAuthError(message); refreshAll(); },
    });
  }
  /** Import AccInsight ou T-Ware : mêmes règles que la lecture d'une capture (champs vides seulement, valeurs surlignées).
      AccInsight seulement (propriété prouvée, lecture exacte) : ses valeurs ne sont plus relues, masquées (syncImported). */
  function applyImported(item, source) {
    const fields = fieldMap();
    const current = readInput({ exact: true }).values;
    for (const [key, value] of Object.entries(item.values || {})) {
      const field = fields.get(key);
      if (!field || current[key] !== undefined) continue;
      if (field.type === 'multichoice') state.form.querySelectorAll(`input[name="f-${CSS.escape(key)}"]`).forEach((box) => { box.checked = value.includes(box.value); });
      else setControl(field, value);
      markRead(key, 'tool');
      if (source === 'accinsight') state.imported.add(key);
    }
    syncConditional();
    saveSoon();
    refreshDerived();
  }

  /* ---- appels à l'action « Proposer une annonce » ---- */
  const goTo = (game, trigger) => {
    const dialog = trigger?.closest?.('dialog');
    if (dialog?.open) { dialog.dataset.fsCloseReason = 'propose'; dialog.close(); }
    if (games.includes(game) && game !== state.game) selectGame(game);
    else if (!state.game) { state.chooser = true; showView('chooser'); applyChooser(); }
    section?.scrollIntoView({ block: 'start', behavior: motion(Boolean(trigger)) });
    section?.querySelector('#fs-propose-title')?.focus({ preventScroll: true });
  };
  if (!admin) document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-fs-propose-open]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const current = demo.getAttribute?.('data-fs-universe');
    goTo(trigger.getAttribute('data-fs-propose-open') || trigger.getAttribute('data-fs-propose-game') || (games.includes(current) ? current : ''), trigger);
  });
  /* Clavier virtuel ouvert (spec 5.7) : la barre d'actions redevient statique pour ne pas couvrir le champ actif. */
  window.visualViewport?.addEventListener('resize', () => {
    const open = window.visualViewport.height < window.innerHeight * 0.6;
    root.querySelectorAll('.fs-step-foot').forEach((foot) => { if (open) foot.dataset.kb = 'open'; else delete foot.dataset.kb; });
  });

  /* ---- démarrage ---- */
  root.hidden = false;
  /* Modification par l'équipe : rien d'autre au démarrage ; la fiche ouvre la fenêtre puis appelle load(data, price). */
  if (admin) {
    state.chooser = false;
    /* Modèles et import, attendus par load() : demandés dès maintenant, pendant que la fiche prépare le prix. */
    loadTemplates().catch(() => {});
    loadImportUi();
    applyGame();
    applyChooser();
    /* Fenêtre fermée (bloc retiré de la page) : l'écouteur se retire, aucun appel pour un parcours qui n'est plus affiché. */
    const onAccount = () => {
      if (detached()) { document.removeEventListener('fs:account', onAccount); return; }
      const next = account.session();
      if (!next && state.session) { dropSession(); state.loggedToken = ''; showStatus(admin.text.noSession); }
      else if (next && next.token !== state.loggedToken) loggedIn();
    };
    if (account) document.addEventListener('fs:account', onAccount);
    /* dirty() : vrai si quelque chose a changé depuis l'ouverture (fermeture confirmée) ; busy() : enregistrement en cours. */
    return { load: adminLoad, dirty: () => adminChanges().length > 0, busy: () => state.busy };
  }
  showAuthError(authError);
  applyGame();
  applyChooser();
  showView('chooser');
  /* Retour de Discord (redirection) : reprise à l'étape du brouillon ; sinon l'accueil du jeu, sans défilement ni focus. */
  /* Brouillon d'un autre jeu que ?game= : le bandeau de reprise propose [Reprendre A] [Commencer B], rien n'est effacé sans clic. */
  if (initialGame && games.includes(requested) && requested !== initialGame && !backFromLogin) state.otherGame = requested;
  if (initialGame) selectGame(initialGame, { view: backFromLogin && savedDrafts.game === initialGame && state.drafts[initialGame]?.step ? 'resume' : 'silent' });

  if (fragment.code) exchange(fragment.code, nonce);
  else if (returning) {
    const here = !returning.intent || returning.intent.kind === 'propose';
    returning.promise.then((outcome) => {
      returnPending = false;
      if (!outcome.ok) state.afterLogin = null;
      if (outcome.ok) loggedIn({ fresh: here });
      else if (here) showAuthError(!outcome.error || outcome.error === 'expired' || outcome.error === 'exchange_refused' ? t('propose.common.login_expired') : outcome.error === 'exchange_failed' ? t('propose.common.discord_failed') : authErrorMessage(outcome.error));
      refreshAll();
      if (here) requestAnimationFrame(() => land(null));
    });
  } else if (state.session) loggedIn();
  if (account) document.addEventListener('fs:account', () => {
    const next = account.session();
    if (!next && state.session) { dropSession(); state.loggedToken = ''; refreshAll(); }
    else if (next && next.token !== state.loggedToken && !state.pendingLogin && !returnPending) loggedIn();
  });
  if (state.correction?.pending && !state.session && !fragment.code && !returning) askCorrectionLogin();
  if (fragment.present && !fragment.code) announce({ ok: false, error: fragment.error || 'expired' });
  if (fragment.present && !forTicket) requestAnimationFrame(() => land(null));
  if (importLink) showNote(UNSUPPORTED_LINK);
}

/**
 * Modification d'une annonce par l'équipe depuis sa fiche (fs-listing-admin.js) : `root` est un bloc du parcours
 * [data-fs-propose] inséré dans la fenêtre modale APRÈS le chargement de ce module (jamais repris par le démarrage
 * ci-dessous). Rend { load(data, price) }, ou null si le bloc est déjà monté ou sans service.
 */
export function mountListingEditor(root, options) {
  if (!options?.handle || !['direct', 'review'].includes(options.mode) || !options.text || typeof options.errorText !== 'function' || typeof options.reasonError !== 'function') return null;
  return initialise(root, { admin: options });
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-fs-propose]').forEach((root) => initialise(root));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-fs-propose]').forEach((root) => initialise(root)));
}
